import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
} from '@angular/core';
declare function CallTrack_function(page,RepName,ProductName,terms, usage500, usageObj1000, usage2000, zipcode, utility_name,enrollmentStatus,Email): void;
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import * as _ from 'underscore';
import { RecommendationService } from '../../recommendation/recommendation.service';
import * as $ from 'jquery';
import { states } from '../../../../../assets/js/states';
import { ResidentialService } from '../../residential.service';
import { UserSettingsService } from 'src/app/user-settings/user-settings.service';
import { Subject } from 'rxjs/internal/Subject';
import 'rxjs/add/operator/takeUntil';
import {
  IMyDpOptions,
  IMyDate,
  IMyDateModel,
  IMyInputFieldChanged,
  IMyCalendarViewChanged,
  IMyDefaultMonth,
} from 'mydatepicker';
import { DatePipe } from '@angular/common';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import {NgbModal, NgbActiveModal, NgbModule, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';


import { NgxSpinnerService } from 'ngx-spinner';
import {
  ScrollToService,
  ScrollToConfigOptions,
} from '@nicky-lenaers/ngx-scroll-to';
import * as moment from 'moment-timezone';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
} from '@angular/animations';
@Component({
  selector: 'app-enrollment',
  templateUrl: './enrollment.component.html',
  styleUrls: ['./enrollment.component.css', '../signup-order.component.css'],
  providers: [DatePipe],
  animations: [
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' })),
      ]),
    ]),
  ],
})
export class EnrollmentComponent implements OnInit {
  @ViewChild('appPhoneNumber', { static: true }) inputEl: ElementRef;
  @ViewChild('newEnergyRates', { static: true }) newEnergyRates: ElementRef;
  @ViewChild('f', { static: true }) form: ElementRef;
  @Output() invoiceBack: EventEmitter<any> = new EventEmitter();
  @ViewChild('depositPending', { static: true }) depositPending: ElementRef;
  @ViewChild('errorStatus4CE', { static: true }) errorStatus4CE: ElementRef;
  tduRates;
  EnrollmentProcess = false;
  first_name;
  last_name;
  phone_num;
  first_name1;
  tempfirstName;
  templastName;
  last_name1;
  email_address1;
  isvalidEmail = true;
  MobilephoneNoError = false
  howdidButton;
  phone_num1 = '';
  dob;
  email_address;
  accountoption = 'Yes';
  hearusOption;
  language = '';
  represnt;
  promo_code;
  ssn = '';
  license;
  select;
  showHear = false;
  showSSN = false;
  ssnmsg = false
  state = 'TX';
  disableBtn = true;
  disableBtnm = false;
  disableBtnmm = false;
  goPaperlessGexa_error = false;
  ngClass = false;
  ngClass1 = false;
  energy_provider;
  agreeBox = false;
  // API Url
  url = environment.api_url;
  statesArr = Object.keys(states);
  deviceWidth;
  modalRef: BsModalRef;
  languages = ['English', 'Spanish'];
  primaryAccountoptions = ['Yes', 'No'];

  // To show the section for mobile view
  showInvoice = false;
  showSec1 = false;
  showSec2 = false;
  showSecPart = true;
  minAge;
  maxAge;
  changedFormatPhone;
  @Input() esiid_value: any;
  enrollNotifyObj;
  queryObj = {
    _id: '',
    esiid: '',
    hg_orders_id: '',
    hg_accountId: '',
  };
  updateObj = {};
  maximumYear;
  latestMonth;
  clickedOnce = false;
  lastnameChange = false;
  emailChange = false;
  phoneChange = false;
  firstnameChange = false;
  disabledhowdid = false;
  disabledpromo = false;
  userResponses;
  public myDatePickerOptions: IMyDpOptions;
  public defaultMonth: IMyDefaultMonth;
  // To Unsubscribe the multiple events
  private unsubscribe = new Subject<void>();
  invoice;
  selectedProduct;
  providerContact;
  agreeBox1;
  disableBtnEnery;
  agreeBox2;
  agreeBox3;
  display = 'none';
  checkValidity = false;
  getSessionData = true;
  ordersInfo;
  sec2Disable = false;
  // @ViewChild('conf_email') conf_email : ElementRef;
  private regex: RegExp = new RegExp(/^\d*\.?\d{0,4}$/g);
  showConf_email = false;
  validContact = false;
  showMask = true;
  user_bot = false;
  ssn12 = '';
  ssn123 = '';
  newVal = '';
  email_address_temp;
  enablesmshonest = true;
  enablesmschariot = true;
  disabled = true;
  ssnvalidation = false;
  orderDetails: any;
  accountOptionFlag = false;
  energyPostObject: any;
  hgAccountId: any;
  serviceTypeDate: any;
  pulsePowerPostResult: any;
  securityDeposit: any;
  securityDepositText: string;
  referrals = [
    'Google',
    'Yahoo',
    'Facebook',
    'Instagram',
    'Twitter',
    'Real estate agent',
    'Leasing agent',
    'Apartment community',
    'Postcard flyer',
    'Yelp',
    'Email marketing',
    'Friend',
    'Word of mouth',
    'Other',
    'None of the above',
  ];
  invoices = ['Paper', 'Paperless', 'Both'];
  redirectionLink: any;
  accountOptionMessage: string;
  btnEnable = true;
  ssnInvalid = true;
  depositRequired4CE: boolean;
  depositAmount4CE: any;
  autoPay4CE: boolean;
  switchModel;
  dobinvalid = false;
  invoiceInvalid = false;
  howdidInvalid = false
  ssnInvalidmsg = false;
  formValid = false;
  checkBoxText1: string;
  checkBoxText2: string;
  agreeBox4: any;
  ldcIds: string;
  invoiceText: string;
  errorText = '';
  private postResultNavigation = {
    PendingDeposit: this.postResultDepositAPI.bind(this),
    Completed: this.postResultCompletedAPI.bind(this),
    PendingCreditCheck: this.postResultCreditCheckAPI.bind(this),
    PendingIdentityVerification:
      this.postResultIdentifyVerificationAPI.bind(this),
    PendingVerification: this.postResultVerificationAPI.bind(this),
  };
  private loadEnergyProvidersPostObject = {
    ChariotEnergy: this.createChariotEnergyPostObject.bind(this),
    PulsePower: this.createShellEnergyPostObject.bind(this),
    NewPowerTexas: this.createShellEnergyPostObject.bind(this),
    ChangeEnergy4CE: this.create4ChangeEnergyPostObject.bind(this),
    GexaEnergy: this.createGEXAEnergyPostObject.bind(this),
    FrontierUtilities: this.createGEXAEnergyPostObject.bind(this),
    TexpoEnergy: this.createTexpoEnergyPostObject.bind(this),
    RhythmEnergy: this.createRhythmEnergyPostObject.bind(this),
    BKVEnergy: this.createBKVEnergyPostObject.bind(this),
    APGEEnergy: this.createAPGEEnergyPostObject.bind(this),
    ShellEnergy: this.createShellEnergyPostObject.bind(this),
  };
  private saveEnergyProviders = {
    ChariotEnergy: this.saveChariotEnergyAPI.bind(this),
    PulsePower: this.saveShellEnergyAPI.bind(this),
    NewPowerTexas: this.saveShellEnergyAPI.bind(this),
    ChangeEnergy4CE: this.save4ChangeEnergyAPI.bind(this),
    GexaEnergy: this.saveGEXAEnergyAPI.bind(this),
    FrontierUtilities: this.saveGEXAEnergyAPI.bind(this),
    TexpoEnergy: this.saveTexpoEnergyAPI.bind(this),
    RhythmEnergy: this.saveRhythmEnergyAPI.bind(this),
    BKVEnergy: this.saveBKVEnergyAPI.bind(this),
    APGEEnergy: this.saveAPGEEnergyAPI.bind(this),
    ShellEnergy: this.saveShellEnergyAPI.bind(this),
  };
  private readonly messageType = {
    info: 'enrollment-Completed',
    info0: 'enrollment-started-step0',
    info1: 'enrollment-retrivedsessiondata-step1',
    info2: 'enrollment-questionStatusObj-step2',
    info3: 'enrollment-PostObject-step3',
    info4: 'enrollment-saveorderapi-step4',
    error: 'enrollment -catch nextfun-error',
  };
  private orderDetailsUtilityName = {
    AEPC: 'AEP Texas Central',
    AEPN: 'AEP Texas North',
    CenterPoint: 'CenterPoint Energy',
    Oncor: 'Oncor',
  };
  private invoiceDetails = {
    Paperless: 'Email',
    Paper: 'Mail',
    Both: 'Email and Mail',
  };

  private BKVinvoiceDetails = {
    Paperless: 'E-Bill',
    Paper: 'Paper Billing',
    Both: 'Paper Billing',
  };

  private APGEinvoiceDetails = {
    Paperless: 'Email',
    Paper: 'Mail',
    Both: 'Electronic/Paper',
  };

  private ChariotReversinvoiceDetails = {
    Email: 'Paperless',
    Mail: 'Paper',
    Paperless: 'Paperless',
    Paper: 'Paper',

  };
  private utilityName = {
    TNMP: 'Texas New Mexico Power',
    CenterPoint: 'Centerpoint',
    AEPC: 'AEP Texas Central',
    AEPN: 'AEP Texas North',
    Oncor: 'Oncor',
    LPL: 'Lubbock Power and Light'
  };
  private loadServiceTypeObject = {
    NewService: this.assignServiceTypeValuesForNewService.bind(this),
    SwitchingProviders:
      this.assignServiceTypeValuesForStandardSwitch.bind(this),
  };
  private loadCreditCheckDetails = {
    Pass: this.postApi4CEEnrollCustomerAPI.bind(this),
    Fail: this.checkBeginCustomerSuccessWithDepositResponse.bind(this),
  };
  private loadGEXAEnergyUtilityNames = {
    AEPC: 'AEP_CENT',
    AEPN: 'AEP_NORTH',
    TNMP: 'TNMP',
    CenterPoint: 'CNP',
    Oncor: 'ONCOR_ELEC',
  };
  private postGEXAResultNavigation = {
    DepositNeeded: this.postResultGEXADepositAPI.bind(this),
    Success: this.postResultGEXACompletedAPI.bind(this),
    Others: this.  openGEXAErrorTemplate.bind(this),
    FreezeAlert: this.postGEXAResultCreditCheckAPI.bind(this),
  };
  GEXAEnergyPostResult: any;
  private energyProvidersDepositCallBack = {
    PulsePower: this.openPulsePowerDepositURL.bind(this),
    NewPowerTexas: this.openPulsePowerDepositURL.bind(this),
    GexaEnergy: this.openGEXADepositURL.bind(this),
    FrontierUtilities: this.openGEXADepositURL.bind(this),
  };
  private loadTduCodeDetails = {
    AEPC: 'ER_AEPTCC',
    AEPN: 'ER_AEPTNC',
    TNMP: 'ER_TNMPOWR',
    CenterPoint: 'ER_CENTERP',
    Oncor: 'ER_ONCOR',
  };
  private loadInvoiceText = {
    GexaEnergy:
      'I agree to receive paperless contract-related notices by email, including my contract expiration notice',
    FrontierUtilities:
      'I agree to receive paperless contract-related notices by email, including my contract expiration notice',
    ChariotEnergy:
      'How would you like to receive future invoices and contract related notices?',
    PulsePower:
      'How would you like to receive future invoices and contract related notices?',
    NewPowerTexas:
      'How would you like to receive future invoices and contract related notices?',
    ChangeEnergy4CE:
      'How would you like to receive future invoices and contract related notices?',
    BKVEnergy:
      'How would you like to receive future invoices and contract related notices?',
    APGEEnergy:
      'How would you like to receive future invoices and contract related notices?',
    RhythmEnergy:
      'How would you like to receive future invoices and contract related notices?',
    ShellEnergy:
      'How would you like to receive future invoices and contract related notices?',
  };
  depositWebUrlGexaFrontier: any;
  goPaperlessGexa = true;
  placeholderText = 'MM/DD/YYYY';
  maxDate;
  navigatorBrowser: string;
  payDepositChecked: boolean;

  ngbModalOptions: NgbModalOptions = {
    backdrop : 'static',
    keyboard : false
  };
  ShowAPIErrorMsg = false;
  APIErrorMsg;

  closeDeposit: boolean;
  constructor(
    private recommendationService: RecommendationService,
    private residentialService: ResidentialService,
    private http: HttpClient,
    private router: Router,
    private activeRouter: ActivatedRoute,
    private userSettingsService: UserSettingsService,
    private datepipe: DatePipe,
    private modalService: BsModalService,
    private ref: ChangeDetectorRef,
    private spinner: NgxSpinnerService,
    private _scrollToService: ScrollToService
  ) {}

  ngOnInit() {
    this.deviceWidth = window.innerWidth;
    if(this.deviceWidth < 786 )
    {
      this.selectLangMbl('English', 'englishId')
      this.selectaccountMbl('No', 'noId')
      this.selectaccountMbl('Yes', 'yesId')

    }
    this.language = "English";
    sessionStorage.setItem('percentage',JSON.stringify(100));
    this.navigatorBrowser = this.residentialService.myBrowser();
    const hg_accountId = window.location.href.split('/').pop();
    this.assignDateObjects();
    this.assignRecommendedSelectedProduct(hg_accountId);
    this.getState(this.state);
    this.assignUserResponseToSession();
    this.setSelectedProductStyles();
    this.getProviderInfo();

    this.assignPromoCode();
    this.setShowService();
    this.setPrimaryAccountInfo();
    this.residentialService.loadScriptFiles(
      '../../../../../assets/js/custom.js'
    );
    this.setCurrentMessage();
    //this.getOrders(hg_accountId);
    this.keyEventForPhone();
    this.setCheckBoxValues();
    this.invoices = this.getIndexOfInvoiceValue(this.invoices);
    this.invoiceText = this.loadInvoiceText[this.actualEnergyProviderName()];
    const ldcIds = JSON.parse(sessionStorage.getItem('tduRates'));
    if (ldcIds == undefined) {
      this.getTduRatesForAllUtilityNames();
    }

    if(this.deviceWidth < 786 )
    {
      this.selectaccountMbl('No', 'noId')
      this.selectaccountMbl('Yes', 'yesId')

    }

    var af = sessionStorage.getItem('_Affiliate') == undefined || sessionStorage.getItem('_Affiliate') == '' || sessionStorage.getItem('_Affiliate') == null? "" : sessionStorage.getItem('_Affiliate')
    var p = sessionStorage.getItem('_Promo') == undefined || sessionStorage.getItem('_Promo') == '' || sessionStorage.getItem('_Promo') == null? "" : sessionStorage.getItem('_Promo');
    if(af != "" && p != "")
    {
      
      this.referrals.push(sessionStorage.getItem('_Affiliate'))    
      this.hearusOption = sessionStorage.getItem('_Affiliate')
      this.disabledhowdid = true
      this.disabledpromo = true;

      if(this.deviceWidth < 786 )
      {
        this.sec2Disable = true;
        this.howdidButton = true;
  
      }
   

    }
    else if (af != "")
    {
      this.referrals.push(sessionStorage.getItem('_Affiliate'))    
      this.hearusOption = sessionStorage.getItem('_Affiliate')
      this.disabledhowdid = true

      if(this.deviceWidth < 786 )
      {
        //this.sec2Disable = true;
        //this.howdidButton = true;
  
      }
    }
    else if (p != "")
    {
      
      this.disabledpromo = true;

      if(this.deviceWidth < 786 )
      {
        //this.sec2Disable = true;
        //this.howdidButton = true;
  
      }
    }
    
 
  }

  getIndexOfInvoiceValue(itemValue) {
    if (
      this.selectedProduct.energy_provider === 'Gexa Energy' ||
      this.selectedProduct.energy_provider === 'Frontier Utilities' || this.selectedProduct.energy_provider === "BKV Energy"
    ) {
      itemValue.splice(itemValue.indexOf('Both'), 1);
    }
    return itemValue;
  }

  setCheckBoxValues() {
    this.checkBoxText1 =
      this.selectedProduct.energy_provider === '4Change Energy'
        ? 'I agree to the <a href="https://www.4changeenergy.com/Docs/4Change-EZPay-Terms-Conditions.pdf" target="_blank">EZ Pay terms and conditions</a> and consent to receive a copy of those terms electronically.'
        : 'By checking this box, you affirm that you understand and agree to all of the above';
    this.checkBoxText2 =
      this.selectedProduct.energy_provider === '4Change Energy'
        ? 'I authorize 4Change Energy to act as my agent to perform the tasks necessary to switch, establish, or change my electric service to 4Change Energy. I have read, understand, and accept my Plan Documents (EFL, TOSA, and YRAC), and the <a href="https://www.4changeenergy.com/Docs/4CE_enrollment-disclosures_06-2016.pdf" target="_blank">Enrollment Disclosure and Consent</a>'
        : this.selectedProduct.energy_provider === 'Gexa Energy' ||
          this.selectedProduct.energy_provider === 'Frontier Utilities'
        ? `By checking this box, you affirm that you authorize ${this.selectedProduct.energy_provider} to act as your agent in order to perform the neccesary tasks to establish my electricity service account and, if required, to switch me from my current REP and instruct my current REP to perform the necesary tasks in order to make this change.`
        : `By checking this box, you affirm that you wish to select <font class="providerClr">${this.selectedProduct.energy_provider}</font> as your REP and that you designate <font class="providerClr">${this.selectedProduct.energy_provider}</font> to perform the tasks necessary to begin your service.`;
  }

  ngAfterViewInit(): void {
    if (this.disableBtn === false) {
      var disclick = document.getElementById('buttondisclick');
      // if (disclick != undefined && disclick != null)
      //   disclick.classList.remove('clickable');
    }
    const phone = document.getElementById('phone_mob');
    if (
      this.phone_num === undefined ||
      this.phone_num === null ||
      this.phone_num === '' ||
      this.phone_num.length < 12
    ) {
      this.validContact = false;
      phone.classList.add('langColorpink');
    } else {
      phone.classList.remove('langColorpink');
    }

    const fName = document.getElementById('fName');

    if (
      this.first_name === undefined ||
      this.first_name === null ||
      this.first_name === ''
    ) {
      fName.classList.add('langColorpink');
    } else {
      fName.classList.remove('langColorpink');
    }

    const lName = document.getElementById('lName');

    if (
      this.last_name === undefined ||
      this.last_name === null ||
      this.last_name === ''
    ) {
      this.validContact = false;
      lName.classList.add('langColorpink');
    } else {
      lName.classList.remove('langColorpink');
    }
    if (
      this.accountoption === undefined ||
      this.accountoption === null ||
      this.accountoption === ''
    ) {
    } else {
    }
    const email_mob = document.getElementById('email_mob');
    if (
      this.email_address === undefined ||
      this.email_address === null ||
      this.email_address === ''
    ) {
      email_mob.classList.add('langColorpink');
    } else {
      email_mob.classList.remove('langColorpink');
    }
    const mob_dob = document.getElementById('mob_dob');
    if (this.dob === undefined || this.dob === null || this.dob === '') {
    } else {
    }

    this.checkValidity = true;
    this.ref.detach();
    setInterval(() => {
      if (!this.ref['destroyed']) {
        this.ref.detectChanges();
      }
    }, 0);
  }

  keyEventForPhone() {
    $('#phone').keypress(function (e) {
      if (e.which !== 8 && e.which !== 0 && (e.which < 48 || e.which > 57)) {
        return false;
      }
    });
  }
  assignPromoCode() {
    this.disabled = false;
    var promo = sessionStorage.getItem('_Promo') == undefined || sessionStorage.getItem('_Promo') == '' || sessionStorage.getItem('_Promo') == null? "" : sessionStorage.getItem('_Promo')
    if (this.residentialService.promoCode) {
      if(this.residentialService.promoCode != null && this.residentialService.promoCode != '' && this.residentialService.promoCode != undefined)
      {
        if(promo != this.residentialService.promoCode)
        {
            this.promo_code = this.residentialService.promoCode;
        }else
        {
        if(promo != '')
        {
            this.promo_code = promo;
            this.residentialService.promoCode = promo
        }
        }
        
      }else
      {
        
        if(promo != '')
        {
            this.promo_code = promo;
            this.residentialService.promoCode = promo
        }
      }
      
      
    } else {
      this.disabled = false;

      if(promo != '')
      {
          this.promo_code = promo;
          this.residentialService.promoCode = promo
      }
      else
      {
        this.promo_code = '';
      }

     
    }
     if( this.promo_code == '')
     {
        this.disabled = false;
     }
  }

  getOrders(hg_accountId) {
    const reqParam = new HttpParams()
      .append('hg_accountId', hg_accountId)
      .append('esiid', localStorage.getItem('currentEsiid'));

    this.http
      .get(this.url + '/getOrders', { params: reqParam })
      .subscribe((res: any) => {
        const response = res;
        this.ordersInfo = response;
        if (response && !_.isEmpty(response.contactInfo)) {
          this.first_name = response.contactInfo.legalFirstName;
          this.last_name = response.contactInfo.legalLastName;
          this.email_address = this.email_address_temp
            ? this.email_address_temp
            : response.contactInfo.emailId;
          this.phone_num1 = this.formatPhoneNumber(
            response.contactInfo.phoneNo
          );
          this.language = response.contactInfo.language
            ? response.contactInfo.language
                .split(' ')
                .map((wrd) => {
                  return (
                    wrd.charAt(0).toUpperCase() + wrd.substr(1).toLowerCase()
                  );
                })
                .join(' ')
            : 'English';
          this.dob = response.contactInfo.dob;
          this.represnt = response.contactInfo.authorizedRep
            ? response.contactInfo.authorizedRep
            : this.represnt;
        } else {
          if (!_.isEmpty(JSON.parse(sessionStorage.getItem('userObj')))) {
            const contactInfo = JSON.parse(sessionStorage.getItem('userObj'));
            this.first_name = contactInfo.fName ? contactInfo.fName : '';
            this.last_name = contactInfo.lName ? contactInfo.lName : '';
            this.email_address = this.email_address_temp
              ? this.email_address_temp
              : contactInfo.emailId
              ? contactInfo.emailId
              : '';
            this.phone_num1 = this.formatPhoneNumber(
              contactInfo.phone ? contactInfo.phone : ''
            );
            this.language = 'English';
          }
        }

        if (window.innerWidth < 768) {
          this.setLanguageClassListPerDeviceWidth();
          this.validateMobileFields();
          const languagePreference =
            document.getElementById('languagePreference');
          if (this.language !== '' || this.language !== undefined)
            languagePreference.classList.remove('validateClass');
        }


      
        // if (response && !_.isEmpty(response.invoiceType)) {
        //   this.invoice = response.invoiceType
        //     ? response.invoiceType
        //     : this.invoice;
        // }
      
      if (response && !_.isEmpty(response.promoDetails)) {
        // this.hearusOption = response.promoDetails.hearusOption
        //   ? response.promoDetails.hearusOption
        //   : this.hearusOption;
      }
        if (response && !_.isEmpty(response.privateDetails)) {
          this.state = this.state;
          this.ssn = response.privateDetails.ssn
            ? response.privateDetails.ssn
            : this.ssn;
          this.license = response.privateDetails.license
            ? response.privateDetails.license
            : this.license;
        }
      });
  }

  formatPhoneNumber(phoneNo: string): string {
    if (phoneNo) {
      return phoneNo.match(/-/g)
        ? phoneNo
        : `${phoneNo.slice(0, 3)}-${phoneNo.slice(3, 6)}-${phoneNo.slice(6)}`;
    }
  }

  setCurrentMessage() {
    this.recommendationService.currentMessage.subscribe((message) => {
      if (!_.isEmpty(message)) {
        if (message['agreeBox']) {
          this.agreeBox = false;
          this.invoiceBack.emit({ agreeBoxes: this.agreeBox });
          this.checkValidity = true;
          this.ngClass = true;
          this.disableBtn = false;
        }
      }
    });
  }
  setShowService() {
    this.residentialService.setShowService.subscribe((data) => {
      if (data.showEnrollmentComp && _.isEmpty(this.accountoption)) {
        this.showConf_email = true;
        let x =
          window.innerWidth < 768
            ? document.getElementById('conf_email_mob')
            : document.getElementById('conf_email');
        x.focus();

        if (!this.ref['destroyed']) {
          this.ref.detectChanges();
        }
      }
    });
  }

  setSelectedProductStyles() {
    if (this.selectedProduct.energy_provider == 'Texans Energy') {
      this.ngClass = true;
      this.disableBtnm = true;
    } else {
      this.ngClass = true;
      this.disableBtnm = false;
    }
  }

  setPrimaryAccountInfo() {
    if (this.deviceWidth < 768) {
      const invoice21 = document.getElementById('noId');
      invoice21.classList.add('langColorpink1');
    }
  }
  assignRecommendedSelectedProduct(hg_accountId) {
    if (_.isEmpty(this.recommendationService.signupProduct)) {
      this.recommendationService.signupProduct = JSON.parse(
        sessionStorage.getItem('signupProduct')
      );
    }
    this.selectedProduct = this.recommendationService.signupProduct;
    this.saveRecommendedSelectedProduct(hg_accountId);
  }

  assignDateObjects() {
    let today = new Date();
    this.minAge = new Date(
      today.getFullYear() - 18,
      today.getMonth(),
      today.getDate()
    );
    this.maxAge = new Date(
      today.getFullYear() - 100,
      today.getMonth(),
      today.getDate()
    );
    this.maximumYear = new Date().getFullYear() - 18;
    this.latestMonth = this.datepipe.transform(new Date(), 'MM');
    this.defaultMonth = { defMonth: this.latestMonth + '/' + this.maximumYear };
    const maxDate = new Date().setDate(new Date().getFullYear() - 18);

    // var month = (new Date().getMonth() + 1).toString();
    // month = month.length == 1 ? "0" + month : month + "";

    // this.maxDate = `${this.maximumYear}-${
    //   month
    // }-${new Date().getDate()}`;
    // this.maxDate = new Date(this.maxDate);
    this.maxDate = new Date(this.maximumYear , new Date().getMonth() , new Date().getDate());
    // this.myDatePickerOptions = {
    //   dateFormat: 'mm/dd/yyyy',
    //   firstDayOfWeek: 'su',
    //   // disableWeekends: true,
    //   disableSince: {
    //     year: this.maximumYear,
    //     month: new Date().getMonth() + 1,
    //     day: today.getDate(),
    //   },
    //   editableDateField: false,
    //   showClearDateBtn: false,
    //   selectorHeight: '100%',
    //   selectorWidth: '100%',
    //   sunHighlight: false,
    //   openSelectorOnInputClick: true,
    // };
  }

  getProviderInfo() {
    this.residentialService
      .getProviderContactInfoDetails(
        this.selectedProduct.energy_provider,
        this.selectedProduct.utility_name
      )
      .subscribe((res: any) => {
        this.providerContact = res[0];
      });
  }

  public triggerScrollTo(destination) {
    const config: ScrollToConfigOptions = {
      target: destination,
      duration: 50,
      easing: 'easeOutElastic',
    };
    //this._scrollToService.scrollTo(config);

    // $([document.documentElement, document.body]).animate({
    //   scrollTop: $("#" + destination.id).offset().top
    // }, 2000);

   
    setTimeout(() => {
      $("#" + destination.id)[0].scrollIntoView();
    }, 500);

  }
  public triggerScrollToTop() {
    
    window.scrollTo(0, 0);
    // Option 1: Smooth scroll using scrollIntoView
    // setTimeout(() => {
    //   window.scrollTo({
    //     top: 0,
    //     behavior: 'smooth'
    //   });
    // }, 500);
  
    // Option 2: jQuery (uncomment if needed)
    // setTimeout(() => {
    //   $([document.documentElement, document.body]).animate({
    //     scrollTop: 0
    //   }, 2000);
    // }, 500);
  }

  getAccept(event) {}
  pad(number) {
    return (number < 10 ? '0' : '') + number;
  }

  AllowClick()
  {
    this.clickedOnce = true;
    this.firstnameChange = true;
    this.lastnameChange = true;
    this.emailChange = true;
    this.phoneChange = true;

  }
  showAcceptances(formValid) {
    this.clickedOnce = true;
    this.firstnameChange = true;
    this.lastnameChange = true;
    this.emailChange = true;
    this.phoneChange = true;
    //this.assignUserResponseToSession();
    if (this.checkAccountRepresentative()) 
      return;
    
    this.formFieldsValidation(formValid);
    if (this.selectedProduct.energy_provider === '4Change Energy')
      this.getTduIdForAllUtilityNames(this.selectedProduct.utility_name);

    if($("#div1234")[0] != undefined)
    {
     
        setTimeout(() => {
          $("#div1234")[0].scrollIntoView();
        }, 1100);
    }
 
      

  }

  checkAccount() {
    if (
      this.accountoption === 'Yes' ||
      (this.accountoption === 'No' && this.represnt !== '')
    ) {
      return true;
    } else if (
      this.accountoption === 'No' &&
      (this.represnt === '' || this.represnt === undefined)
    ) {
      return false;
    }
  }

  formFieldsValidation(formValid) {
    if (this.ssn.length >= 11 && formValid === true) {
      formValid = true;
      this.btnEnable = false;
      if (formValid && this.ssnvalidation === false)
        this.residentialService.validateHGAccountID(
          this.recommendationService.hg_accountId
        )
          ? this.submitOrderProductDetails(formValid)
          : this.checkSSNValidation(formValid);
    } else {
      if (this.ssn.length <= 10) {
        this.ssnInvalid = false;
      }
      this.disableBtn = true;
      this.ngClass = false;
    }
  }

  checkAccountRepresentative() {
    if (
      this.accountoption === 'No' &&
      (this.represnt === undefined || this.represnt === '')
    ) {
      this.ngClass = false;
      this.disableBtn = true;
      this.accountOptionFlag = true;
      this.accountOptionMessage = 'Enter Authorized Representative details';
    } else {
      this.ngClass = true;
      this.disableBtn = false;
      this.accountOptionFlag = false;
    }
    return this.accountOptionFlag;
  }

  representativeValid(event) {
    if (event.target.value) {
      this.accountOptionFlag = false;
      this.accountOptionMessage = '';
    }
  }

  submitOrderProductDetails(formValid) {
    const signUpProduct =
      this.recommendationService.signupProduct !== undefined
        ? this.recommendationService.signupProduct
        : JSON.parse(sessionStorage.getItem('signupProduct'));
    const energyProviderName = signUpProduct.energy_provider,
      utilityName = signUpProduct.utility_name,
      planName = signUpProduct.product_key,
      productID = signUpProduct.ProductID;

    this.residentialService
      .getEnergyProvidersPlanStatus(energyProviderName, utilityName, planName)
      .subscribe(
        (res: any) => {
          if (
            res.length > 0 &&
            productID !== res[0].ProductID &&
            this.residentialService.validateCreatedDateTime(res[0].createdDate)
          ) {
            this.assignNewEnergyProvidersRates();
          } else {
            this.checkSSNValidation(formValid);
          }
        },
        (err) => {
          this.checkSSNValidation(formValid);
        }
      );

      this.onChangeSaveAbondonedOrder(event);
  }

  checkSSNValidation(formValid) {
    this.agreeBox = true;

    if(this.deviceWidth > 786)
    {
      this.triggerScrollToTop()
    }

    this.invoiceBack.emit({ agreeBoxes: this.agreeBox });
    this.checkValidity = false;

    // SSN Validation
    const hg_accountId = window.location.href.split('/').pop();
    if (formValid && this.ssn === '444-44-4444') {
      this.router.navigate(['ssn-check', hg_accountId]);
    }
  }

  toggleShowPassword(password) {
    this.user_bot = !this.user_bot;
    this.ssn = password;
  }
  toggleShowPassword1(password) {
    this.user_bot = !this.user_bot;
    this.ssn = password;
  }

  onKeyPress(event: KeyboardEvent) {
    this.phoneChange = true;
    if (event['key'] == null) {
      return;
    }
    let current: string = this.inputEl.nativeElement.value;
    let next: string = current;
    let nextWithout = next.replace(new RegExp('-', 'g'), '');
    if (nextWithout && !String(nextWithout).match(this.regex)) {
      this.phone_num1 = '';
      event.preventDefault();
    } else {
      if (next.length == 3) {
        this.phone_num1 = next + '-' + event['key'];
        event.preventDefault();
      } else if (next.length == 7) {
        this.phone_num1 = next + '-' + event['key'];
        event.preventDefault();
      }
    }
  }

  onKeyPressMobile(event: KeyboardEvent) {
    this.phoneChange = true;
    if (event['data'] == null) {
      return;
    }
    let current: string = this.inputEl.nativeElement.value;
    let next: string = current;
    let nextWithout = next.replace(new RegExp('-', 'g'), '');
    if (nextWithout && !String(nextWithout).match(this.regex)) {
      this.phone_num1 = '';
      event.preventDefault();
    } else {
      if (next.length == 3) {
        this.phone_num1 = next + '-' 
        event.preventDefault();
      } else if (next.length == 7) {
        this.phone_num1 = next + '-'
        event.preventDefault();
      }
    }
  }

  onKeyPressEmail(event) { 
    this.emailChange = true;
    if (event['data'] == null) {
      return;
    }
    this.email_address_temp = event.target.value;
  }

  Emailvalidate(event) {
    this.isvalidEmail = true


    var validEmailRegEx =
    /^[A-Z0-9_'%=+!`#~$*?^{}&|-]+([\.][A-Z0-9_'%=+!`#~$*?^{}&|-]+)*@[A-Z0-9-]+(\.[A-Z0-9-]+)+$/i;
    var isEmailValid1 = validEmailRegEx.test(event.target.value);
    if (isEmailValid1 === false && event.target.value != "") {
      //alert('Please Enter Valid Email');
      this.isvalidEmail = false
    }


  }

  onKeyPressfname(event) {
    this.firstnameChange = true
    if (event['data'] == null) {
      return;
    }
    this.tempfirstName = event.target.value;
  }

  SaveFailedOrder(reason) {
   
    this.SaveAbondonedOrder(true, reason);
  }
  
  onChangeSaveAbondonedOrder(event) {
   
    this.SaveAbondonedOrder();
  }
  getpromo(event) {
    this.onChangeSaveAbondonedOrder(event);
    if (event['data'] == null) {
      return;
    }
    this.promo_code = event.target.value;
    this.residentialService.promoCode = this.promo_code;
    
  }

  onKeyPresslastname(event) {
    this.lastnameChange = true;
    if (event['data'] == null) {
      return;
    }
    this.templastName = event.target.value;
  }

  onKeyPressConfirmEmail(event) {
    this.accountoption = event.target.value;
    this.email_address_temp = this.email_address_temp
      ? this.email_address_temp
      : this.email_address;
  }

  onKeyPress1(event: KeyboardEvent) {
    this.showMask = !this.showMask;

    if (!_.isEmpty(this.ssn)) {
      this.ngClass = true;
      this.disableBtn = false;
    } else {
      this.ngClass = false;
      this.disableBtn = true;
    }
  }

  onPaste(event) {
    this.phoneChange = true;
    let next = event.clipboardData.getData('Text');
    let ph_val = next.replace(/\D[^\.]/g, '');
    let phone =
      ph_val.slice(0, 3) + '-' + ph_val.slice(3, 6) + '-' + ph_val.slice(6);
      this.phone_num1 = phone;
    event.preventDefault();
  }

  mailMe(
    mail // <--- element on which you need to apply click
  ) {
    mail = document.createElement('a');
    mail.href = 'mailto:hello@honestgorilla.com?subject=Question&body=Hi';
    mail.click();
  }

  next(event, form, formValid) {
    try {
      console.log('clicked')
      if(!this.EnrollmentProcess)
      {
        this.EnrollmentProcess = true;
        const hg_accountId = window.location.href.split('/').pop();
        // To get the service type values
        let serviceType, startDate, switchType, moveInType, expiredDate;
        this.logPostCreatedData('info0');
        
        if (!_.isEmpty(JSON.parse(sessionStorage.getItem('userResponse'))) && JSON.parse(sessionStorage.getItem('userResponse')) != null)
        {
    
            const responses =
            sessionStorage.getItem('userResponseUpdated') !== ''
              ? JSON.parse(sessionStorage.getItem('userResponseUpdated'))
                  .userResponses
              : JSON.parse(sessionStorage.getItem('userResponse')).userResponses;
          this.logPostCreatedData('info1', responses);
          this.userResponses = responses;
          this.residentialService.userResponse['userResponses'] =
            this.userResponses;

        }



        if (!_.isEmpty(JSON.parse(sessionStorage.getItem('userObj')))) {
          const contactInfo1 = JSON.parse(sessionStorage.getItem('userObj'));
          this.first_name1 = contactInfo1.fName;
          this.last_name1 = contactInfo1.lName;
          this.email_address1 = contactInfo1.emailId;
          this.phone_num = contactInfo1.phone;
        }
        this.orderDetails = {
          order_no: null,
          hg_accountId: hg_accountId,
          serviceTypeDetails: this.getServiceTypeValues(),
          contactInfo: {
            legalFirstName:
              this.tempfirstName !== undefined
                ? this.tempfirstName
                : this.first_name,
            legalLastName:
              this.templastName !== undefined
                ? this.templastName
                : this.last_name,
            emailId:
              this.email_address_temp !== undefined
                ? this.email_address_temp
                : this.email_address,
            phoneNo: this.phone_num1 ? this.phone_num1 : this.phone_num,
            language: this.language,
            dob: this.dob,
            authorizedRep: this.represnt,
          },
          invoiceType: this.invoice,
          promoDetails: {
            hearusOption: this.hearusOption,
            promoeCode: this.promo_code,
          },
          privateDetails: {
            state: this.state,
            ssn: this.ssn123,
            license: this.license,
          },
          billingAddress: JSON.parse(sessionStorage.getItem('billingAddress')),
          isExpired: false,
          expirationDate: null,
          Affiliate: sessionStorage.getItem('_Affiliate') == undefined || sessionStorage.getItem('_Affiliate') == '' || sessionStorage.getItem('_Affiliate') == null? "" : sessionStorage.getItem('_Affiliate'),
          AffiliatePromo: sessionStorage.getItem('_Promo') == undefined || sessionStorage.getItem('_Promo') == '' || sessionStorage.getItem('_Promo') == null? "" : sessionStorage.getItem('_Promo'),
          AffiliateID: sessionStorage.getItem('_AffiliateID') == undefined || sessionStorage.getItem('_AffiliateID') == '' || sessionStorage.getItem('_AffiliateID') == null? "" : sessionStorage.getItem('_AffiliateID'),
          QuestionId: sessionStorage.getItem('QuestionUserID') == undefined || sessionStorage.getItem('QuestionUserID') == '' || sessionStorage.getItem('QuestionUserID') == null? "" : sessionStorage.getItem('QuestionUserID')
        };
        sessionStorage.setItem(
          'customerName',
          `${this.orderDetails.contactInfo.legalFirstName} ${this.orderDetails.contactInfo.legalLastName}`
        );
        // this.validateEsiidValue(this.orderDetails);
        this.orderDetails['selectedProduct'] = this.getSignupProduct();
        expiredDate = new Date();
        let term = this.recommendationService.signupProduct.terms;
        expiredDate.setMonth(expiredDate.getMonth() + term);
        this.orderDetails.expirationDate = expiredDate;
        if (formValid && this.esiid_value) {
          if (_.isEmpty(this.residentialService['user'])) {
            this.residentialService['user'] = {
              accountId: '',
            };
            this.residentialService['user']['accountId'] = hg_accountId;
            this.residentialService.questionnaireStatusObj = JSON.parse(
              sessionStorage.getItem('questionStatusObj')
            );
          }
          // this.residentialService.esiid = this.esiid_value;
          this.residentialService['user']['accountId'] = hg_accountId;
          this.orderDetails.billingAddress = JSON.parse(
            sessionStorage.getItem('billingAddress')
          );
          var line11, line12, line13;
          let serviceAddressDetails =
            this.orderDetails.billingAddress.userAddress; //line12
          let serviceAddress_apartment =
            this.orderDetails.billingAddress.apartment;
          let billingAddressDetails;
          let billingAddress_apartment;
          var mailingAddress;
          if (
            this.orderDetails.billingAddress.sameAsService === false &&
            this.orderDetails.billingAddress
          ) {
            billingAddressDetails =
              this.orderDetails.billingAddress.billingAddress.billingAddress;
            billingAddress_apartment =
              this.orderDetails.billingAddress.billingAddress.apartment;
          } else {
            billingAddressDetails = this.orderDetails.billingAddress.userAddress;
            billingAddress_apartment = this.orderDetails.billingAddress.apartment;
          }
          this.logPostCreatedData(
            'info2',
            sessionStorage.getItem('questionStatusObj')
          );
          const responses1 = JSON.parse(sessionStorage.getItem('userResponse'));
          sessionStorage.setItem(
            'enablesmshonest',
            this.enablesmshonest === false ? 'No' : 'Yes'
          );
          var tempPromocode = 'GORILLA';
          this.hgAccountId = hg_accountId;          
          this.energyPostObject =
            this.loadEnergyProvidersPostObject[this.actualEnergyProviderName()]();
          this.residentialService.enrollmentPostObject = JSON.stringify(
            this.energyPostObject
          );
          this.logPostCreatedData('info3', JSON.stringify(this.energyPostObject));
          this.saveEnergyProvidersForEnrollments();
        } else {
          this.ngClass = false;
          this.disableBtn = true;
          this.EnrollmentProcess = false;
        }
      }
    } catch (err) {
      this.logPostCreatedData('error', err.message);
      this.EnrollmentProcess = false;
    }
    this.logPostCreatedData('info');    
  }

  actualEnergyProviderName() {
    return this.selectedProduct.energy_provider === '4Change Energy'
      ? 'ChangeEnergy4CE'
      : this.selectedProduct.energy_provider.replace(/\s/g, '');
  }

  saveRecommendedSelectedProduct(hg_accountId) {
    const hgAccountId = { hg_accountId: hg_accountId };
    this.residentialService
      .postSelectedProductAPI({ ...this.selectedProduct, ...hgAccountId })
      .subscribe((res: any) => {});
  }
 
  saveEnergyProvidersForEnrollments() {
    this.residentialService.updateResponsesOnly().subscribe((response) => {
      const result = response;
      if (result) {
        this.ngClass = true;
        this.disableBtn = false;
        this.orderDetails.billingAddress = JSON.parse(
          sessionStorage.getItem('billingAddress')
        );
        this.logPostCreatedData('info4');
        this.openModal();
        this.saveEnergyProviders[this.actualEnergyProviderName()]();
      }
    });
  }

  postResultDepositAPI() {
    this.sendMessagesAfterPulseEnrollment();
    this.assignOrderDetailsForPulse();
    this.saveEnrollmentOrderDetailsForPendingDeposit();
    this.securityDeposit = `$${this.pulsePowerPostResult.DepositAmount}`;
    this.securityDepositText = `Pay the ${this.securityDeposit} deposit now`;
    const template: ElementRef<any> = this.depositPending;

    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-small' }, this.ngbModalOptions)
      
    );
  }


  // CreditCheckPopupForChariot() {
  //   this.sendMessagesAfterPulseEnrollment();
  //   this.assignOrderDetailsForPulse();
  //   this.saveEnrollmentOrderDetailsForPendingDeposit();
  //   this.securityDeposit = `$${this.pulsePowerPostResult.DepositAmount}`;
  //   this.securityDepositText = `Pay the ${this.securityDeposit} deposit now`;
  //   const template: ElementRef<any> = this;
  //   this.modalRef = this.modalService.show(
  //     template,
  //     Object.assign({}, { class: 'gray modal-small' })
  //   );
  // }


  postResultCompletedAPI() {
    this.redirectionLink = 'congrats';
    this.postPulsePowerOrderDetailsAPI();
  }

  postResultCreditCheckAPI() {
    this.redirectionLink = 'service-denied';
    this.postPulsePowerOrderDetailsAPI();
  }

  postResultIdentifyVerificationAPI() {
    this.redirectionLink = 'congrats';
    this.postPulsePowerOrderDetailsAPI();
  }

  postResultVerificationAPI() {
    this.redirectionLink = 'congrats';
    this.postPulsePowerOrderDetailsAPI();
  }

  openDepositPendingModal() {
    if (this.providerContact.ProviderName === 'Chariot Energy' || this.providerContact.ProviderName === 'BKV Energy' ) {
      var componentName = this.providerContact.ProviderName === 'BKV Energy' ? 'depositrequiredbkv' : 'depositrequired'
      this.router.navigate([
        componentName,
        this.recommendationService.hg_accountId,
      ]);
      this.modalRef.hide();
    } else {
      const energyDepositObj =
        this.energyProvidersDepositCallBack[
          this.providerContact.ProviderName.replace(/\s/g, '')
        ]();
      const selectDeposit = document.getElementById('selectDeposit');
      selectDeposit.classList.add('deposit-select');
      this.payDepositChecked = true;
      this.residentialService
        .saveDepositPendingStatus(energyDepositObj.depositObj)
        .subscribe((res: any) => {});
      sessionStorage.setItem(
        'orderDetails',
        JSON.stringify(this.recommendationService.enrollmentOrderDetails)
      );
      if (
        this.selectedProduct.energy_provider === 'Gexa Energy' ||
        this.selectedProduct.energy_provider === 'Frontier Utilities'
      ) {
        // window.open(energyDepositObj.webURL);
        // this.postResultGEXACompletedAPI();
         this.modalRef.hide();

        this.saveGEXAEnergyAPI(energyDepositObj.depositObj.depositStatus.TransactionID)
      }
      else if( 
        this.selectedProduct.energy_provider === 'Pulse Power' ||
        this.selectedProduct.energy_provider === 'New Power Texas'


      )
      {
        window.open(energyDepositObj.webURL);
        this.redirectionLink = 'congrats';
        this.saveEnrollmentOrderDetails()
        this.modalRef.hide();



      } 
      else window.location.href = energyDepositObj.webURL;
    }
  }

  openPulsePowerDepositURL() {
    const depositCallBackURL = this.pulsePowerPostResult.DepositPayment,
      confirmationNumber = this.pulsePowerPostResult.ConfirmationNumber,
      callBackURL = encodeURIComponent(
        `${environment.api_url}/user-settings/${this.hgAccountId}`
      ),
      webURL = `${depositCallBackURL}&callback=${callBackURL}`;
    const hgAccountId = { hgAccountId: this.hgAccountId };
    const userObj = {
      depositStatus: {
        ...this.pulsePowerPostResult,
        ...hgAccountId,
      },
    };
    return { webURL: webURL, depositObj: userObj };
  }

  openGEXADepositURL() {
    const hgAccountId = { hgAccountId: this.hgAccountId };
    const depositObj = {
      ConfirmationNumber: this.GEXAEnergyPostResult.AccountNumber,
      ConfirmationStatus: this.GEXAEnergyPostResult.RequestMessage,
      DepositAmount: this.GEXAEnergyPostResult.DepositAmount,
      DepositPayment: this.GEXAEnergyPostResult.PaymentLink,
      ConfirmationStatusMessage: this.GEXAEnergyPostResult.RequestMessage,
      ConfirmationStatusCode: this.GEXAEnergyPostResult.RequestStatus,
      PendingRenewalAccountNumber: '',
      PendingRenewalZipCode: '',
      PendingRenewalURL: '',
      Status: this.GEXAEnergyPostResult.RequestMessage,
      DepositNeeded: this.GEXAEnergyPostResult.DepositNeeded,
      Has_Outstanding_Balance:
        this.GEXAEnergyPostResult.Has_Outstanding_Balance,
      TransactionID: this.GEXAEnergyPostResult.TransactionID,
      VendorTransactionID: this.GEXAEnergyPostResult.VendorTransactionID,
      Version: this.GEXAEnergyPostResult.Version,
    };
    return {
      webURL: this.GEXAEnergyPostResult.PaymentLink,
      depositObj: {
        depositStatus: {
          ...depositObj,
          ...hgAccountId,
        },
      },
    };
  }

  postGEXAResultCreditCheckAPI() {
    this.router.navigate([
      'service-denied',
      this.recommendationService.hg_accountId,
    ]);
  }


  closeDepositPendingModal() {

    this.closeDeposit = true;
    const selectDeposit = document.getElementById('anotherProvider');
    selectDeposit.classList.add('deposit-select');
   
    
    this.modalRef.hide();
    this.router.navigate([
      'recommendation/compare-product',
      this.recommendationService.hg_accountId,
    ]);


  }

  selectNewProvider() {
    this.closeDeposit = true;
    const selectDeposit = document.getElementById('anotherProvider');
    selectDeposit.classList.add('deposit-select');
    sessionStorage.removeItem("selectedEnergyProvider");


    var ProductTypeSelectList = [];
    ProductTypeSelectList.push("Prepaid")
    sessionStorage.setItem(
      'selectedProductType',
      JSON.stringify(ProductTypeSelectList)
    );

    
    var Term = [];
    Term.push("Compare")
    sessionStorage.setItem(
      'selectedProviderData',
      JSON.stringify(Term)
    );

    
    this.modalRef.hide();
    this.router.navigate([
      'recommendation/compare-product',
      this.recommendationService.hg_accountId,
    ]);
  }

  saveChariotEnergyAPI() {
    const user = {
      orderDetails: this.orderDetails,
      postObject: this.energyPostObject,
      energyProvider: this.orderDetails['selectedProduct'].energy_provider,
      apiURL: '',
    };
    this.residentialService.completeCustomerEnrollmentPostObject = user;
    this.residentialService.postApiOfEnrollment(user).subscribe((res: any) => {
      this.EnrollmentProcess = false;
      this.residentialService.enrollmentPostResult = JSON.parse(res);
      const result = this.residentialService.enrollmentPostResult;

      this.TrackFunction(result.Status + ": " + result.Message);
      // this.selectedProduct.
      // result && result.Message.indexOf('PlanId not Found') >= 0
      //   ? this.setEnergyProvidersPlanFailed()
      //   : result.Status.indexOf('CreditCheck Failed') >= 0
      //   ? this.navigateCreditCheckFailure(result.Message)
      //   : result.Status.indexOf('Validation Failed') >= 0
      //   ? this.openChariotrrorTemplate(result.Message)
      //   : result.Message.indexOf('Required Deposite Fields') >= 0
      //   ? this.postChariotDeposit(result.DepositAmount)
      //   : this.postChariotEnergyResult(result);

        if (result && result.Message.indexOf('PlanId not Found') >= 0) {
          this.residentialService.SendFailedEnrollment(this.orderDetails, result,result).subscribe((res: any) => {});
          this.SaveFailedOrder(result.Message);
          this.setEnergyProvidersPlanFailed();
        } else if (result.Status.indexOf('CreditCheck Failed') >= 0) {
          this.residentialService.SendFailedEnrollment(this.orderDetails, result,result).subscribe((res: any) => {});
          this.SaveFailedOrder(result.Message);
          this.navigateCreditCheckFailure(result.Message);
        } else if (result.Status.indexOf('Validation Failed') >= 0) {
          this.residentialService.SendFailedEnrollment(this.orderDetails, result,result).subscribe((res: any) => {});
          this.SaveFailedOrder(result.Message);
          this.openChariotrrorTemplate(result.Message);
        } else if (result.Message.indexOf('Required Deposite Fields') >= 0) {
          this.postChariotDeposit(result.DepositAmount);
        } else {
          this.postChariotEnergyResult(result);
        }
    });
  }

    saveBKVEnergyAPI() {
        
        const user = {
            orderDetails: this.orderDetails,
            postObject: this.energyPostObject,
            energyProvider: this.orderDetails['selectedProduct'].energy_provider,
            apiURL: '',
        };
        this.residentialService.completeCustomerEnrollmentPostObject = user;
        this.residentialService.postApiOfEnrollment(user).subscribe((res: any) => {
          this.EnrollmentProcess = false;
            this.residentialService.enrollmentPostResult = JSON.parse(res);
            const result = this.residentialService.enrollmentPostResult;
            this.TrackFunction(result.Status + ": " + result.Message);
            // result && result.Message.indexOf('PlanId not Found') >= 0
            //     ? this.setEnergyProvidersPlanFailed()
            //     : result.Status.indexOf('CreditCheck Failed') >= 0
            //         ? this.navigateCreditCheckFailure(result.Message)
            //         : result.Status.indexOf('Validation Failed') >= 0
            //             ? this.openChariotrrorTemplate(result.Message)
            //             : result.Message.indexOf('Required Deposite Fields') >= 0
            //                 ? this.postChariotDeposit(result.DepositAmount)
            //                 : this.postBKVEnergyResult(result);

            if (result && result.Message.indexOf('PlanId not Found') >= 0) {
              this.setEnergyProvidersPlanFailed();
              this.residentialService.SendFailedEnrollment(this.orderDetails, result,result).subscribe((res: any) => {});
              this.SaveFailedOrder(result.Message);
            } else if (result.Status.indexOf('CreditCheck Failed') >= 0) {
              this.navigateCreditCheckFailure(result.Message);
              this.residentialService.SendFailedEnrollment(this.orderDetails, result,result).subscribe((res: any) => {});
              this.SaveFailedOrder(result.Message);
            } else if (result.Status.indexOf('Validation Failed') >= 0) {
              this.openChariotrrorTemplate(result.Message);
              this.residentialService.SendFailedEnrollment(this.orderDetails, result,result).subscribe((res: any) => {});
              this.SaveFailedOrder(result.Message);
            } else if (result.Message.indexOf('Required Deposite Fields') >= 0) {
              this.postChariotDeposit(result.DepositAmount);
            } else {
              this.postBKVEnergyResult(result);
            }
        });
    }

  saveRhythmEnergyAPI() {
    const user = {
      orderDetails: this.orderDetails,
      postObject: this.energyPostObject,
      energyProvider: this.orderDetails['selectedProduct'].energy_provider,
      apiURL: '',
    };
    this.residentialService.completeCustomerEnrollmentPostObject = user;
    this.residentialService.postApiOfRhythmEnergyEnrollment(user).subscribe((res: any) => {
      this.EnrollmentProcess = false;
      this.postApiRhythmEnrollmentResult(res);
    });
  }

  saveAPGEEnergyAPI() {
    const user = {
      orderDetails: this.orderDetails,
      postObject: this.energyPostObject,
      energyProvider: this.orderDetails['selectedProduct'].energy_provider,
      apiURL: '',
    };
    this.residentialService.completeCustomerEnrollmentPostObject = user;
    this.residentialService.postApiOfAPGEEnergyEnrollment(user).subscribe((res: any) => {
      this.EnrollmentProcess = false;
      this.postApiAPGEEnrollmentResult(res);
    });
  }

  saveShellEnergyAPI() {
    const user = {
      orderDetails: this.orderDetails,
      postObject: this.energyPostObject,
      energyProvider: this.orderDetails['selectedProduct'].energy_provider,
      apiURL: '',
    };
    this.residentialService.completeCustomerEnrollmentPostObject = user;
    this.residentialService.postApiOfShellEnergyEnrollment(user).subscribe((res: any) => {
      this.EnrollmentProcess = false;
      this.postApiShellEnrollmentResult(res);
    });
  }


  postRhythmEnergyResult(postresult,isRequiredDeposit,amt) {

    if(isRequiredDeposit)
    {
      const hg_accountId = window.location.href.split('/').pop();

  
       this.orderDetails['referenumber'] = '';
       this.orderDetails['hg_accountId'] = hg_accountId;
       this.orderDetails['webStatus'] = 'Pending Deposit';
       this.orderDetails['reason'] =  '';
       this.TrackFunction('Pending Deposit')
       const postObjDetails = this.assignOrderDetailsForRhythm(true);
 

       this.orderDetails = {
         ...this.orderDetails,
         ...postObjDetails,
       };
       // this.residentialService.completeCustomerEnrollmentPostObject =
       //   this.orderDetails;
       this.residentialService.setConfirmationStatusDetails =
         this.orderDetails;
       const body = new HttpParams().append(
         'orderDetails',
         JSON.stringify(this.orderDetails)
         ).append(
          'AbondonedId',
          (sessionStorage.getItem('_abandonedid') == null || sessionStorage.getItem('_abandonedid') == "" || 
          sessionStorage.getItem('_abandonedid') == undefined ? null : sessionStorage.getItem('_abandonedid'))
        );
       this.http
         .post(this.url + '/saveorders', body)
         .subscribe((res: any) => {
           const userId = JSON.parse(sessionStorage.getItem('userObj'));
           const userObj = {
             hg_accountId: postObjDetails.hg_accountId,
             esiid: postObjDetails.esiid,
             emailId: postObjDetails.contactInfo.emailId,
             enableMessage: "",
             referenumber: postObjDetails.ConfirmationNumber,
           };
 
           const body1 = new HttpParams()
             .append('userDetails', JSON.stringify(userObj))
             .append(
               'providerContact',
               JSON.stringify(this.providerContact)
             );
           this.http
             .post(this.url + '/congratsEmail', body1)
             .subscribe((res: any) => {
               const result = res;
               this.router.navigate(['congrats', hg_accountId]);
             });
           this.router.navigate(['congrats', hg_accountId]);
           this.ClearAbandonedId();
         });

    }
    else
    {


      let status = postresult['status'];
    if (
      status === 'PENDING' ||
       status === 'ACTIVE' || status === 'INACTIVE'
    ) {
      const hg_accountId = window.location.href.split('/').pop();
     
      var referenumber = postresult['uuid'];
      sessionStorage.setItem('referenumber', referenumber);
       this.orderDetails['referenumber'] = referenumber;
       this.orderDetails['hg_accountId'] = hg_accountId;
       this.orderDetails['webStatus'] = status == "INACTIVE" ? "PENDING" : status == "ACTIVE" ? "COMPLETED" : status;
       this.orderDetails['reason'] =  postresult['url'];
      // this.orderDetails = {
      //   referenumber: referenumber,
      //   hg_accountId: hg_accountId,
      //   isDepositRequired: 'null',
      //   webStatus:status,

      this.TrackFunction(this.orderDetails['webStatus'])
      // };
      const postObjDetails = this.assignOrderDetailsForRhythm(false);
 

      this.orderDetails = {
        ...this.orderDetails,
        ...postObjDetails,
      };
      // this.residentialService.completeCustomerEnrollmentPostObject =
      //   this.orderDetails;
      this.residentialService.setConfirmationStatusDetails =
        this.orderDetails;
      const body = new HttpParams().append(
        'orderDetails',
        JSON.stringify(this.orderDetails)
        ).append(
          'AbondonedId',
          (sessionStorage.getItem('_abandonedid') == null || sessionStorage.getItem('_abandonedid') == "" || 
          sessionStorage.getItem('_abandonedid') == undefined ? null : sessionStorage.getItem('_abandonedid'))
        );
      this.http
        .post(this.url + '/saveorders', body)
        .subscribe((res: any) => {
          const userId = JSON.parse(sessionStorage.getItem('userObj'));
          const userObj = {
            hg_accountId: postObjDetails.hg_accountId,
            esiid: postObjDetails.esiid,
            emailId: postObjDetails.contactInfo.emailId,
            enableMessage: "",
            referenumber: postObjDetails.ConfirmationNumber,
          };

          const body1 = new HttpParams()
            .append('userDetails', JSON.stringify(userObj))
            .append(
              'providerContact',
              JSON.stringify(this.providerContact)
            );
          this.http
            .post(this.url + '/congratsEmail', body1)
            .subscribe((res: any) => {
              const result = res;
              this.router.navigate(['congrats', hg_accountId]);
            });
          this.router.navigate(['congrats', hg_accountId]);
          this.ClearAbandonedId();
        });
    }
    else
    {



      this.residentialService.enrollmentPostResult = postresult;
      this.router.navigate(['', this.hgAccountId]);
    }




    }

    

  }

   postAPGEEnergyResult(postresult) {

    
    
      let status = postresult['result'];
    if (
      status === 'success'
       
    ) {
      this.TrackFunction(status)
      const hg_accountId = window.location.href.split('/').pop();

      var referenumber = postresult.data['dbs'];
      sessionStorage.setItem('referenumber', referenumber);
       this.orderDetails['referenumber'] = referenumber;
       this.orderDetails['hg_accountId'] = hg_accountId;
       this.orderDetails['webStatus'] =  "Completed";
       this.orderDetails['reason'] =  'Success';
      // this.orderDetails = {
      //   referenumber: referenumber,
      //   hg_accountId: hg_accountId,
      //   isDepositRequired: 'null',
      //   webStatus:status,

        
      // };
      const postObjDetails = this.assignOrderDetailsForRhythm(false);
 

      this.orderDetails = {
        ...this.orderDetails,
        ...postObjDetails,
      };
      // this.residentialService.completeCustomerEnrollmentPostObject =
      //   this.orderDetails;
      this.residentialService.setConfirmationStatusDetails =
        this.orderDetails;
      const body = new HttpParams().append(
        'orderDetails',
        JSON.stringify(this.orderDetails)
        ).append(
          'AbondonedId',
          (sessionStorage.getItem('_abandonedid') == null || sessionStorage.getItem('_abandonedid') == "" || 
          sessionStorage.getItem('_abandonedid') == undefined ? null : sessionStorage.getItem('_abandonedid'))
        );
      this.http
        .post(this.url + '/saveorders', body)
        .subscribe((res: any) => {
          const userId = JSON.parse(sessionStorage.getItem('userObj'));
          const userObj = {
            hg_accountId: postObjDetails.hg_accountId,
            esiid: postObjDetails.esiid,
            emailId: postObjDetails.contactInfo.emailId,
            enableMessage: "",
            referenumber: postObjDetails.ConfirmationNumber,
          };

          const body1 = new HttpParams()
            .append('userDetails', JSON.stringify(userObj))
            .append(
              'providerContact',
              JSON.stringify(this.providerContact)
            );
          this.http
            .post(this.url + '/congratsEmail', body1)
            .subscribe((res: any) => {
              const result = res;
              this.router.navigate(['congrats', hg_accountId]);
            });
          this.router.navigate(['congrats', hg_accountId]);
          this.ClearAbandonedId();
        });
    }
    else
    {



      this.residentialService.enrollmentPostResult = postresult;
      this.router.navigate(['', this.hgAccountId]);
    }




  }

  postShellEnergyResult(postresult) {

    
    const apiResponse = JSON.parse(postresult);


    if(apiResponse != null && apiResponse.OrderStatus != null)
    {
      if(apiResponse.OrderStatus.OrderStatus == "Draft"
      || apiResponse.OrderStatus.OrderStatus == "Cancelled"
      ||  apiResponse.OrderStatus.OrderStatus == "Rejected"
      )
      {
        //apiResponse.OrderStatus.OrderStatus = "Rejected";
        //apiResponse.OrderStatus.Message = "Custom msg";
        
        this.TrackFunction(apiResponse.OrderStatus.OrderStatus)
        const hg_accountId = window.location.href.split('/').pop();

        var referenumber = apiResponse.OrderStatus['OrderNumber'];
        sessionStorage.setItem('referenumber', referenumber);
        this.orderDetails['referenumber'] = referenumber;
        this.orderDetails['hg_accountId'] = hg_accountId;
        this.orderDetails['webStatus'] =  "Pending Deposit";
        this.orderDetails['reason'] =  apiResponse.OrderStatus.OrderStatus;
        this.orderDetails['RejectedMessage'] =  apiResponse.OrderStatus.OrderStatus == "Rejected" ? apiResponse.OrderStatus.Message : "";

        const postObjDetails = this.assignOrderDetailsForRhythm(false);


        this.orderDetails = {
          ...this.orderDetails,
          ...postObjDetails,
        };
        // this.residentialService.completeCustomerEnrollmentPostObject =
        //   this.orderDetails;
        this.residentialService.setConfirmationStatusDetails =
          this.orderDetails;
        const body = new HttpParams().append(
          'orderDetails',
          JSON.stringify(this.orderDetails)
          ).append(
            'AbondonedId',
            (sessionStorage.getItem('_abandonedid') == null || sessionStorage.getItem('_abandonedid') == "" || 
            sessionStorage.getItem('_abandonedid') == undefined ? null : sessionStorage.getItem('_abandonedid'))
          );
        this.http
          .post(this.url + '/saveorders', body)
          .subscribe((res: any) => {
            const userId = JSON.parse(sessionStorage.getItem('userObj'));
            const userObj = {
              hg_accountId: postObjDetails.hg_accountId,
              esiid: postObjDetails.esiid,
              emailId: postObjDetails.contactInfo.emailId,
              enableMessage: "",
              referenumber: postObjDetails.ConfirmationNumber,
            };
    
            const body1 = new HttpParams()
              .append('userDetails', JSON.stringify(userObj))
              .append(
                'providerContact',
                JSON.stringify(this.providerContact)
              );
            this.http
              .post(this.url + '/congratsEmail', body1)
              .subscribe((res: any) => {
                const result = res;
                this.router.navigate(['congrats', hg_accountId]);
              });
            this.router.navigate(['congrats', hg_accountId]);
            this.ClearAbandonedId();
          });


      }
      else if(apiResponse.OrderStatus.OrderStatus == "Activated" || apiResponse.OrderStatus.OrderStatus == "In Progress")
      {
        this.TrackFunction(apiResponse.OrderStatus.OrderStatus)
        const hg_accountId = window.location.href.split('/').pop();

        var referenumber = apiResponse.OrderStatus['OrderNumber'];
        sessionStorage.setItem('referenumber', referenumber);
        this.orderDetails['referenumber'] = referenumber;
        this.orderDetails['hg_accountId'] = hg_accountId;
        this.orderDetails['webStatus'] =  "Completed";
        this.orderDetails['reason'] =  apiResponse.OrderStatus.OrderStatus;

        const postObjDetails = this.assignOrderDetailsForRhythm(true);


        this.orderDetails = {
          ...this.orderDetails,
          ...postObjDetails,
        };
        // this.residentialService.completeCustomerEnrollmentPostObject =
        //   this.orderDetails;
        this.residentialService.setConfirmationStatusDetails =
          this.orderDetails;
        const body = new HttpParams().append(
          'orderDetails',
          JSON.stringify(this.orderDetails)
          ).append(
            'AbondonedId',
            (sessionStorage.getItem('_abandonedid') == null || sessionStorage.getItem('_abandonedid') == "" || 
            sessionStorage.getItem('_abandonedid') == undefined ? null : sessionStorage.getItem('_abandonedid'))
          );
        this.http
          .post(this.url + '/saveorders', body)
          .subscribe((res: any) => {
            const userId = JSON.parse(sessionStorage.getItem('userObj'));
            const userObj = {
              hg_accountId: postObjDetails.hg_accountId,
              esiid: postObjDetails.esiid,
              emailId: postObjDetails.contactInfo.emailId,
              enableMessage: "",
              referenumber: postObjDetails.ConfirmationNumber,
            };
    
            const body1 = new HttpParams()
              .append('userDetails', JSON.stringify(userObj))
              .append(
                'providerContact',
                JSON.stringify(this.providerContact)
              );
            this.http
              .post(this.url + '/congratsEmail', body1)
              .subscribe((res: any) => {
                const result = res;
                this.router.navigate(['congrats', hg_accountId]);
              });
            this.router.navigate(['congrats', hg_accountId]);
            this.ClearAbandonedId();
          });


      }
    }

  //   let status = postresult['result'];
  // if (
  //   status === 'success'
     
  // ) {
  //   this.TrackFunction(status)
  //   const hg_accountId = window.location.href.split('/').pop();

  //   var referenumber = postresult.data['dbs'];
  //   sessionStorage.setItem('referenumber', referenumber);
  //    this.orderDetails['referenumber'] = referenumber;
  //    this.orderDetails['hg_accountId'] = hg_accountId;
  //    this.orderDetails['webStatus'] =  "Completed";
  //    this.orderDetails['reason'] =  'Success';
  //   // this.orderDetails = {
  //   //   referenumber: referenumber,
  //   //   hg_accountId: hg_accountId,
  //   //   isDepositRequired: 'null',
  //   //   webStatus:status,

      
  //   // };
  //   const postObjDetails = this.assignOrderDetailsForRhythm(false);


  //   this.orderDetails = {
  //     ...this.orderDetails,
  //     ...postObjDetails,
  //   };
  //   // this.residentialService.completeCustomerEnrollmentPostObject =
  //   //   this.orderDetails;
  //   this.residentialService.setConfirmationStatusDetails =
  //     this.orderDetails;
  //   const body = new HttpParams().append(
  //     'orderDetails',
  //     JSON.stringify(this.orderDetails)
  //     ).append(
  //       'AbondonedId',
  //       (sessionStorage.getItem('_abandonedid') == null || sessionStorage.getItem('_abandonedid') == "" || 
  //       sessionStorage.getItem('_abandonedid') == undefined ? null : sessionStorage.getItem('_abandonedid'))
  //     );
  //   this.http
  //     .post(this.url + '/saveorders', body)
  //     .subscribe((res: any) => {
  //       const userId = JSON.parse(sessionStorage.getItem('userObj'));
  //       const userObj = {
  //         hg_accountId: postObjDetails.hg_accountId,
  //         esiid: postObjDetails.esiid,
  //         emailId: postObjDetails.contactInfo.emailId,
  //         enableMessage: "",
  //         referenumber: postObjDetails.ConfirmationNumber,
  //       };

  //       const body1 = new HttpParams()
  //         .append('userDetails', JSON.stringify(userObj))
  //         .append(
  //           'providerContact',
  //           JSON.stringify(this.providerContact)
  //         );
  //       this.http
  //         .post(this.url + '/congratsEmail', body1)
  //         .subscribe((res: any) => {
  //           const result = res;
  //           this.router.navigate(['congrats', hg_accountId]);
  //         });
  //       this.router.navigate(['congrats', hg_accountId]);
  //       this.ClearAbandonedId();
  //     });
  // }
  // else
  // {



  //   this.residentialService.enrollmentPostResult = postresult;
  //   this.router.navigate(['', this.hgAccountId]);
  // }




}
  postChariotDeposit(depositAmount) {
    this.securityDepositText = `Pay the ${depositAmount} deposit now`;
    const template: ElementRef<any> = this.depositPending;

    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-small' },this.ngbModalOptions)
    );
  }
  navigateCreditCheckFailure(message) {
    //alert(message);
    this.router.navigate(['creditcheck-furtheraction', this.hgAccountId]);
  }

  postChariotEnergyResult(postresult) {

    let status = postresult['Status'];
    if (
      status === 'Enrollment has been completed' ||
      status === 'Enrollment has been completed with Pending Status'
    ) {
      const hg_accountId = window.location.href.split('/').pop();

      var referenumber = postresult['RefrenceNumber'];
      sessionStorage.setItem('referenumber', referenumber);

      var reason = "Completed";
      
      this.orderDetails = {
        referenumber: referenumber,
        hg_accountId: hg_accountId,
        isDepositRequired: 'null',
        webStatus:'Completed',
          // this.Paythe$175deposit === true
          //   ? 'Completed'
          //   : 'Pending Deposit',
        reason: reason,
      };
      const postObjDetails = this.postObjDetails();
      this.orderDetails = {
        ...this.orderDetails,
        ...postObjDetails,
      };
      // this.residentialService.completeCustomerEnrollmentPostObject =
      //   this.orderDetails;
      this.residentialService.setConfirmationStatusDetails =
        this.orderDetails;
      const body = new HttpParams().append(
        'orderDetails',
        JSON.stringify(this.orderDetails)
        ).append(
          'AbondonedId',
          (sessionStorage.getItem('_abandonedid') == null || sessionStorage.getItem('_abandonedid') == "" || 
          sessionStorage.getItem('_abandonedid') == undefined ? null : sessionStorage.getItem('_abandonedid'))
        );
      this.http
        .post(this.url + '/saveorders', body)
        .subscribe((res: any) => {
          const userId = JSON.parse(sessionStorage.getItem('userObj'));
          const userObj = {
            hg_accountId: postObjDetails.hg_accountId,
            esiid: postObjDetails.esiid,
            emailId: postObjDetails.contactInfo.emailId,
            enableMessage: "",
            referenumber: postObjDetails.ConfirmationNumber,
          };

          const body1 = new HttpParams()
            .append('userDetails', JSON.stringify(userObj))
            .append(
              'providerContact',
              JSON.stringify(this.providerContact)
            );
          this.http
            .post(this.url + '/congratsEmail', body1)
            .subscribe((res: any) => {
              const result = res;
              this.router.navigate(['congrats', hg_accountId]);
            });
          this.router.navigate(['congrats', hg_accountId]);
          this.ClearAbandonedId();
        });
    }
    else
    {



      this.residentialService.enrollmentPostResult = postresult;
      this.router.navigate(['', this.hgAccountId]);
    }



  }

  postBKVEnergyResult(postresult) {
      
        let status = postresult['Status'];
        if (
            status === 'Enrollment has been completed' ||
            status === 'Enrollment has been completed with Pending Status'
            || status === 'Enrollment has been completed with Pending-ESG Status' ||
            status ===  'Enrollment has been completed with Review Status'
        ) {
            const hg_accountId = window.location.href.split('/').pop();

            var referenumber = postresult['ReferenceNumber'];
            sessionStorage.setItem('referenumber', referenumber);

            var reason = "Completed";

            this.orderDetails = {
                referenumber: referenumber,
                hg_accountId: hg_accountId,
                isDepositRequired: 'null',
                webStatus: 'Completed',
                // this.Paythe$175deposit === true
                //   ? 'Completed'
                //   : 'Pending Deposit',
                reason: reason,
            };
            const postObjDetails = this.postBKVObjDetails();
            this.orderDetails = {
                ...this.orderDetails,
                ...postObjDetails,
            };
            // this.residentialService.completeCustomerEnrollmentPostObject =
            //   this.orderDetails;
            this.residentialService.setConfirmationStatusDetails =
                this.orderDetails;
            const body = new HttpParams().append(
                'orderDetails',
                JSON.stringify(this.orderDetails)
                ).append(
                  'AbondonedId',
                  (sessionStorage.getItem('_abandonedid') == null || sessionStorage.getItem('_abandonedid') == "" || 
                  sessionStorage.getItem('_abandonedid') == undefined ? null : sessionStorage.getItem('_abandonedid'))
                );
            this.http
                .post(this.url + '/saveorders', body)
                .subscribe((res: any) => {
                    const userId = JSON.parse(sessionStorage.getItem('userObj'));
                    const userObj = {
                        hg_accountId: postObjDetails.hg_accountId,
                        esiid: postObjDetails.esiid,
                        emailId: postObjDetails.contactInfo.emailId,
                        enableMessage: "",
                        referenumber: postObjDetails.ConfirmationNumber,
                    };

                    const body1 = new HttpParams()
                        .append('userDetails', JSON.stringify(userObj))
                        .append(
                            'providerContact',
                            JSON.stringify(this.providerContact)
                        );
                    this.http
                        .post(this.url + '/congratsEmail', body1)
                        .subscribe((res: any) => {
                            const result = res;
                            this.router.navigate(['congrats', hg_accountId]);
                        });
                    this.router.navigate(['congrats', hg_accountId]);
                    this.ClearAbandonedId();
                });
        } else if(status == "Abandoned")
        {
          
          var referenumber = postresult['ReferenceNumber'];
          sessionStorage.setItem('referenumber', referenumber);

          const hg_accountId = window.location.href.split('/').pop();

          var reason = "Abandoned";

          this.orderDetails = {
              referenumber: referenumber,
              hg_accountId: hg_accountId,
              isDepositRequired: true,
              webStatus: 'Abandoned',
              // this.Paythe$175deposit === true
              //   ? 'Completed'
              //   : 'Pending Deposit',
              reason: reason,
              PaymentLink: postresult['PaymentLink']
          };
          const postObjDetails = this.postBKVObjDetails();
          this.orderDetails = {
              ...this.orderDetails,
              ...postObjDetails,
          };
          // this.residentialService.completeCustomerEnrollmentPostObject =
          //   this.orderDetails;
          this.residentialService.setConfirmationStatusDetails =
              this.orderDetails;
          const body = new HttpParams().append(
              'orderDetails',
              JSON.stringify(this.orderDetails)
              ).append(
                'AbondonedId',
                (sessionStorage.getItem('_abandonedid') == null || sessionStorage.getItem('_abandonedid') == "" || 
                sessionStorage.getItem('_abandonedid') == undefined ? null : sessionStorage.getItem('_abandonedid'))
              );
          this.http
              .post(this.url + '/saveorders', body)
              .subscribe((res: any) => {
                  const userId = JSON.parse(sessionStorage.getItem('userObj'));
                  const userObj = {
                      hg_accountId: postObjDetails.hg_accountId,
                      esiid: postObjDetails.esiid,
                      emailId: postObjDetails.contactInfo.emailId,
                      enableMessage: "",
                      referenumber: postObjDetails.ConfirmationNumber,
                  };

                  const body1 = new HttpParams()
                      .append('userDetails', JSON.stringify(userObj))
                      .append(
                          'providerContact',
                          JSON.stringify(this.providerContact)
                      );
                  this.http
                      .post(this.url + '/congratsEmail', body1)
                      .subscribe((res: any) => {
                          const result = res;
                          this.router.navigate(['congrats', hg_accountId]);
                      });
                  this.router.navigate(['congrats', hg_accountId]);
                  this.ClearAbandonedId();
              });


        }
        else {



            this.residentialService.enrollmentPostResult = postresult;
            this.router.navigate(['', this.hgAccountId]);
        }



    }


  // savePulsePowerEnergyAPI() {
  //   const user = {
  //     orderDetails: this.orderDetails,
  //     postObject: this.energyPostObject,
  //     energyProvider: this.orderDetails['selectedProduct'].energy_provider,
  //     apiURL: this.providerContact.ProviderEnrollURL,
  //   };
  //   this.residentialService
  //     .postApiOfPulseEnrollment(user)
  //     .subscribe((res: any) => {
  //       this.postApiPulseEnrollmentResult(res);
  //     });
  // }

  save4ChangeEnergyAPI() {
    const user = {
      postObject: this.energyPostObject,
      energyProvider: this.orderDetails['selectedProduct'].energy_provider,
      apiURL: this.providerContact.ProviderAPIURL,
    };
    this.residentialService.enrollmentPostObject = this.energyPostObject;
    this.residentialService
      .postApiOf4ChangeEnergyEnrollment(user)
      .subscribe((res: any) => {
        this.EnrollmentProcess = false;
        this.callCreditCheckResponse(res);
      });
  }

  callCreditCheckResponse(res) {
    if (
      res &&
      res.CreditCheckResult &&
      res.CreditCheckResult.ResponseType === 'Success' &&
      !res.CreditCheckResult.EnrollmentDeclined
    ) {
      this.TrackFunction(res.CreditCheckResult.ResponseType);
      this.checkCreditCheckSuccessResponse(res);
    } else if (
      res.CreditCheckResult &&
      res.CreditCheckResult.ResponseType === 'Error' &&
      res.CreditCheckResult.Message === 'Customer Phone Number Invalid'
    ) {
      this.TrackFunction('Error: ' + res.CreditCheckResult.Message);
      //this.checkCreditCheckSuccessResponse(res);
      this.open4CEErrorTemplate(res.CreditCheckResult.Message);
      this.residentialService.SendFailedEnrollment(this.orderDetails, res.CreditCheckResult.Message,res.CreditCheckResult).subscribe((res: any) => {});
      this.SaveFailedOrder(res.CreditCheckResult.Message);
    } else {
      var msg = res.CreditCheckResult.Message == null ? res.CreditCheckResult.EnrollmentDeclinedReason : res.CreditCheckResult.Message;
      this.open4CEErrorTemplate(msg);
      this.residentialService.SendFailedEnrollment(this.orderDetails, msg,res.CreditCheckResult).subscribe((res: any) => {});
      this.SaveFailedOrder(msg);
    }

    
  }

  saveTexpoEnergyAPI() {
    const user = {
      postObject: this.energyPostObject,
      energyProvider: this.orderDetails['selectedProduct'].energy_provider,
      config: {
        UserName: 'TexpoEnergy',
        EnrollmentSvcUrl: this.providerContact.ProviderEnrollURL,
      },
    };
    this.residentialService.enrollmentPostObject = this.energyPostObject;
    this.residentialService
      .postApiOfTexpoEnergyEnrollment(user)
      .subscribe((res: any) => {
        this.EnrollmentProcess = false;
        // res && res.Message.search('Enrollment Successful') >= 0
        //   ? this.checkTexpoSuccessResponse(res)
        //   : this.open4CEErrorTemplate(res.Message);
        if (res && res.Message.search('Enrollment Successful') >= 0) {
          this.checkTexpoSuccessResponse(res);
        } else {
          this.open4CEErrorTemplate(res.Message);
          this.residentialService.SendFailedEnrollment(this.orderDetails, res,res).subscribe((res: any) => {});
          this.SaveFailedOrder(res.Message);
        }
      });
  }
  checkTexpoSuccessResponse(res: any) {
    this.TrackFunction(res.Message)
    let depAmount = res.Message.split('<br />')[7].search('$');
    depAmount = res.Message.split('<br />')[7].substr(depAmount);
    this.securityDeposit = depAmount == '' ? 0 : depAmount;
    this.residentialService.setConfirmationStatusDetails = res;
    if (this.securityDeposit !== 0) {
      this.securityDepositText = `Pay the $${this.securityDeposit} deposit now`;
      const template: ElementRef<any> = this.depositPending;
      this.modalRef = this.modalService.show(
        template,
        Object.assign({}, { class: 'gray modal-small' },this.ngbModalOptions)
      );
    } else {
      this.redirectionLink = 'congrats';
      // this.sendMessagesAfterPulseEnrollment();
      this.assignOrderDetailsForTexpo(res);
      this.saveEnrollmentOrderDetails();
    }
  }
  assignOrderDetailsForTexpo(data) {
    let mainPhone = this.getPrimaryPhoneNumber(),
      isGetOrderRes = false,
      isNotificationRes = false;
    let serviceTypeDateDetails = this.getServiceTypeValues();
    this.selectedProduct.energy_provider_image =
      this.providerContact.ProviderCloudLogo;
    const orderDetails = {
      order_no: null,
      hg_accountId: this.hgAccountId,
      ConfirmationNumber: data.AccountNumber,
      status: this.securityDeposit !== 0 ? 'Pending Deposit' : 'Completed',
      isDepositRequired:
        this.securityDeposit !== 0 ? 'Pending Deposit' : 'Closed',
      webStatus: this.securityDeposit !== 0 ? 'Pending Deposit' : 'Completed',
      reason: this.securityDeposit !== 0 ? 'Pending Deposit' : 'Closed',
      creditCheckResults: null,
      customerId: data.AccountNumber,
      enableSMSForHonest: this.enablesmshonest === false ? 'No' : 'Yes',
      enableSMSForChariot: this.enablesmschariot === true ? 'Yes' : 'No',
      ratePlanName: this.selectedProduct.product_key,
      serviceTypeDetails: serviceTypeDateDetails,
      contactInfo: {
        legalFirstName: this.orderDetails.contactInfo.legalFirstName,
        legalLastName: this.orderDetails.contactInfo.legalLastName,
        emailId: JSON.parse(sessionStorage.getItem('userObj')).emailId,
        phoneNo: mainPhone[0] + mainPhone[1] + mainPhone[2],
        language: this.language,
        dob: this.dob,
        authorizedRep: this.represnt,
      },
      esiid: this.residentialService.esiid,
      invoiceType: this.invoice,
      promoDetails: {
        hearusOption: this.hearusOption,
        promoeCode: this.promo_code,
      },
      privateDetails: {
        state: this.state,
        license: this.license,
      },
      billingAddress: JSON.parse(sessionStorage.getItem('billingAddress')),
      isExpired: false,
      ReceivedPromocode: this.residentialService.promoCode,
      UsedPromocode:
        this.residentialService.promoCode === 'TAP' ? 'TAP' : 'GORILLA',
      selectedProduct: this.selectedProduct,
      expirationDate: this.serviceTypeExpireDate(
        serviceTypeDateDetails.switchDate
      ),
      Affiliate: sessionStorage.getItem('_Affiliate') == undefined || sessionStorage.getItem('_Affiliate') == '' || sessionStorage.getItem('_Affiliate') == null? "" : sessionStorage.getItem('_Affiliate'),
      AffiliatePromo: sessionStorage.getItem('_Promo') == undefined || sessionStorage.getItem('_Promo') == '' || sessionStorage.getItem('_Promo') == null? "" : sessionStorage.getItem('_Promo'),
      AffiliateID: sessionStorage.getItem('_AffiliateID') == undefined || sessionStorage.getItem('_AffiliateID') == '' || sessionStorage.getItem('_AffiliateID') == null? "" : sessionStorage.getItem('_AffiliateID'),
      QuestionId: sessionStorage.getItem('QuestionUserID') == undefined || sessionStorage.getItem('QuestionUserID') == '' || sessionStorage.getItem('QuestionUserID') == null? "" : sessionStorage.getItem('QuestionUserID')
    };
    this.recommendationService.enrollmentOrderDetails = orderDetails;
  }

  saveGEXAEnergyAPI(TransactionID?) {
    this.energyPostObject['TransactionID'] = TransactionID;
    const user = {
      postObject: this.energyPostObject,
      energyProvider: this.orderDetails['selectedProduct'].energy_provider,
      config: {
        UserName: this.providerContact.AccessKeyName,
        Password: this.providerContact.AccessKeyValue,
        EnrollmentSvcUrl: this.providerContact.ProviderAPIURL,
      },
    };
    this.residentialService.enrollmentPostObject = this.energyPostObject;
    this.residentialService
      .postApiOfGEXAEnergyEnrollment(user)
      .subscribe((res: any) => {
        this.EnrollmentProcess = false;
        if (res && res.SubmitAPIEnrollmentResult)
          this.checkGEXASuccessResponse(res,TransactionID);
      });
  }

  checkGEXASuccessResponse(res: any,TransactionID?) {
    this.GEXAEnergyPostResult = res.SubmitAPIEnrollmentResult;
    this.TrackFunction(res.SubmitAPIEnrollmentResult.RequestMessage);
    // this.postGEXAResultNavigation[
    //   res.SubmitAPIEnrollmentResult.RequestMessage === 'Success' ||
    //   (res.SubmitAPIEnrollmentResult.RequestMessage === 'Deposit Needed' &&
    //     !res.SubmitAPIEnrollmentResult.Has_Outstanding_Balance)
    //     ? res.SubmitAPIEnrollmentResult.RequestMessage.replace(/\s/g, '')
    //     : res.SubmitAPIEnrollmentResult.Has_Outstanding_Balance
    //     ? 'Others'
    //     : res.SubmitAPIEnrollmentResult.FreezeAlert == 'Y'
    //     ? 'FreezeAlert'
    //     : 'Others'
    // ]( this.GEXAEnergyPostResult.RequestMessage);


    if(TransactionID == null)
    {
      if(res.SubmitAPIEnrollmentResult.RequestStatus == 1)
      {
        this.postResultGEXACompletedAPI(res);
      }
      else if(res.SubmitAPIEnrollmentResult.RequestStatus == -2)
      {
        this.postResultGEXADepositAPI()
      } 
      else 
      {
        this.openGEXAErrorTemplate(this.GEXAEnergyPostResult.RequestMessage,this.GEXAEnergyPostResult);
      }

    }
    else
    {

      if(res.SubmitAPIEnrollmentResult.RequestStatus == 1)
      {
        res.SubmitAPIEnrollmentResult.RequestMessage = "Deposit Needed";
        this.GEXAEnergyPostResult.RequestMessage = "Deposit Needed";
        this.postResultGEXACompletedAPI(res);
        this.modalRef.hide();
      }
      else if(res.SubmitAPIEnrollmentResult.RequestStatus == -2)
      {
        this.postResultGEXACompletedAPI(res);
        this.modalRef.hide();
        if(res.SubmitAPIEnrollmentResult.PaymentLink && res.SubmitAPIEnrollmentResult.PaymentLink != null && res.SubmitAPIEnrollmentResult.PaymentLink != '')
        {
           window.open(res.SubmitAPIEnrollmentResult.PaymentLink);
        }
       
      }
      else 
      {
        this.openGEXAErrorTemplate(this.GEXAEnergyPostResult.RequestMessage,this.GEXAEnergyPostResult);
      }
    }

    
  }

  postResultGEXADepositAPI() {
    this.securityDeposit = `$${this.GEXAEnergyPostResult.DepositAmount}`;
    this.securityDepositText = `Pay the ${this.securityDeposit} deposit now`;
    const template: ElementRef<any> = this.depositPending;
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-small' },this.ngbModalOptions)
    );
  }

  postResultGEXACompletedAPI(res) {
    // const userObj = {
    //   VendorTransactionID: this.GEXAEnergyPostResult.VendorTransactionID,
    //   TransactionID: this.GEXAEnergyPostResult.TransactionID,
    //   EBill: this.checkEBilling(),
    //   PaperlessDocuments: this.checkEBilling(),
    // };
    // const user = {
    //   postObject: userObj,
    //   energyProvider: this.orderDetails['selectedProduct'].energy_provider,
    //   config: {
    //     UserName: this.providerContact.AccessKeyName,
    //     Password: this.providerContact.AccessKeyValue,
    //     EnrollmentSvcUrl: this.providerContact.ProviderAPIURL,
    //   },
    // };
    // this.residentialService
    //   .saveGEXACompleteEnrollment(user)
    //   .subscribe((res: any) => {
    //     this.residentialService.setConfirmationStatusDetails =
    //       this.GEXAEnergyPostResult.DepositAmount > 0
    //         ? this.GEXAEnergyPostResult
    //         : res.ConfirmAPIEnrollmentResult;
    //     this.assignOrderDetailsForGEXA(res);
    //     this.saveEnrollmentOrderDetails();
    //     this.redirectionLink = 'congrats';
    //   });

      this.residentialService.setConfirmationStatusDetails = this.GEXAEnergyPostResult
      this.assignOrderDetailsForGEXA(res);
      this.redirectionLink = 'congrats';
      this.saveEnrollmentOrderDetails();
  }

  assignOrderDetailsForGEXA(res) {
    let mainPhone = this.getPrimaryPhoneNumber(),
      isGetOrderRes = false,
      isNotificationRes = false;
    let serviceTypeDateDetails = this.getServiceTypeValues();
    this.selectedProduct.energy_provider_image =
      this.providerContact.ProviderCloudLogo;
    const orderDetails = {
      order_no: null,
      hg_accountId: this.hgAccountId,
      ConfirmationNumber: res.SubmitAPIEnrollmentResult.AccountNumber,
      status:
        this.GEXAEnergyPostResult.DepositAmount > 0
          ? this.GEXAEnergyPostResult.RequestMessage
          : res.SubmitAPIEnrollmentResult.RequestMessage === 'Success'
          ? 'Completed'
          : res.SubmitAPIEnrollmentResult.RequestMessage,
      isDepositRequired:
        this.GEXAEnergyPostResult.DepositAmount > 0
          ? this.GEXAEnergyPostResult.DepositNeeded
          : 'No',
      webStatus:
        this.GEXAEnergyPostResult.DepositAmount > 0
          ? this.GEXAEnergyPostResult.RequestMessage
          : res.SubmitAPIEnrollmentResult.RequestMessage === 'Success'
          ? 'Completed'
          : res.SubmitAPIEnrollmentResult.RequestMessage,
      reason:
        this.GEXAEnergyPostResult.DepositAmount > 0
          ? this.GEXAEnergyPostResult.RequestMessage
          : res.SubmitAPIEnrollmentResult.RequestMessage,
      creditCheckResults:
        this.GEXAEnergyPostResult.DepositAmount > 0
          ? this.GEXAEnergyPostResult.DepositNeeded
          : 'No',
      customerId: res.SubmitAPIEnrollmentResult.TransactionID,
      enableSMSForHonest: this.enablesmshonest === false ? 'No' : 'Yes',
      enableSMSForChariot: this.enablesmschariot === true ? 'Yes' : 'No',
      ratePlanName: this.selectedProduct.product_key,
      serviceTypeDetails: serviceTypeDateDetails,
      contactInfo: {
        legalFirstName: this.first_name,
        legalLastName: this.last_name,
        emailId: this.email_address,
        phoneNo: mainPhone[0] + mainPhone[1] + mainPhone[2],
        language: this.language,
        dob: this.dob,
        authorizedRep: this.represnt,
      },
      esiid: this.residentialService.esiid,
      invoiceType: this.invoice,
      promoDetails: {
        hearusOption: this.hearusOption,
        promoeCode: this.promo_code,
      },
      privateDetails: {
        state: this.state,
        license: this.license,
      },
      billingAddress: JSON.parse(sessionStorage.getItem('billingAddress')),
      isExpired: false,
      ReceivedPromocode: this.residentialService.promoCode,
      UsedPromocode:
        this.residentialService.promoCode === 'TAP' ? 'TAP' : 'GORILLA',
      selectedProduct: this.selectedProduct,
      expirationDate: this.serviceTypeExpireDate(
        serviceTypeDateDetails.switchDate
      ),
      Affiliate: sessionStorage.getItem('_Affiliate') == undefined || sessionStorage.getItem('_Affiliate') == '' || sessionStorage.getItem('_Affiliate') == null? "" : sessionStorage.getItem('_Affiliate'),
      AffiliatePromo: sessionStorage.getItem('_Promo') == undefined || sessionStorage.getItem('_Promo') == '' || sessionStorage.getItem('_Promo') == null? "" : sessionStorage.getItem('_Promo'),
      AffiliateID: sessionStorage.getItem('_AffiliateID') == undefined || sessionStorage.getItem('_AffiliateID') == '' || sessionStorage.getItem('_AffiliateID') == null? "" : sessionStorage.getItem('_AffiliateID'),
      QuestionId: sessionStorage.getItem('QuestionUserID') == undefined || sessionStorage.getItem('QuestionUserID') == '' || sessionStorage.getItem('QuestionUserID') == null? "" : sessionStorage.getItem('QuestionUserID')
    };
    this.recommendationService.enrollmentOrderDetails = orderDetails;
  }

  checkCreditCheckSuccessResponse(res) {
    this.depositRequired4CE =
      res.CreditCheckResult.DepositAmount > 0 ? true : false;
    this.depositAmount4CE = res.CreditCheckResult.DepositAmount;
    this.autoPay4CE = res.CreditCheckResult.IsAutoPayRequired;
    this.residentialService.creditCheckResult4CE = {
      depositRequired4CE:
        res.CreditCheckResult.DepositAmount > 0 ? true : false,
      depositAmount4CE: res.CreditCheckResult.DepositAmount,
      autoPay4CE: this.getCreditCheckForIsAutoPay(
        res.CreditCheckResult.IsAutoPayRequired
      ),
    };
    this.postApi4CEBeginCustomerEnrollment();
  }
  getCreditCheckForIsAutoPay(IsAutoPayRequired: boolean): boolean {
    if (IsAutoPayRequired && this.depositAmount4CE > 0) {
      return false;
    } else if (IsAutoPayRequired && this.depositAmount4CE === 0) {
      return true;
    }
  }

  open4CEErrorTemplate(msg?) {

    this.ShowAPIErrorMsg = msg == null ? false : true;
    this.APIErrorMsg = msg
    const template: ElementRef<any> = this.errorStatus4CE;
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-small' },this.ngbModalOptions)
    );
  }

  openGEXAErrorTemplate(msg?,res? :any) {
    this.residentialService.SendFailedEnrollment(this.orderDetails, msg,res).subscribe((res: any) => {});
    this.SaveFailedOrder(msg);
    
    this.ShowAPIErrorMsg = msg == null ? false : true;
    this.APIErrorMsg = msg
    const template: ElementRef<any> = this.errorStatus4CE;
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-small' },this.ngbModalOptions)
    );
  }
  openChariotrrorTemplate(msg) {
    this.ShowAPIErrorMsg = true;
    this.APIErrorMsg = msg
    const template: ElementRef<any> = this.errorStatus4CE;
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-small' },this.ngbModalOptions)
    );
  }


  postApi4CEBeginCustomerEnrollment() {
    let beginCustomerEnrollmentRequest = {
      postObject: this.create4ChangeEnergyBeginCustomerPostObject(),
      energyProvider: this.orderDetails['selectedProduct'].energy_provider,
      apiURL: this.providerContact.ProviderAPIURL,
    };
    this.residentialService
      .setupBeginCustomerEnrollment(beginCustomerEnrollmentRequest)
      .subscribe((result: any) => {
        // result &&
        // result.BeginCustomerEnrollmentResult &&
        // result.BeginCustomerEnrollmentResult.ResponseType === 'Success'
        //   ? this.checkBeginCustomerResponseDetails(result)
        //   : result.BeginCustomerEnrollmentResult.ResponseType === 'Error' &&
        //     result.BeginCustomerEnrollmentResult.Message.indexOf(
        //       'GetById returned null'
        //     ) > 0
        //   ? this.setEnergyProvidersPlanFailed()
        //   : this.open4CEErrorTemplate(result.BeginCustomerEnrollmentResult.Message);

        if (
          result &&
          result.BeginCustomerEnrollmentResult &&
          result.BeginCustomerEnrollmentResult.ResponseType === 'Success'
        ) {
          this.checkBeginCustomerResponseDetails(result);
        } else if (
          result.BeginCustomerEnrollmentResult &&
          result.BeginCustomerEnrollmentResult.ResponseType === 'Error' &&
          result.BeginCustomerEnrollmentResult.Message.indexOf('GetById returned null') > 0
        ) {
          this.setEnergyProvidersPlanFailed();
          this.residentialService.SendFailedEnrollment(this.orderDetails, result.BeginCustomerEnrollmentResult.Message,result.BeginCustomerEnrollmentResult).subscribe((res: any) => {});
          this.SaveFailedOrder(result.BeginCustomerEnrollmentResult.Message);
        } else {
          this.open4CEErrorTemplate(result.BeginCustomerEnrollmentResult.Message);
          this.residentialService.SendFailedEnrollment(this.orderDetails, result.BeginCustomerEnrollmentResult.Message, result.BeginCustomerEnrollmentResult).subscribe((res: any) => {});
          this.SaveFailedOrder(result.BeginCustomerEnrollmentResult.Message);
        }

      });
  }

  checkBeginCustomerResponseDetails(result) {
    this.residentialService.depositPaymentOption = {
      accountNumber: result.BeginCustomerEnrollmentResult.AccountNumber,
      clientJavaScriptUrl:
        result.BeginCustomerEnrollmentResult.ClientJavaScriptUrl,
      clientJavaScriptHost:
        result.BeginCustomerEnrollmentResult.ClientJavaScriptHost,
      clientJavaScriptAccessToken:
        result.BeginCustomerEnrollmentResult.ClientJavaScriptAccessToken,
    };
    const depositCheckDetails =
      !this.autoPay4CE && this.depositAmount4CE === 0 ? 'Pass' : 'Fail';
    this.loadCreditCheckDetails[depositCheckDetails]();
  }

  checkBeginCustomerSuccessWithDepositResponse() {
    this.router.navigate([
      'depositrequired4ce',
      this.recommendationService.hg_accountId,
    ]);
  }

  postApi4CEEnrollCustomerAPI() {
    let postObject = this.create4ChangeEnergyBeginCustomerPostObject();
    postObject = {
      ...postObject,
      ...{
        AccountNumber:
          this.residentialService.depositPaymentOption.accountNumber,
      },
    };

    let beginCustomerEnrollmentRequest = {
      postObject: postObject,
      energyProvider: this.orderDetails['selectedProduct'].energy_provider,
      apiURL: this.providerContact.ProviderAPIURL,
    };
    this.residentialService
      .setupSuccessCustomerEnrollment(beginCustomerEnrollmentRequest)
      .subscribe((result: any) => {
        this.residentialService.setConfirmationStatusDetails = result;
        // result &&
        // result.CompleteCustomerEnrollmentResult &&
        // result.CompleteCustomerEnrollmentResult.ResponseType === 'Success'
        //   ? this.postApiSave4CEEnrollCustomer(result)
        //   : this.open4CEErrorTemplate();

        if (
          result &&
          result.CompleteCustomerEnrollmentResult &&
          result.CompleteCustomerEnrollmentResult.ResponseType === 'Success'
        ) {
          this.postApiSave4CEEnrollCustomer(result);
        } else {

          this.residentialService.SendFailedEnrollment(this.orderDetails, result.CompleteCustomerEnrollmentResult.Message,result.CompleteCustomerEnrollmentResult).subscribe((res: any) => {});
          this.open4CEErrorTemplate(result.CompleteCustomerEnrollmentResult.Message);
          this.SaveFailedOrder(result.CompleteCustomerEnrollmentResult.Message);
        }
      });
  }

  postApiSave4CEEnrollCustomer(res) {
    let postObject =
        this.residentialService.completeCustomerEnrollmentPostObject,
      serviceTypeDateDetails = this.getServiceTypeValues(),
      isGetOrderRes = false,
      isNotificationRes = false,
      contactInfo = JSON.parse(sessionStorage.getItem('userObj'));
    this.selectedProduct.energy_provider_image =
      this.providerContact.ProviderCloudLogo;
    this.redirectionLink = 'congrats';
    const orderDetails = {
      order_no: null,
      hg_accountId: this.recommendationService.hg_accountId,
      ConfirmationNumber: res.CompleteCustomerEnrollmentResult.AccountNumber,
      status:
        res.CompleteCustomerEnrollmentResult.ResponseType === 'Success'
          ? 'Completed'
          : res.CompleteCustomerEnrollmentResult.ResponseType,
      isDepositRequired:
        this.residentialService.creditCheckResult4CE.depositRequired4CE,
      webStatus:
        res.CompleteCustomerEnrollmentResult.ResponseType === 'Success'
          ? 'Completed'
          : res.CompleteCustomerEnrollmentResult.ResponseType,
      reason: '',
      creditCheckResults: '',
      customerId: res.CompleteCustomerEnrollmentResult.AccountNumber,
      enableSMSForHonest: postObject.enableSMSForHonest === true ? 'Yes' : 'No',
      enableSMSForChariot: '',
      ratePlanName: this.selectedProduct.product_key,
      serviceTypeDetails: serviceTypeDateDetails,
      contactInfo: {
        legalFirstName: postObject.FirstName,
        legalLastName: postObject.LastName,
        emailId: postObject.Email,
        phoneNo: postObject.HomePhone,
        language: postObject.language,
        dob: postObject.DateOfBirth,
        authorizedRep: postObject.authorizedRep,
      },
      esiid: postObject.ServiceAddress.EsiId,
      invoiceType: postObject.invoiceType,
      promoDetails: {
        hearusOption: postObject.hearusOption,
        promoeCode: postObject.promoeCode,
      },
      privateDetails: {
        state: this.state,
        license: postObject.license,
      },
      billingAddress: JSON.parse(sessionStorage.getItem('billingAddress')),
      isExpired: false,
      ReceivedPromocode: this.residentialService.promoCode,
      UsedPromocode:
        this.residentialService.promoCode === 'TAP' ? 'TAP' : 'GORILLA',
      selectedProduct: this.selectedProduct,
      expirationDate: this.serviceTypeExpireDate(
        serviceTypeDateDetails.switchDate
      ),
      Affiliate: sessionStorage.getItem('_Affiliate') == undefined || sessionStorage.getItem('_Affiliate') == '' || sessionStorage.getItem('_Affiliate') == null? "" : sessionStorage.getItem('_Affiliate'),
      AffiliatePromo: sessionStorage.getItem('_Promo') == undefined || sessionStorage.getItem('_Promo') == '' || sessionStorage.getItem('_Promo') == null? "" : sessionStorage.getItem('_Promo'),
      AffiliateID: sessionStorage.getItem('_AffiliateID') == undefined || sessionStorage.getItem('_AffiliateID') == '' || sessionStorage.getItem('_AffiliateID') == null? "" : sessionStorage.getItem('_AffiliateID'),
      QuestionId: sessionStorage.getItem('QuestionUserID') == undefined || sessionStorage.getItem('QuestionUserID') == '' || sessionStorage.getItem('QuestionUserID') == null? "" : sessionStorage.getItem('QuestionUserID')
    };
    this.recommendationService.enrollmentOrderDetails = orderDetails;
    this.saveEnrollmentOrderDetails();
  }

  renameEnergyProviderName(itemName: string) {
    return itemName === '4ChangeEnergy' ? `${itemName.slice(1)}4` : itemName;
  }

  // postApiPulseEnrollmentResult(res) {
  //   if (res && res.Status === 'Error') {
  //     this.TrackFunction('Error:' + res.Message);
  //     this.validatePulsePowerErrorMessage(res.Message);
  //     this.residentialService.SendFailedEnrollment(this.orderDetails, res,res).subscribe((res: any) => {});
  //     this.SaveFailedOrder(res.Message);
  //   } else {
  //     this.pulsePowerPostResult = res;
  //     this.TrackFunction(this.pulsePowerPostResult.ConfirmationStatus);
  //     this.residentialService.setConfirmationStatusDetails = res;
  //     this.postResultNavigation[
  //       this.pulsePowerPostResult.ConfirmationStatus.replace(/\s/g, '')
  //     ]();
  //   }
  // }

  postApiRhythmEnrollmentResult(res) {
    if (res && res.Status === 'Error') {
      if(res.errors.filter(x => x.code == "deposit_required").length != 0)
      {
        var details = res.errors.filter(x => x.code == "deposit_required")[0].detail;
        var amt =  res.errors.filter(x => x.code == "deposit_required")[0].deposit_amount;
        this.postRhythmEnergyResult(res,true,amt);

      }else
      {
        this.residentialService.SendFailedEnrollment(this.orderDetails, res,res).subscribe((res: any) => {});
          this.validateRhythmEnergyErrorMessage(res);
          this.SaveFailedOrder(res);
      }
    } else {
      
      this.postRhythmEnergyResult(res,false,amt);
    }
  }

  postApiAPGEEnrollmentResult(res) {
    if (res && res.Status === 'Error') {
      this.TrackFunction('Error: ' + res.message)
      this.open4CEErrorTemplate(res.message)
      this.residentialService.SendFailedEnrollment(this.orderDetails, res,res).subscribe((res: any) => {});
      this.SaveFailedOrder(res.message);
    } else {
      
      this.postAPGEEnergyResult(res);
    }
  }

  postApiShellEnrollmentResult(res) {

    
    try{
      const apiResponse = JSON.parse(res.APIresponse);
      if(apiResponse != null && apiResponse.Message != undefined && apiResponse.Message != "" && apiResponse.Message != null)
      {
        this.TrackFunction('Error: ' + apiResponse.Message)
        this.open4CEErrorTemplate(apiResponse.Message);
        this.residentialService.SendFailedEnrollment(this.orderDetails, res.APIresponse,res.APIresponse,res.APIrequest).subscribe((res: any) => {});
        this.SaveFailedOrder(apiResponse.Message);
  
      }else if(apiResponse != null &&  apiResponse.detail != undefined && apiResponse.detail != "" && apiResponse.detail != null)
      {
        this.TrackFunction('Error: ' + apiResponse.detail)
        this.open4CEErrorTemplate(apiResponse.detail);
        this.residentialService.SendFailedEnrollment(this.orderDetails, res.APIresponse,res.APIresponse,res.APIrequest).subscribe((res: any) => {});
        this.SaveFailedOrder(apiResponse.detail);
  
      }else
      {
        if(apiResponse != null &&  apiResponse.OrderStatus && (apiResponse.OrderStatus.OrderStatus == "" || apiResponse.OrderStatus.OrderNumber == "" || apiResponse.OrderStatus.OrderStatus == "Expired"))
        {
          var msg = apiResponse.OrderStatus.Message == null || apiResponse.OrderStatus.Message == "" ? 'N/A' : apiResponse.OrderStatus.Message
          this.TrackFunction('Error: ' + msg)
          this.open4CEErrorTemplate(msg);
          this.residentialService.SendFailedEnrollment(this.orderDetails, res.APIresponse,res.APIresponse,res.APIrequest).subscribe((res: any) => {});
          this.SaveFailedOrder(msg);
        }
        
        else
        {
          this.postShellEnergyResult(res.APIresponse);

        }
      }

    }
    catch(e)
    {
      this.TrackFunction('Error: ' + res.APIresponse)
      this.open4CEErrorTemplate(res.APIresponse);
      this.residentialService.SendFailedEnrollment(this.orderDetails, res.APIresponse,res.APIrequest).subscribe((res: any) => {});
      this.SaveFailedOrder(res.APIresponse);
    }
    

  }


  editnavigt(confmType) {
    const elemt = document.querySelectorAll('.active');
    if (elemt !== null) {
      for (let j = 0; j < elemt.length; ++j) {
        elemt[j].classList.remove('active');
      }
    }
    const confmTabValue = document.getElementById('confirm_click');
    confmTabValue.classList.add('active');
    const confirmEleObj = document.getElementById(confmType);
    confirmEleObj.classList.remove('fade');
    confirmEleObj.classList.add('active');
    this.getOrderDetails('confirm_address');
  }

 

  validateRhythmEnergyErrorMessage(er) {

    var result = " ";

    if (er != null)
    {
        if(er.errors.filter(x => x.code == "deposit_required").length != 0)
        {

          var details = er.errors.filter(x => x.code == "deposit_required")[0].detail;
          var amt =  er.errors.filter(x => x.code == "deposit_required")[0].deposit_amount;
           result = "Deposit Required_" + amt + "_" + details;
           this.TrackFunction(result)
        }
        else
        {

          er.errors.forEach(item => {
      
            result += " * ";
              

            if(item.detail != null)
            {

                result +=  item.detail;
            }

            result += " <br/>";
      
          });

          this.TrackFunction(result)
        }

    }

    this.open4CEErrorTemplate(result);
  }

  validatePulsePowerErrorMessage(message: string) {
    if (
      message.search(
        `RateID:, ${this.orderDetails['selectedProduct'].ProductID} was not found`
      ) !== -1 ||
      message.search(
        `Rate:, ${this.orderDetails['selectedProduct'].energy_charge} does not match with a RateID of ${this.orderDetails['selectedProduct'].ProductID}`
      ) !== -1
    )
      this.setEnergyProvidersPlanFailed();
    else this.open4CEErrorTemplate(message);
  }



  postPulsePowerOrderDetailsAPI() {
    this.sendMessagesAfterPulseEnrollment();
    this.assignOrderDetailsForPulse();
    this.saveEnrollmentOrderDetails();
  }

  saveEnrollmentOrderDetails() {
    const orderDetails = this.recommendationService.enrollmentOrderDetails;
    const body = new HttpParams().append(
      'orderDetails',
      JSON.stringify(orderDetails)
    ).append(
      'AbondonedId',
      (sessionStorage.getItem('_abandonedid') == null || sessionStorage.getItem('_abandonedid') == "" || 
      sessionStorage.getItem('_abandonedid') == undefined ? null : sessionStorage.getItem('_abandonedid'))
    );
    this.http.post(this.url + '/saveorders', body).subscribe((res: any) => {
      res;
      this.sendCongratsMail();
      this.router.navigate([
        this.redirectionLink,
        this.recommendationService.hg_accountId,
      ]);
    });
  }

  saveEnrollmentOrderDetailsForPendingDeposit() {
    const orderDetails = this.recommendationService.enrollmentOrderDetails;
    const body = new HttpParams().append(
      'orderDetails',
      JSON.stringify(orderDetails)
      ).append(
        'AbondonedId',
        (sessionStorage.getItem('_abandonedid') == null || sessionStorage.getItem('_abandonedid') == "" || 
        sessionStorage.getItem('_abandonedid') == undefined ? null : sessionStorage.getItem('_abandonedid'))
      );
    this.http.post(this.url + '/saveorders', body).subscribe((res: any) => {
      this.recommendationService.enrollmentOrderDetails.order_no = res.order_no;
      // this.securityDeposit = `$${this.pulsePowerPostResult.DepositAmount}`;
      // this.securityDepositText = `Pay the ${this.securityDeposit} deposit now`;
      // const template: ElementRef<any> = this.depositPending;
      // this.modalRef = this.modalService.show(
      //   template,
      //   Object.assign({}, { class: 'gray modal-small' })
      // );
    });
  }

  sendMessagesAfterPulseEnrollment() {
    var messageObj = {
      postResultStatus:
        this.residentialService.setConfirmationStatusDetails.ConfirmationStatus,
      msg: '',
      phoneno: this.phone_num,
      name: this.first_name,
      emailId: this.email_address,
      energyProvider: this.selectedProduct.energy_provider,
      accountNumber: '',
      productName: this.selectedProduct.product_key,
      isSendTextMessage: false,
      isSendEmail: false,
      emailSubject: '',
      emailTemplateName: '',
    };

    this.residentialService
      .SendMessagesAfterPostOfEnrollment(messageObj)
      .subscribe((res: any) => {
        console.log('Message Sent successfully: ', res);
      });
  }

  assignOrderDetailsForPulse() {
    let mainPhone = this.getPrimaryPhoneNumber(),
      isGetOrderRes = false,
      isNotificationRes = false;
    let serviceTypeDateDetails = this.getServiceTypeValues();
    this.selectedProduct.energy_provider_image =
      this.providerContact.ProviderCloudLogo;
    const orderDetails = {
      order_no: null,
      hg_accountId: this.hgAccountId,
      ConfirmationNumber:
        this.residentialService.setConfirmationStatusDetails.ConfirmationNumber,
      status:
        this.residentialService.setConfirmationStatusDetails.ConfirmationStatus,
      isDepositRequired: this.assignConfirmationStatus(
        this.residentialService.setConfirmationStatusDetails.ConfirmationStatus
      ),
      webStatus:
        this.residentialService.setConfirmationStatusDetails.ConfirmationStatus,
      reason:
        this.residentialService.setConfirmationStatusDetails
          .ConfirmationStatusMessage,
      creditCheckResults: this.assignConfirmationStatus(
        this.residentialService.setConfirmationStatusDetails.ConfirmationStatus
      ),
      customerId:
        this.residentialService.setConfirmationStatusDetails.ConfirmationNumber,
      enableSMSForHonest: this.enablesmshonest === false ? 'No' : 'Yes',
      enableSMSForChariot: this.enablesmschariot === true ? 'Yes' : 'No',
      ratePlanName: this.selectedProduct.product_key,
      serviceTypeDetails: serviceTypeDateDetails,
      contactInfo: {
        legalFirstName: this.first_name,
        legalLastName: this.last_name,
        emailId: this.email_address,
        phoneNo: mainPhone[0] + mainPhone[1] + mainPhone[2],
        language: this.language,
        dob: this.dob,
        authorizedRep: this.represnt,
      },
      esiid: this.residentialService.esiid,
      invoiceType: this.invoice,
      promoDetails: {
        hearusOption: this.hearusOption,
        promoeCode: this.promo_code,
      },
      privateDetails: {
        state: this.state,
        license: this.license,
      },
      billingAddress: JSON.parse(sessionStorage.getItem('billingAddress')),
      isExpired: false,
      ReceivedPromocode: this.residentialService.promoCode,
      UsedPromocode:
        this.residentialService.promoCode === 'TAP' ? 'TAP' : 'GORILLA',
      selectedProduct: this.selectedProduct,
      expirationDate: this.serviceTypeExpireDate(
        serviceTypeDateDetails.switchDate
      ),
      Affiliate: sessionStorage.getItem('_Affiliate') == undefined || sessionStorage.getItem('_Affiliate') == '' || sessionStorage.getItem('_Affiliate') == null? "" : sessionStorage.getItem('_Affiliate'),
      AffiliatePromo: sessionStorage.getItem('_Promo') == undefined || sessionStorage.getItem('_Promo') == '' || sessionStorage.getItem('_Promo') == null? "" : sessionStorage.getItem('_Promo'),
      AffiliateID: sessionStorage.getItem('_AffiliateID') == undefined || sessionStorage.getItem('_AffiliateID') == '' || sessionStorage.getItem('_AffiliateID') == null? "" : sessionStorage.getItem('_AffiliateID'),
      QuestionId: sessionStorage.getItem('QuestionUserID') == undefined || sessionStorage.getItem('QuestionUserID') == '' || sessionStorage.getItem('QuestionUserID') == null? "" : sessionStorage.getItem('QuestionUserID')
    };
    this.recommendationService.enrollmentOrderDetails = orderDetails;
  }
  assignConfirmationStatus(itemValue): string {
    return itemValue === 'Pending Deposit' || 'Pending Credit Check'
      ? itemValue
      : '';
  }

  updateNotificationObj() {
    this.enrollNotifyObj = this.userSettingsService.enrollNotificationObj;
    if (
      this.enrollNotifyObj &&
      (this.enrollNotifyObj.type === 'enrollment_not_completed' ||
        this.enrollNotifyObj.type === 'renewal')
    ) {
      this.queryObj._id = this.enrollNotifyObj._id;
      this.updateObj['esiid'] = this.enrollNotifyObj.esiid;
      this.queryObj.hg_accountId = this.enrollNotifyObj.hg_accountId;
      this.queryObj.hg_orders_id = this.enrollNotifyObj.hg_orders_id;
      this.updateObj['processCompleted'] = true;
      if (this.enrollNotifyObj.showNotification === true) {
        this.updateObj['showNotification'] = false;
      }
      const enrollbody = new HttpParams()
        .append('queryObj', JSON.stringify(this.queryObj))
        .append('updateObj', JSON.stringify(this.updateObj));
      this.http
        .post(this.url + '/updateNotification', enrollbody)
        .subscribe((res: any) => {
          const notifyresult = res;
          if (notifyresult.statusCode === '002') {
          } else {
            this.router.navigate([
              'user-settings',
              JSON.parse(sessionStorage.getItem('userObj'))._id,
            ]);
          }
        });
    }
  }

  sendCongratsMail() {
    const userObj = {
      hg_accountId: this.hgAccountId,
      esiid: localStorage.getItem('currentEsiid'),
      emailId: JSON.parse(sessionStorage.getItem('userObj')).emailId,
    };
    const body = new HttpParams()
      .append('userDetails', JSON.stringify(userObj))
      .append('providerContact', JSON.stringify(this.providerContact));
    this.http.post(this.url + '/congratsEmail', body).subscribe((res: any) => {
      this.spinner.hide();
      const result = res;
      this.ClearAbandonedId();
    });
  }

  getServiceTypeValues() {
    let serviceType, expiredDate, responses, switchObj, serviceTypeObj;

    if (!_.isEmpty(JSON.parse(sessionStorage.getItem('userResponse'))) && JSON.parse(sessionStorage.getItem('userResponse')) != null)
    {

    
    responses = JSON.parse(sessionStorage.getItem('userResponse'));
    this.userResponses = responses.userResponses;
    this.residentialService.userResponse['userResponses'] = this.userResponses;
    if (!_.isEmpty(this.userResponses)) {
      switchObj = _.findWhere(this.userResponses, {
        res_question_id: '002',
      });
      serviceType = switchObj.fieldValue;
      serviceTypeObj =
        this.loadServiceTypeObject[switchObj.fieldValue.replace(/\s/g, '')]();
      expiredDate = this.expiratonDateFromQuestion();
    }
    return {
      serviceType: serviceType,
      switchType: serviceTypeObj.switchType,
      switchDate: serviceTypeObj.startDate,
      moveInType: serviceTypeObj.switchType,
      expiredDate: expiredDate,
    };
  }
  else
  {
    var responses__ = JSON.parse(sessionStorage.getItem('sevrviceDetails'));
    switchObj = _.findWhere(responses__, {
      res_question_id: '002',
    });
    serviceType = switchObj.fieldValue;
    serviceTypeObj =
      this.loadServiceTypeObject[switchObj.fieldValue.replace(/\s/g, '')]();
    expiredDate = this.expiratonDateFromQuestion();
    
    return {
      serviceType: serviceType,
      switchType: serviceTypeObj.switchType,
      switchDate: serviceTypeObj.startDate,
      moveInType: serviceTypeObj.switchType,
      expiredDate: expiredDate,
    };
  }
    // return {
    //   serviceType: JSON.parse(sessionStorage.getItem('serviceType')),
    //   switchType:  this.loadServiceTypeObject[JSON.parse(sessionStorage.getItem('serviceType')).replace(/\s/g, '')](),
    //   switchDate: serviceTypeObj.startDate,
    //   moveInType: serviceTypeObj.switchType,
    //   expiredDate: expiredDate,
    // };


  }

  assignServiceTypeValuesForStandardSwitch(): any {

      if (!_.isEmpty(JSON.parse(sessionStorage.getItem('userResponse'))) && JSON.parse(sessionStorage.getItem('userResponse')) != null)
      {


      const obj = _.findWhere(this.userResponses, { res_question_id: '004' });
      let startDate,
        switchType = obj.fieldValue;
      if (switchType === 'Standard Switch') {
        startDate = 'Standard Switch';
      } else {
        const dateObj = _.findWhere(this.userResponses, {
          res_question_id: '005',
        });
        startDate = this.getServiceTypeDateObj(dateObj.fieldValue);
      }
      return { switchType: switchType, startDate: startDate };
    }
    else
    {
      var responses__ = JSON.parse(sessionStorage.getItem('sevrviceDetails'));
      const obj = _.findWhere(responses__, { res_question_id: '004' });
      let startDate,
        switchType = obj.fieldValue;
      if (switchType === 'Standard Switch') {
        startDate = 'Standard Switch';
      } else {
        const dateObj = _.findWhere(responses__, {
          res_question_id: '005',
        });
        startDate = this.getServiceTypeDateObj(dateObj.fieldValue);
      }
      return { switchType: switchType, startDate: startDate };
    }
  }

  assignServiceTypeValuesForNewService() {

    if (!_.isEmpty(JSON.parse(sessionStorage.getItem('userResponse'))) && JSON.parse(sessionStorage.getItem('userResponse')) != null)
    {


    const switchDateObj = _.findWhere(this.userResponses, {
      res_question_id: '007',
    });
    let switchType, startDate;
    if (!_.isEmpty(switchDateObj)) {
      switchType = switchDateObj.startDateType;
      if (
        switchDateObj.startDateType &&
        switchDateObj.startDateType === 'Priority Move-In'
      ) {
        startDate = 'Priority Move-In';
      } else {
        const someDate = new Date();
        someDate.setDate(someDate.getDate() + 2);
        startDate =
          new Date(switchDateObj.fieldValue) < someDate
            ? 'Priority Move-In'
            : this.getServiceTypeDateObj(switchDateObj.fieldValue);
      }
    }
    return { switchType: switchType, startDate: startDate };
  } else
  {
    var responses__ = JSON.parse(sessionStorage.getItem('sevrviceDetails'));
   
    const switchDateObj = _.findWhere(responses__, {
      res_question_id: '007',
    });
    let switchType, startDate;
    if (!_.isEmpty(switchDateObj)) {
      switchType = switchDateObj.startDateType;
      if (
        switchDateObj.startDateType &&
        switchDateObj.startDateType === 'Priority Move-In'
      ) {
        startDate = 'Priority Move-In';
      } else {
        const someDate = new Date();
        someDate.setDate(someDate.getDate() + 2);
        startDate =
          new Date(switchDateObj.fieldValue) < someDate
            ? 'Priority Move-In'
            : this.getServiceTypeDateObj(switchDateObj.fieldValue);
      }
    }
    return { switchType: switchType, startDate: startDate };

  }
  }

  getServiceTypeDateObj(dateObj) {
    return this.selectedProduct.energy_provider === '4Change Energy'
      ? new Date(dateObj).getFullYear() +
          '-' +
          this.pad(new Date(dateObj).getMonth() + 1) +
          '-' +
          new Date(dateObj).getDate()
      : this.pad(new Date(dateObj).getMonth() + 1) +
          '/' +
          new Date(dateObj).getDate() +
          '/' +
          new Date(dateObj).getFullYear();
  }

  expiratonDateFromQuestion() {
    let expiredDate;
    const expireObj = _.findWhere(this.userResponses, {
      res_question_id: '003',
    });
    if (!_.isEmpty(expireObj) && typeof expireObj.fieldValue !== 'string') {
      const date = JSON.parse(expireObj.fieldValue.date);
      expiredDate = this.getServiceTypeDateObj(date);
    } else if (
      !_.isEmpty(expireObj) &&
      typeof expireObj.fieldValue === 'string'
    ) {
      expiredDate = expireObj.fieldValue;
    }
    return expiredDate !== undefined ? expiredDate : '';
  }

  serviceTypeExpireDate(startDate) {
    let term = this.recommendationService.signupProduct.terms,
      expiredDate =
        startDate !== 'Priority Move-In' && startDate !== 'Standard Switch'
          ? new Date(startDate)
          : new Date();
    expiredDate.setMonth(expiredDate.getMonth() + parseInt(term));
    return this.suffixDateTimeToSelectedSwitchDate(expiredDate);
  }

  moveInRequestedServiceDate(itemValue) {
    if (itemValue === 'Priority Move-in') {
      const someDate = new Date();
      return this.getServiceTypeDateObj(
        someDate.setDate(someDate.getDate() + 2)
      );
    }
  }

  getPrimaryPhoneNumber() {
    return this.orderDetails.contactInfo.phoneNo
      ? this.orderDetails.contactInfo.phoneNo.split('-')
      : '';
  }

  assignNewDateForSelectedSwitchDate() {
    
    let newdate,
      selectedSwitchDate = sessionStorage.getItem('selectdSwitchDate');
    if (selectedSwitchDate === undefined || selectedSwitchDate === null || selectedSwitchDate === '' ) {
      // const currentDate = new Date(
      //   new Date().getTime() + 3 * 24 * 60 * 60 * 1000
      // );
      let currentDate = new Date(),
        endDate,
        noOfDaysToAdd = 3,
        count = 0;
      while (count < noOfDaysToAdd) {
        endDate = new Date(currentDate.setDate(currentDate.getDate() + 1));
        if (endDate.getDay() != 0 && endDate.getDay() != 6) {
          count++;
        }
      }
      newdate = this.suffixZeroToSelectedSwitchDate(endDate);
      // newdate = this.setDateValueFor4CE(
      //   endDate.getMonth() + 1,
      //   endDate.getDate(),
      //   endDate.getFullYear()
      // );
    } else if (selectedSwitchDate !== undefined) {
      newdate =
        this.deviceWidth > 768 //&& this.navigatorBrowser === 'Chrome'
          ? this.suffixZeroToSelectedSwitchDate(new Date(selectedSwitchDate))
          : this.setSwitchDateForMobile(selectedSwitchDate);
    } else {
      newdate = '0' + selectedSwitchDate;
    }
    return newdate;
  }

  setSwitchDateForMobile(itemValue) {
    let endDate;
    if (this.deviceWidth < 768 || this.navigatorBrowser === 'Safari') {
      const model = itemValue.split(' ');
      if (model.length > 2) {
        endDate = this.suffixZeroToSelectedSwitchDate(new Date(itemValue));
      } else {
        const modelDate = model[0];
        endDate = new Date(modelDate);
        if (this.deviceWidth < 768)
          endDate.setDate(new Date(endDate).getDate() + 1);
      }
      return endDate;
    }
  }

  setDateValueFor4CE(month, day, year) {
    return this.selectedProduct.energy_provider === '4Change Energy'
      ? `${year}-${this.pad(month)}-${this.pad(day)}`
      : `${this.pad(month)}/${this.pad(day)}/${year}`;
  }

  suffixZeroToSelectedSwitchDate(d) {
    let newDate;
    if (new Date(d) < new Date()) d = new Date();
    newDate = this.setDateValueFor4CE(
      `${d.getMonth() + 1}`,
      `${d.getDate()}`,
      `${d.getFullYear()}`
    );
    return newDate;
  }

  suffixDateTimeToSelectedSwitchDate(expiredDate) {
    var d = new Date(expiredDate);
    return this.selectedProduct.energy_provider === '4Change Energy'
      ? d.getFullYear() + '-' + this.pad(d.getMonth() + 1) + '-' + d.getDate()
      : [d.getMonth() + 1, d.getDate(), d.getFullYear()].join('/') +
          ' ' +
          [d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds()].join(':');
  }

  createChariotEnergyPostObject() {
    let ssnDetails,
      sstchValue,
      newDate,
      postObject,
      serviceAddressDetails = this.orderDetails.billingAddress.userAddress,
      mainPhone = this.getPrimaryPhoneNumber(),
      billingAddress = this.getBillingAddressDetails();

    ssnDetails = this.getSSNNumber();
    sstchValue = this.getSwitchTypeValue();
    newDate = this.assignNewDateForSelectedSwitchDate();

    this.invoice = this.invoiceDetails[this.invoice];

    sstchValue = sstchValue === 'TURN_ON' ? 'moving' : 'Switching';

    sstchValue =
      sessionStorage.getItem('serviceType') &&
      sessionStorage.getItem('serviceType') == 'New Service'
        ? 'moving'
        : 'Switching';
    let stswitch = this.assignSelectedSwitchValue(sstchValue);
    const isSMSOption = this.enablesmschariot === true ? 'Yes' : 'No';
    sessionStorage.setItem('enablesmschariot', isSMSOption);
    const serviceStartDate =
      stswitch === 'Standard Switch' ? 'Standard Switch' : newDate;
    postObject = {
      Key: this.providerContact.AccessKeyValue,
      Zip: serviceAddressDetails.zipcode,
      PromoCode: this.providerContact.PromoCode,
      UtilityName: this.getUtilityName(
        this.orderDetails['selectedProduct'].utility_name
      ),
      CustomerTypeID: this.providerContact.CustomerTypeID,
      ProductID: this.orderDetails['selectedProduct'].ProductID,
      FirstName: this.tempfirstName
        ? this.tempfirstName
        : this.orderDetails.contactInfo.legalFirstName,
      LastName: this.templastName
        ? this.templastName
        : this.orderDetails.contactInfo.legalLastName,
      AuthorizedUserName: this.represnt
        ? this.represnt
        : this.orderDetails.contactInfo.legalFirstName,
      AuthorizedUserRelationship: '',
      AuthorizedPhoneNumber: mainPhone[0] + mainPhone[1] + mainPhone[2],
      PhoneNumber: mainPhone[0] + mainPhone[1] + mainPhone[2],
      SecondaryPhoneNumber: '',
      EmailAddress: this.email_address
        ? this.email_address
        : JSON.parse(sessionStorage.getItem('userObj')).emailId,
      BillDeliverMethodID: this.invoice,
      Howdidyouhear: '',
      HowdidyouhearDes: '',
      languagePreference:
        this.orderDetails.contactInfo.language == 'Language Preference'
          ? 'English'
          : 'English',
      IsSMS: isSMSOption ? isSMSOption : 'Yes',
      IsPromoInterested: 'Yes',
      SSN:
        ssnDetails[0] +
        (ssnDetails[1] != undefined ? ssnDetails[1] : '') +
        (ssnDetails[2] != undefined ? ssnDetails[2] : ''),
      DriversLicence: '',
      DriversLicenceState: '',
      ByPassCreditCheck: 'No',
      DOB: this.residentialService.setDateValueForChariot(
        this.orderDetails.contactInfo.dob
      ),
      ESIID: this.residentialService.esiid,
      MemberId: '',
      ServiceStartDate: serviceStartDate,
      ServiceType: sstchValue,
      IsAccountHolder: this.accountoption ? this.accountoption : 'Yes',
      BillingAddressTypeID: 'Yes',
      BillingAddress: billingAddress.billingAddressDetails.street_address,
      BillingState: billingAddress.billingAddressDetails.state,
      BillingUnit:
        billingAddress.billingAddressApt != undefined
          ? billingAddress.billingAddressApt.trim()
          : '',
      BillingCity: billingAddress.billingAddressDetails.city,
      BillingZipcode: billingAddress.billingAddressDetails.zipcode,
      AutoPay: 'No',
      AutopayType: '',
      AccountType: '',
      NameOnAccount: '',
      RoutingNumber: '',
      AccountNumber: '',
      CreditCardName: '',
      CreditCardNumber: '',
      CreditCardExpirationMonth: '',
      CreditCardExpirationYear: '',
      CreditCardCVC: '',
      CreditCardBillingAddressTypeID: '',
      CreditCardAddress: '',
      CreditCardState: '',
      CreditCardCity: '',
      CreditCardUnit: '',
      CreditCardZipcode: '',
      PayDeposit: '',
      DepositCardNumber: '',
      DepositCardExpirationMonth: '',
      DepositCardExpirationYear: '',
      DepositCVC: '',
      DepositBillingAddress: '',
      DepositUnit: '',
      DepositState: '',
      DepositZip: '',
      DepositCity: '',
      waivedReason: '',
      SendViaEmail: '',
      UserName: '',
      Password: '',
      ConfirmPassword: '',
      SecurityQuestion: '',
      SecurityAnswer: '',
    };
    sessionStorage.setItem('chariotPostObject', JSON.stringify(postObject));
    return postObject;
    }

    createBKVEnergyPostObject() {
        
        let ssnDetails,
            sstchValue,
            newDate,
            postObject,
            serviceAddressDetails = this.orderDetails.billingAddress.userAddress,
            mainPhone = this.getPrimaryPhoneNumber(),
            billingAddress = this.getBillingAddressDetails();

        ssnDetails = this.getSSNNumber();
        sstchValue = this.getSwitchTypeValue();
        newDate = this.assignNewDateForSelectedSwitchDate();

        //this.invoice = this.BKVinvoiceDetails[this.invoice];

        sstchValue = sstchValue === 'TURN_ON' ? 'moving' : 'Switching';

        sstchValue =
            sessionStorage.getItem('serviceType') &&
                sessionStorage.getItem('serviceType') == 'New Service'
                ? 'moving'
                : 'Switching';
        let stswitch = this.assignSelectedSwitchValue(sstchValue);
        const isSMSOption = this.enablesmschariot === true ? 'Yes' : 'No';
        sessionStorage.setItem('enablesmschariot', isSMSOption);
        const serviceStartDate =
            stswitch === 'Standard Switch' ? 'Standard Switch' : newDate;
        postObject = {
            Key: this.providerContact.AccessKeyValue,
            Zip: serviceAddressDetails.zipcode,
            PromoCode: this.providerContact.PromoCode,
            Term: this.orderDetails['selectedProduct'].terms,
            UtilityName: this.getUtilityName(
                this.orderDetails['selectedProduct'].utility_name
            ),
            CustomerTypeID: this.providerContact.CustomerTypeID,
            ProductID: this.orderDetails['selectedProduct'].ProductID != null && this.orderDetails['selectedProduct'].ProductID != undefined ? 
                this.orderDetails['selectedProduct'].ProductID.indexOf('_') ? this.orderDetails['selectedProduct'].ProductID.split('_')[0] : this.orderDetails['selectedProduct'].ProductID : "" ,
            FirstName: this.tempfirstName
                ? this.tempfirstName
                : this.orderDetails.contactInfo.legalFirstName,
            LastName: this.templastName
                ? this.templastName
                : this.orderDetails.contactInfo.legalLastName,
            AuthorizedUserName: this.represnt
                ? this.represnt
                : this.orderDetails.contactInfo.legalFirstName,
            AuthorizedUserRelationship: '',
            IsAuthorizedUser: "yes",
            AuthorizedPhoneNumber: mainPhone[0] + mainPhone[1] + mainPhone[2],
            PhoneNumber: mainPhone[0] + mainPhone[1] + mainPhone[2],
            SecondaryPhoneNumber: '',
            EmailAddress: this.email_address
                ? this.email_address
                : JSON.parse(sessionStorage.getItem('userObj')).emailId,
            BillDeliveryMethod: this.BKVinvoiceDetails[this.invoice],
            Howdidyouhear: '',
            HowdidyouhearDes: '',
            // LanguagePreference:
            //     this.orderDetails.contactInfo.language == 'Language Preference'
            //         ? 'English'
            //         : 'English',
                    LanguagePreference:
                this.orderDetails.contactInfo.language,
                    
            IsSMS: isSMSOption ? isSMSOption : 'Yes',
            IsPromoInterested: 'Yes',
            SSN:
                ssnDetails[0] +
                (ssnDetails[1] != undefined ? ssnDetails[1] : '') +
                (ssnDetails[2] != undefined ? ssnDetails[2] : ''),
            DriversLicence: '',
            DriversLicenceState: '',
            ByPassCreditCheck: 'No',
            DOB: this.residentialService.setDateValueForChariot(
                this.orderDetails.contactInfo.dob
            ),
            ESIID: this.residentialService.esiid,
            //MemberId: '',
            ServiceStartDate: serviceStartDate,
            ServiceType: sstchValue,
            IsAccountHolder: this.accountoption ? this.accountoption : 'Yes',
            SameAsServiceAddress: 'Yes',
            BillingAddress: billingAddress.billingAddressDetails.street_address,
            BillingState: billingAddress.billingAddressDetails.state,
            BillingUnit:
                billingAddress.billingAddressApt != undefined
                    ? billingAddress.billingAddressApt.trim()
                    : '',
            BillingCity: billingAddress.billingAddressDetails.city,
            BillingZipcode: billingAddress.billingAddressDetails.zipcode,
            AutoPay: 'No',
            AutopayType: '',
            AccountType: '',
            NameOnAccount: '',
            RoutingNumber: '',
            AccountNumber: '',
            CreditCardName: '',
            CreditCardNumber: '',
            CreditCardExpirationMonth: '',
            CreditCardExpirationYear: '',
            CreditCardCVC: '',
            CreditCardBillingAddressTypeID: '',
            CreditCardAddress: '',
            CreditCardState: '',
            CreditCardCity: '',
            CreditCardUnit: '',
            CreditCardZipcode: '',
            PayDeposit: '',
            DepositCardNumber: '',
            DepositCardExpirationMonth: '',
            DepositCardExpirationYear: '',
            DepositCVC: '',
            DepositBillingAddress: '',
            DepositUnit: '',
            DepositState: '',
            DepositZip: '',
            DepositCity: '',
            waivedReason: '',
            SendViaEmail: '',
            UserName: '',
            Password: '',
            ConfirmPassword: '',
            SecurityQuestion: '',
            SecurityAnswer: '',
        };

      //   postObject = {
      //   "Key": "CT1b-Gmw2LQaS-pZFc",
      //   "Zip": "77511",
      //   "PromoCode": "BANANAS10",
      //   "UtilityName": "Texas New Mexico Power",
      //   "CustomerTypeID": 1,
      //   "ProductID": "RN15000022",
      //   "FirstName": "BILLIE",
      //   "LastName": "BEATTY",
      //   "PhoneNumber": "1111111111",
      //   "SecondaryPhoneNumber": "",
      //   "EmailAddress": "testingemail745@gmail.com",
      //   "BillDeliveryMethod": "Paper Billing",
      //   "LanguagePreference": "English",
      //   "IsSMS": "no",
      //   "IsPromoInterested": "no",
      //   "SSN": "666730809",
      //   "DOB": "12/12/1990",
      //   "ESIID": "",
      //   "ServiceStartDate": "04/23/2019",
      //   "ServiceType": "Switching",
      //   "DriversLicence": "",
      //   "DriversLicenceState": "",
      //   "ByPassCreditCheck": "no",
      //   "IsAuthorizedUser": "yes",
      //   "AuthorizedPhoneNumber": "",
      //   "AuthorizedEmailAddress": "",
      //   "AuthorizedUserName": "",
      //   "SameAsServiceAddress": "no",
      //   "BillingAddress": "",
      //   "BillingState": "",
      //   "BillingUnit": "",
      //   "BillingCity": "",
      //   "BillingZipcode": "",
      //   "AutoPay": "no",
      //   "AutopayType": "Credit Card",
      //   "AccountType": "Savings",
      //   "NameOnAccount": "",
      //   "RoutingNumber": "",
      //   "AccountNumber": "",
      //   "CreditCardName": "",
      //   "CreditCardNumber": "",
      //   "CreditCardExpirationMonth": "January",
      //   "CreditCardExpirationYear": "2019",
      //   "CreditCardCVC": "",
      //   "CreditCardBillingAddressTypeID": "no",
      //   "CreditCardAddress": "",
      //   "CreditCardState": "",
      //   "CreditCardCity": "",
      //   "CreditCardUnit": "",
      //   "CreditCardZipcode": "",
      //   "PayDeposit": "",
      //   "DepositCardNumber": "",
      //   "DepositCardExpirationMonth": "January",
      //   "DepositCardExpirationYear": "2019",
      //   "DepositCVC": "",
      //   "DepositBillingAddress": "",
      //   "DepositUnit": "",
      //   "DepositState": "",
      //   "DepositZip": "",
      //   "DepositCity": "",
      //   "waivedReason": "",
      //   "SendViaEmail": "no",
      //   "IsEmailFax": false,
      //   "UserName": "",
      //   "Password": "",
      //   "ConfirmPassword": "",
      //   "SecurityQuestion": "",
      //   "SecurityAnswer": "",
      //   "MemberId": "",
      //   "Howdidyouhear": "",
      //   "HowdidyouhearDes": ""
      // };

        sessionStorage.setItem('BKVPostObject', JSON.stringify(postObject));
        return postObject;
    }

  createRhythmEnergyPostObject() {
    let ssnDetails,
      sstchValue,
      newDate,
      postObject,
      CreditCheckObject,
      premisesObject,
      serviceAddressDetails = this.orderDetails.billingAddress.userAddress,
      mainPhone = this.getPrimaryPhoneNumber(),
      billingAddress = this.getBillingAddressDetails();

    ssnDetails = this.getSSNNumber();
    sstchValue = this.getSwitchTypeValue();
    newDate = this.assignNewDateForSelectedSwitchDate();

    this.invoice = this.invoiceDetails[this.invoice];

    sstchValue = sstchValue === 'TURN_ON' ? 'MOVE_IN' : 'SWITCH';

    sstchValue =
      sessionStorage.getItem('serviceType') &&
      sessionStorage.getItem('serviceType') == 'New Service'
        ? 'MOVE_IN'
        : 'SWITCH';
    let stswitch = this.assignSelectedSwitchValue(sstchValue);

    const serviceStartDate =
      stswitch === 'Standard Switch' ? 'Standard Switch' : newDate;

    postObject = [
     
      CreditCheckObject = {

      first_name: this.tempfirstName
        ? this.tempfirstName
        : this.orderDetails.contactInfo.legalFirstName,
      last_name: this.templastName
        ? this.templastName
        : this.orderDetails.contactInfo.legalLastName,
      date_of_birth: this.residentialService.setDateValueForChariot(
          this.orderDetails.contactInfo.dob
        ),
      phone: mainPhone[0] + mainPhone[1] + mainPhone[2],
      email: this.email_address
        ? this.email_address
        : JSON.parse(sessionStorage.getItem('userObj')).emailId,
      
   
     
      address_line: billingAddress.billingAddressDetails.street_address,
      state: billingAddress.billingAddressDetails.state,
      secondary_line:
        billingAddress.billingAddressApt != undefined
          ? billingAddress.billingAddressApt.trim()
          : '',
      city: billingAddress.billingAddressDetails.city,
      zip_code: billingAddress.billingAddressDetails.zipcode,
      
      sales_agent: "",
      sales_event: "",
      sales_org_id: "",
      sales_org_name: "",
      // acquisition_medium: "",
      // acquisition_source: "",
      // acquisition_campaign: "",
      // rhythm_campaign_slug: "",
     acquisition_medium: "affiliate",
     acquisition_source: "Honest Gorilla",
     acquisition_campaign: "API",
     rhythm_campaign_slug: "affiliate",
      ssn:
      ssnDetails[0] +
      (ssnDetails[1] != undefined ? ssnDetails[1] : '') +
      (ssnDetails[2] != undefined ? ssnDetails[2] : ''),
      offer_snapshot: this.orderDetails['selectedProduct'].ProductID,
      },
      premisesObject = {
    
        meter_id: this.residentialService.esiid,
        enrollment_type: sstchValue,
        offer_snapshot: this.orderDetails['selectedProduct'].ProductID,
        service_start_date : serviceStartDate
        
      }
  
  ];

    return postObject;
  }

  createAPGEEnergyPostObject() {
    let ssnDetails,
      sstchValue,
      newDate,
      postObject,
      CreditCheckObject,
      enrollmentOject,
      serviceAddressDetails = this.orderDetails.billingAddress.userAddress,
      mainPhone = this.getPrimaryPhoneNumber(),
      billingAddress = this.getBillingAddressDetails();

    ssnDetails = this.getSSNNumber();
    sstchValue = this.getSwitchTypeValue();
    newDate = this.assignNewDateForSelectedSwitchDate();

    sstchValue = sstchValue === 'TURN_ON' ? 'MOVE_IN' : 'SWITCH';

    sstchValue =
      sessionStorage.getItem('serviceType') &&
      sessionStorage.getItem('serviceType') == 'New Service'
        ? 'MOVE_IN'
        : 'SWITCH';
    let stswitch = this.assignSelectedSwitchValue(sstchValue);

    const serviceStartDate =
      stswitch === 'Standard Switch' ? 'Standard Switch' : newDate;

      var invoice = this.APGEinvoiceDetails[this.invoice];
      this.invoice = this.APGEinvoiceDetails[this.invoice];
    postObject = [
     
      CreditCheckObject = {

      FullName: (this.tempfirstName
        ? this.tempfirstName
        : this.orderDetails.contactInfo.legalFirstName) + " " + (this.templastName
        ? this.templastName
        : this.orderDetails.contactInfo.legalLastName),

      AddressLine1: serviceAddressDetails.street_address,
      State: serviceAddressDetails.state,
      City: serviceAddressDetails.city,
      ZipCode: serviceAddressDetails.zipcode,
      LdcAccountNum: this.residentialService.esiid,
      Residential: true,
      SSN:
        ssnDetails[0] + 
        (ssnDetails[1] != undefined ? ssnDetails[1] : '') + 
        (ssnDetails[2] != undefined ? ssnDetails[2] : ''),
      OfferCode: this.orderDetails['selectedProduct'].ProductID,
      },

      enrollmentOject = {
    
                    Esid : this.residentialService.esiid,
                    RevenueClass : "Residential",
                    FirstName : this.tempfirstName
                    ? this.tempfirstName
                    : this.orderDetails.contactInfo.legalFirstName,
                    LastName: this.templastName
                    ? this.templastName
                    : this.orderDetails.contactInfo.legalLastName,
                    OfferCode : this.orderDetails['selectedProduct'].ProductID,
                    HomePhoneNumber: mainPhone[0] + mainPhone[1] + mainPhone[2],
                    WorkPhoneNumber: "",
                    EmailAddress: this.email_address
                    ? this.email_address
                    : JSON.parse(sessionStorage.getItem('userObj')).emailId,
                    CreditScore: "",
                    ContactName: "",
                    ServiceAddress: serviceAddressDetails.street_address,
                    ServiceAddress2: '',
                    ServiceCity: serviceAddressDetails.city,
                    ServiceState: serviceAddressDetails.state,
                    ServiceCounty: "",
                    ServiceZipCode: serviceAddressDetails.zipcode,
                    DistributorName: this.orderDetails['selectedProduct'].APITDSP,
                    MailingAddress: billingAddress.billingAddressDetails.street_address,
                    MailingAddress2:  billingAddress.billingAddressApt != undefined
                    ? billingAddress.billingAddressApt.trim()
                    : '',
                    MailingCity: billingAddress.billingAddressDetails.city,
                    MailingState: billingAddress.billingAddressDetails.state,
                    MailingZipCode: billingAddress.billingAddressDetails.zipcode,
                    SecurityQuestion: "",
                    SecurityAnswer: "",
                    BirthDate: this.residentialService.setDateValueForChariot(
                      this.orderDetails.contactInfo.dob
                   ),
                    EnrollmentType: sstchValue == "MOVE_IN" ? "Move in" : "Switch",
                    NotificationPreference: invoice,
                    BillDeliveryMethod: invoice,
                    DepositAmount: "",
                    SocialSecurity:  ssnDetails[0] +
                    (ssnDetails[1] != undefined ? ssnDetails[1] : '') + 
                    (ssnDetails[2] != undefined ? ssnDetails[2] : ''),
                    RequestedStartDate: serviceStartDate,
                    Price: this.orderDetails['selectedProduct'].PriceID,
                    Language: this.orderDetails.contactInfo.language,
                    ServiceTypeDescription: "ELECTRIC",
                    CustomerContact: '',
                    CustomerContactType:  "Authorized User",
                    CustomerContactRelationship: '',
                    AuthorizationToken: '',
                    Source: "API"
        
      }
  
  ];

    return postObject;
  }

  createShellEnergyPostObject() {
    let ssnDetails,
      sstchValue,
      newDate,
      postObject,
      CreditCheckObject,
      enrollmentOject,
      serviceAddressDetails = this.orderDetails.billingAddress.userAddress,
      mainPhone = this.getPrimaryPhoneNumber(),
      billingAddress = this.getBillingAddressDetails();

    ssnDetails = this.getSSNNumber();

    var ssn =  ssnDetails[0] + 
    (ssnDetails[1] != undefined ? ssnDetails[1] : '') + 
    (ssnDetails[2] != undefined ? ssnDetails[2] : '');

   

    sstchValue = this.getSwitchTypeValue();
    newDate = this.assignNewDateForSelectedSwitchDate();

    sstchValue = sstchValue === 'TURN_ON' ? 'MOVE_IN' : 'SWITCH';

    sstchValue =
      sessionStorage.getItem('serviceType') &&
      sessionStorage.getItem('serviceType') == 'New Service'
        ? 'MOVE_IN'
        : 'SWITCH';
    let stswitch = this.assignSelectedSwitchValue(sstchValue);

    const serviceStartDate =
       newDate;

      var invoice = this.APGEinvoiceDetails[this.invoice];
      this.invoice = this.APGEinvoiceDetails[this.invoice];
  //   postObject = [
     
  //     CreditCheckObject = {

  //     FullName: (this.tempfirstName
  //       ? this.tempfirstName
  //       : this.orderDetails.contactInfo.legalFirstName) + " " + (this.templastName
  //       ? this.templastName
  //       : this.orderDetails.contactInfo.legalLastName),

  //     AddressLine1: serviceAddressDetails.street_address,
  //     State: serviceAddressDetails.state,
  //     City: serviceAddressDetails.city,
  //     ZipCode: serviceAddressDetails.zipcode,
  //     LdcAccountNum: this.residentialService.esiid,
  //     Residential: true,
  //     SSN:
  //       ssnDetails[0] + 
  //       (ssnDetails[1] != undefined ? ssnDetails[1] : '') + 
  //       (ssnDetails[2] != undefined ? ssnDetails[2] : ''),
  //     OfferCode: this.orderDetails['selectedProduct'].ProductID,
  //     },

  //     enrollmentOject = {
    
  //                   Esid : this.residentialService.esiid,
  //                   RevenueClass : "Residential",
  //                   FirstName : this.tempfirstName
  //                   ? this.tempfirstName
  //                   : this.orderDetails.contactInfo.legalFirstName,
  //                   LastName: this.templastName
  //                   ? this.templastName
  //                   : this.orderDetails.contactInfo.legalLastName,
  //                   OfferCode : this.orderDetails['selectedProduct'].ProductID,
  //                   HomePhoneNumber: mainPhone[0] + mainPhone[1] + mainPhone[2],
  //                   WorkPhoneNumber: "",
  //                   EmailAddress: this.email_address
  //                   ? this.email_address
  //                   : JSON.parse(sessionStorage.getItem('userObj')).emailId,
  //                   CreditScore: "",
  //                   ContactName: "",
  //                   ServiceAddress: serviceAddressDetails.street_address,
  //                   ServiceAddress2: '',
  //                   ServiceCity: serviceAddressDetails.city,
  //                   ServiceState: serviceAddressDetails.state,
  //                   ServiceCounty: "",
  //                   ServiceZipCode: serviceAddressDetails.zipcode,
  //                   DistributorName: this.orderDetails['selectedProduct'].APITDSP,
  //                   MailingAddress: billingAddress.billingAddressDetails.street_address,
  //                   MailingAddress2:  billingAddress.billingAddressApt != undefined
  //                   ? billingAddress.billingAddressApt.trim()
  //                   : '',
  //                   MailingCity: billingAddress.billingAddressDetails.city,
  //                   MailingState: billingAddress.billingAddressDetails.state,
  //                   MailingZipCode: billingAddress.billingAddressDetails.zipcode,
  //                   SecurityQuestion: "",
  //                   SecurityAnswer: "",
  //                   BirthDate: this.residentialService.setDateValueForChariot(
  //                     this.orderDetails.contactInfo.dob
  //                  ),
  //                   EnrollmentType: sstchValue == "MOVE_IN" ? "Move in" : "Switch",
  //                   NotificationPreference: invoice,
  //                   BillDeliveryMethod: invoice,
  //                   DepositAmount: "",
  //                   SocialSecurity:  ssnDetails[0] +
  //                   (ssnDetails[1] != undefined ? ssnDetails[1] : '') + 
  //                   (ssnDetails[2] != undefined ? ssnDetails[2] : ''),
  //                   RequestedStartDate: serviceStartDate,
  //                   Price: this.orderDetails['selectedProduct'].PriceID,
  //                   Language: this.orderDetails.contactInfo.language,
  //                   ServiceTypeDescription: "ELECTRIC",
  //                   CustomerContact: '',
  //                   CustomerContactType:  "Authorized User",
  //                   CustomerContactRelationship: '',
  //                   AuthorizationToken: '',
  //                   Source: "API"
        
  //     }


  
  // ];

  const RequestedStartDate = this.formatDate(serviceStartDate)
  const DOB = this.formatDate(this.residentialService.setDateValueForChariot(
    this.orderDetails.contactInfo.dob)
 )

  postObject = {
      BrokerAuthKeyFromAPI: "",
      ServiceAddress: {
      StreetAddress: serviceAddressDetails.street_address,
      City: serviceAddressDetails.city,
      State: serviceAddressDetails.state,
      PostalCode:  serviceAddressDetails.zipcode,
      ESIID: this.residentialService.esiid,
    },

    ProductFilter: {
        Utility: this.orderDetails['selectedProduct'].APITDSP,
        "Broker Code": "",
        "Promo Code": "",
        "Term Months": this.orderDetails['selectedProduct'].terms,
        "Plan Name": this.orderDetails['selectedProduct'].product_Name,
        "Priority": this.orderDetails['selectedProduct'].ProductID.split('_')[0]
    },

    BillingAddress: {
      StreetAddress: billingAddress.billingAddressDetails.street_address,
      City: billingAddress.billingAddressDetails.city,
      State: billingAddress.billingAddressDetails.state,
      PostalCode:  billingAddress.billingAddressDetails.zipcode,
    },
     CreditAddress: {
      StreetAddress: serviceAddressDetails.street_address,
      City: serviceAddressDetails.city,
      State: serviceAddressDetails.state,
      PostalCode:  serviceAddressDetails.zipcode,
    },

    Type: "New Enrollment",
    RequestedStartDate: RequestedStartDate ? RequestedStartDate : "",
    "Sales Person": "",
    MoveOrSwitch:  sstchValue == "MOVE_IN" ? "Move" : "Switch",
    CustomerFirstName:(this.tempfirstName
      ? this.tempfirstName
      : this.orderDetails.contactInfo.legalFirstName) ,
    CustomerLastName: this.templastName
    ? this.templastName
    : this.orderDetails.contactInfo.legalLastName,
    Phone: mainPhone[0] + mainPhone[1] + mainPhone[2],
    Mobile: "",
    Email: this.email_address
    ? this.email_address
    : JSON.parse(sessionStorage.getItem('userObj')).emailId,
    "Date of Birth": DOB ? DOB : "",
    "Security Question": "Last Four Digits of your Social Security Number",
    "Security Answer": (ssnDetails[2] != undefined ? ssnDetails[2] : ''),
    "Language Preference":this.orderDetails.contactInfo.language,
    "Authorized User": "",
    "Authorized User Relationship": "Friend",
    "Credit Check Authorization": true,
    EnrollmentAuthorization: true,
    DepositWaiverRequest: false,
    IsExternalCreditCheck: environment.production ? "false" : "true",
    ExternalCreditScore: environment.production ? "" : "850",
    ExternalCreditCheckBody: "",
    ThirdPartyConsent: "",
    SSN: ssn,
    BrandCode:"",
    PreviousAddress: {
      StreetAddress: billingAddress.billingAddressDetails.street_address,
      City: billingAddress.billingAddressDetails.city,
      State: billingAddress.billingAddressDetails.state,
      PostalCode:  billingAddress.billingAddressDetails.zipcode,
  },
}



    return postObject;
  }

  getBillingAddressDetails() {
    let billingAddressDetails, billingAddress_apartment;
    if (
      this.orderDetails.billingAddress.sameAsService === false &&
      this.orderDetails.billingAddress
    ) {
      billingAddressDetails =
        this.orderDetails.billingAddress.billingAddress.billingAddress;
      billingAddress_apartment =
        this.orderDetails.billingAddress.billingAddress.apartment;
    } else {
      billingAddressDetails = this.orderDetails.billingAddress.userAddress;
      billingAddress_apartment = this.orderDetails.billingAddress.apartment;
    }
    return {
      billingAddressDetails: billingAddressDetails,
      billingAddressApt: billingAddress_apartment,
    };
  }

  createPulsePowerPostObject() {
    let energyProviderName = 'Pulse Power',
      mainPhone = this.getPrimaryPhoneNumber(),
      ssnDetails = this.getSSNNumber(),
      newDate = this.assignNewDateForSelectedSwitchDate(),
      serviceTypeDetails = this.getServiceTypeValues(),
      sstchValue =
        serviceTypeDetails.serviceType === 'New Service'
          ? 'MoveIn'
          : 'Switching',
      requestedDateObj,
      postObject;

    postObject = {
      RateID: this.orderDetails['selectedProduct'].ProductID,
      Rate: this.orderDetails['selectedProduct'].energy_charge,
      PromoCode: this.providerContact.PromoCode,
      FirstName: this.tempfirstName
        ? this.tempfirstName
        : this.orderDetails.contactInfo.legalFirstName,
      LastName: this.templastName
        ? this.templastName
        : this.orderDetails.contactInfo.legalLastName,
      EmailAddress: this.email_address
        ? this.email_address
        : JSON.parse(sessionStorage.getItem('userObj')).emailId,
      MobilePhone: mainPhone[0] + mainPhone[1] + mainPhone[2],
      Esiid: this.residentialService.esiid,
      ServiceType: sstchValue,
      SSN: ssnDetails[0] + ssnDetails[1] + ssnDetails[2],
      Language: this.language,
      AuthorizedRep: this.represnt !== undefined ? this.represnt : '',
      MarketingEmails: false,
      MarketingPhoneCalls: false,
      Ebilling: this.checkEBilling(),
      PriorityMoveIn: this.getSwitchDateObject(),
    };
    if (sstchValue === 'MoveIn') {
      requestedDateObj = { RequestedDate: newDate };

      postObject = { ...postObject, ...requestedDateObj };
    }
    return postObject;
  }

  create4ChangeEnergyPostObject() {
    let energyProviderName = '4Change Energy',
      ssnDetails = this.getSSNNumber(),
      newDate = this.assignNewDateForSelectedSwitchDate(),
      serviceTypeDetails = this.getServiceTypeValues(),
      sstchValue =
        serviceTypeDetails.serviceType === 'New Service'
          ? 'MoveIn'
          : 'Switching',
      billingAddress = this.getBillingAddressDetails(),
      postObject,
      dob4CE = this.requiredDateFormatFor4CE(this.orderDetails.contactInfo.dob);

    postObject = {
      PartnerId: this.providerContact.CustomerTypeID,
      PartnerUserName: this.providerContact.AccessKeyName,
      PartnerPassword: this.providerContact.AccessKeyValue,
      FirstName: this.tempfirstName
        ? this.tempfirstName
        : this.orderDetails.contactInfo.legalFirstName,
      LastName: this.templastName
        ? this.templastName
        : this.orderDetails.contactInfo.legalLastName,
      Email: this.email_address
        ? this.email_address
        : JSON.parse(sessionStorage.getItem('userObj')).emailId,
      DateOfBirth: dob4CE,
      CreditCheckAddress: {
        Street1: billingAddress.billingAddressDetails.street_address,
        City: billingAddress.billingAddressDetails.city,
        StateName: billingAddress.billingAddressDetails.state,
        PostCode: billingAddress.billingAddressDetails.zipcode,
        Apt: billingAddress.billingAddressApt,
        EsiId: this.residentialService.esiid,
      },
      Ssn: ssnDetails[0] + ssnDetails[1] + ssnDetails[2],
    };
    return postObject;
  }
  requiredDateFormatFor4CE(dobDate: any) {
    // const dob = dobDate.split('-');
    // return `${dob[0]}-${dob[1]}-${dob[2].substr(0, 2)}`;
    const dob = moment(new Date(dobDate)).format('YYYY-MM-DD').toString();
    return dob;
  }

  createTexpoEnergyPostObject() {
    let ssnDetails = this.getSSNNumber(),
      newDate = this.assignNewDateForSelectedSwitchDate(),
      serviceTypeDetails = this.getServiceTypeValues(),
      sstchValue =
        serviceTypeDetails.serviceType === 'New Service' ? 'MOVEIN' : 'SWITCH',
      billingAddress = this.getBillingAddressDetails(),
      postObject;
    console.log(this.selectedProduct);
    postObject = {
      CompetitiveResellerKey: 'aad4bbbc-d357-4a3f-ab6a-435f14ccabdc',
      NeedsNewAccount: true,
      CurrentlyHasService: true,
      RatePlanKey: this.selectedProduct.ProductID,
      PromotionCode: 'GOR',
      EnrollmentDate: this.residentialService.getCurrentDatePerCST(),
      ServiceStartDate: newDate,
      ServiceProviderKey: '0a003528-8d7c-4785-b1c1-a328a7ce4e77',
      SiteCode: this.residentialService.esiid,
      SLAddressLineOne: billingAddress.billingAddressDetails.street_address,
      SLAddressLineTwo: '',
      SLCity: billingAddress.billingAddressDetails.city,
      SLState: billingAddress.billingAddressDetails.state,
      SLZip: billingAddress.billingAddressDetails.zipcode,
      SLZipPlusFour: '1620',
      SLApartmentName: billingAddress.billingAddressApt,
      PremiseType: 2,
      CustomerType: 1,
      CommodityType: 2,
      BAAddressLineOne: billingAddress.billingAddressDetails.street_address,
      BAAddressLineTwo: '',
      BACity: billingAddress.billingAddressDetails.city,
      BAState: billingAddress.billingAddressDetails.state,
      BAZip: billingAddress.billingAddressDetails.zipcode,
      BAZipPlusFour: '1620',
      CustomerName: `${
        this.tempfirstName
          ? this.tempfirstName
          : this.orderDetails.contactInfo.legalFirstName
      } ${
        this.templastName
          ? this.templastName
          : this.orderDetails.contactInfo.legalLastName
      }`,
      FirstName: this.tempfirstName
        ? this.tempfirstName
        : this.orderDetails.contactInfo.legalFirstName,
      MiddleInitial: null,
      LastName: this.templastName
        ? this.templastName
        : this.orderDetails.contactInfo.legalLastName,
      PrimaryPhone: this.phone_num1.replace(new RegExp('-', 'g'), ''),
      MobilePhone: this.phone_num1.replace(new RegExp('-', 'g'), ''),
      SecondaryPhone: '',
      Email: this.email_address
        ? this.email_address
        : JSON.parse(sessionStorage.getItem('userObj')).emailId,
      PreferredContactMethod: 1,
      SSN: ssnDetails[0] + ssnDetails[1] + ssnDetails[2],
      DateOfBirth: this.requiredDateFormatFor4CE(
        this.orderDetails.contactInfo.dob
      ),
      Pin: '1111',
      Language: this.language === 'English' ? 1 : 2,
      TaxGroup: 1,
      AccountType: 2,
      ServiceProviderCommodityKey: 'fd85ba01-530d-4ab7-9c9c-b0b8132af9e9',
    };
    return postObject;
  }

  createGEXAEnergyPostObject() {
    let ssnDetails = this.getSSNNumber(),
      newDate = this.assignNewDateForSelectedSwitchDate(),
      serviceTypeDetails = this.getServiceTypeValues(),
      sstchValue =
        serviceTypeDetails.serviceType === 'New Service' ? 'MOVEIN' : 'SWITCH',
      billingAddress = this.getBillingAddressDetails(),
      postObject;
    postObject = {
      Version: '1.0',
      PowerPricePlanID: this.selectedProduct.PricePlanID,
      GasPricePlanID: '',
      PowerTDSP:
        this.loadGEXAEnergyUtilityNames[this.selectedProduct.utility_name],
      GasTDSP: '',
      PowerProductID: this.selectedProduct.ProductID,
      GasProductID: '',
      PromoCode: '',
      FirstName: this.tempfirstName
        ? this.tempfirstName
        : this.orderDetails.contactInfo.legalFirstName,
      LastName: this.templastName
        ? this.templastName
        : this.orderDetails.contactInfo.legalLastName,
      Email: this.email_address
        ? this.email_address
        : JSON.parse(sessionStorage.getItem('userObj')).emailId,
      DateOfBirth: this.orderDetails.contactInfo.dob,
      ServiceAddress: billingAddress.billingAddressDetails.street_address,
      ServiceCity: billingAddress.billingAddressDetails.city,
      ServiceState: billingAddress.billingAddressDetails.state,
      ServiceZipCode: billingAddress.billingAddressDetails.zipcode,
      PowerMeterNum: this.residentialService.esiid,
      Ssn: ssnDetails[0] + ssnDetails[1] + ssnDetails[2],
      PhoneNum: this.phone_num1.replace(new RegExp('-', 'g'), ''),
      MobileNum: this.phone_num1.replace(new RegExp('-', 'g'), ''),
      ContactType: this.invoice,
      Language: this.language,
      EBill: this.checkEBilling(),
      SwitchMoveDate: newDate,
      SwitchMoveType: sstchValue,
      IsBillingSame: this.orderDetails.billingAddress.sameAsService,
      GasMeterNum: '',
      TpvNumber: '',
      DLState: '',
      DLNumber: '',
      PaperlessDocumentsYN: 'Y',
      PaperlessConsent: this.goPaperlessGexa ? 'Y' : ''
    };
    return postObject;
  }

  create4ChangeEnergyBeginCustomerPostObject() {
    let ssnDetails = this.getSSNNumber(),
      mainPhone = this.getPrimaryPhoneNumber(),
      newDate = this.assignNewDateForSelectedSwitchDate(),
      serviceTypeDetails = this.getServiceTypeValues(),
      billingAddress = this.getBillingAddressDetails(),
      requestedDateObj,
      sstchValue =
        serviceTypeDetails.serviceType === 'New Service' ? 'Move-in' : 'Switch';

    var beginCustomerEnrollmentRequest = {
      PartnerId: this.providerContact.CustomerTypeID,
      PartnerUserName: this.providerContact.AccessKeyName,
      PartnerPassword: this.providerContact.AccessKeyValue,
      FirstName: this.tempfirstName
        ? this.tempfirstName
        : this.orderDetails.contactInfo.legalFirstName,
      LastName: this.templastName
        ? this.templastName
        : this.orderDetails.contactInfo.legalLastName,
      Email: this.email_address
        ? this.email_address
        : JSON.parse(sessionStorage.getItem('userObj')).emailId,
      DateOfBirth: this.requiredDateFormatFor4CE(
        this.orderDetails.contactInfo.dob
      ),
      ServiceAddress: {
        Street2: billingAddress.billingAddressApt,
        Street1: billingAddress.billingAddressDetails.street_address,
        City: billingAddress.billingAddressDetails.city,
        StateName: billingAddress.billingAddressDetails.state,
        PostCode: billingAddress.billingAddressDetails.zipcode,
        EsiId: this.residentialService.esiid,
      },
      language: this.language,
      BillingSameAsService: this.orderDetails.billingAddress.sameAsService,
      EnrollmentType: sstchValue,
      ProductId: this.orderDetails['selectedProduct'].ProductID,
      WorkPhone: this.phone_num1.replace(new RegExp('-', 'g'), ''),
      HomePhone: this.phone_num1.replace(new RegExp('-', 'g'), ''),
      LdcId: this.ldcIds,
      CharityId: 1,
      DepositAmount: this.depositAmount4CE,
      DepositRequired: this.depositRequired4CE,
    };
    if (this.depositAmount4CE > 0) {
      beginCustomerEnrollmentRequest = {
        ...beginCustomerEnrollmentRequest,
        ...{ Ssn: ssnDetails[0] + ssnDetails[1] + ssnDetails[2] },
      };
    }
    if (sstchValue === 'Move-in') {
      requestedDateObj = { MoveInDate: newDate };
      beginCustomerEnrollmentRequest = {
        ...beginCustomerEnrollmentRequest,
        ...requestedDateObj,
      };
    }
    const postObject = {
      language: this.language,
      license: this.license !== undefined ? this.license : '',
      hearusOption: this.hearusOption,
      promoeCode: this.promo_code,
      authorizedRep: this.represnt !== undefined ? this.represnt : '',
      enableSMSForHonest: this.enablesmshonest,
      invoiceType: this.invoice,
    };
    this.residentialService.completeCustomerEnrollmentPostObject = {
      ...beginCustomerEnrollmentRequest,
      ...postObject,
    };
    this.residentialService.beginCustomerEnrollmentRequest =
      beginCustomerEnrollmentRequest;
    return beginCustomerEnrollmentRequest;
  }

  getTduIdForAllUtilityNames(utilityName: string): any {
    const ldcIds = JSON.parse(sessionStorage.getItem('tduRates'));
    ldcIds.map((ldcId) => {
      if (this.loadTduCodeDetails[utilityName] === ldcId.Code)
        this.ldcIds = ldcId.IstaId;
    });
  }
  getTduRatesForAllUtilityNames() {
    this.residentialService
      .getTduIdForAllUtilityNames()
      .subscribe((res: any) => {
        this.tduRates = res;
        sessionStorage.setItem('tduRates', JSON.stringify(this.tduRates));
      });
  }
  checkEBilling() {
    return this.invoice === 'Paperless' ? true : false;
  }

  getSSNNumber() {
    return this.orderDetails.privateDetails.ssn
      ? this.orderDetails.privateDetails.ssn.split('-')
      : this.orderDetails.privateDetails.ssn;
  }

  getSwitchDateObject() {
    const switchDateObj = _.findWhere(this.userResponses, {
      res_question_id: '007',
    });
    return switchDateObj && switchDateObj.startDateType === 'Priority Move-In'
      ? true
      : false;
  }

  validateAccountOption() {
    if (this.accountoption === '') {
      this.ngClass = false;
      this.disableBtn = true;
    }
  }
  getUtilityName(utility_name: string) {
    return this.utilityName[utility_name];
     
  }
  assignSelectedSwitchValue(serviceType: string) {
    let stswitch = '';
    if (serviceType === 'Switching') {

      if (!_.isEmpty(JSON.parse(sessionStorage.getItem('userResponse'))) && JSON.parse(sessionStorage.getItem('userResponse')) != null)
      {

        let ddata = JSON.parse(sessionStorage.getItem('userResponse'));
        const obj = _.findWhere(ddata.userResponses, {
          res_question_id: '004',
        });
        if (obj !== undefined && obj.fieldValue === 'Standard Switch') {
          stswitch = 'Standard Switch';
        } else if (
          sessionStorage.getItem('selectedSwitchValue') === 'Standard Switch'
        ) {
          stswitch = 'Standard Switch';
        }

      }
      else
      {

          var responses__ = JSON.parse(sessionStorage.getItem('sevrviceDetails'));
          const obj = _.findWhere(responses__, {
            res_question_id: '004',
          });
          if (obj !== undefined && obj.fieldValue === 'Standard Switch') {
            stswitch = 'Standard Switch';
          } else if (
            sessionStorage.getItem('selectedSwitchValue') === 'Standard Switch'
          ) {
            stswitch = 'Standard Switch';
          }


      }


    }



    return stswitch;
  }

  getSignupProduct() {
    if (_.isEmpty(this.recommendationService.signupProduct)) {
      this.recommendationService.signupProduct = JSON.parse(
        sessionStorage.getItem('signupProduct')
      );
    }
    return this.recommendationService.signupProduct;
  }

  getSwitchTypeValue() {
    let switchObj1 = {
      questionStatus: 'Completed',
      questionStep: '0031',
      type: 'Switching Providers',
    };
    if (
      sessionStorage.getItem('questionStatusObj') !== null ||
      sessionStorage.getItem('questionStatusObj') !== 'null' ||
      sessionStorage.getItem('questionStatusObj') !== undefined ||
      sessionStorage.getItem('questionStatusObj') !== 'undefined'
    ) {
      switchObj1 = JSON.parse(sessionStorage.getItem('questionStatusObj'));
    }
    if (switchObj1 && switchObj1.type)
      return (switchObj1.type = 'New Service' ? 'TURN_ON' : 'SWITCH');
    else return 'TURN_ON';
  }

  validateEsiidValue(orderDetails) {
    if (this.esiid_value) {
      if (this.esiid_value === 'ESI ID # Locator  Currently Unavailable') {
        this.esiid_value = localStorage.getItem('otherEsiid')
          ? localStorage.getItem('otherEsiid')
          : '';
        orderDetails['esiid'] = this.esiid_value;
      } else {
        localStorage.setItem('currentEsiid', this.esiid_value);
        orderDetails['esiid'] = this.esiid_value;
      }
    }
  }

  logPostCreatedData(itemType: string, message?: string) {
    const logObj = {
      type: itemType,
      message: this.messageType[itemType],
      data: message,
    };
    this.residentialService
      .postcreatelogdata(logObj)
      .subscribe((res: any) => {});
  }

  setEnergyProvidersPlanFailed() {
    let orderDetails = this.orderDetails;
    const userObj = {
      utilityName: this.selectedProduct.energy_provider,
    };
    this.residentialService
      .postApiPlanIdFailSaveToDB(userObj)
      .subscribe((res: any) => {});
    setTimeout(() => {
      this.assignNewEnergyProvidersRates();
    }, 30000);
  }

  openNewEnergyRatesModal(template: ElementRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-small' },this.ngbModalOptions)
    );
  }

  assignNewEnergyProvidersRates() {
    const user = {
      esiid: this.residentialService.esiid,
      questionStatusObj: JSON.parse(
        sessionStorage.getItem('questionStatusObj')
      ),
      questionnarieObj: JSON.parse(sessionStorage.getItem('userResponse')),
    };
    this.residentialService.getRecommendations(user).subscribe((result) => {
      this.recommendationService.recommendationObj =
        result['recommendedProduct'];
      sessionStorage.setItem(
        'recommendedProducts',
        JSON.stringify(result['recommendedProduct'])
      );
      const questionObj = sessionStorage.getItem('userResponseUpdated');
      if(questionObj != null)
      {
        sessionStorage.setItem('userResponse', questionObj);

      }
      this.openNewEnergyRatesModal(this.newEnergyRates);
    });
  }

  assignUserResponseToSession() {
    const questionObj = sessionStorage.getItem('userResponse')
      ? sessionStorage.getItem('userResponse')
      : sessionStorage.getItem('userResponseUpdated');

      var a  = JSON.parse(sessionStorage.getItem('widthoutQuestionUserRequest'));
      if(a != null)
      {
        
        sessionStorage.removeItem('userResponse');
      }else
      {
        sessionStorage.setItem('userResponse', questionObj);
  
      }


  }

  closeModal() {
    this.modalRef.hide();
  }

  newEnergyProviderRates() {
    sessionStorage.setItem(
      'currentUser',
      this.recommendationService.hg_accountId
    );
    this.modalRef.hide();
    this.router.navigate([
      'recommendation/compare-product',
      this.recommendationService.hg_accountId,
    ]);
  }

  openModal() {
    this.display = 'block';
  }

  onCloseHandled() {
    this.display = 'none';
  }

  shownext(id, formValid) {
    if (formValid && !this.validateMobileFields()) {
      // set the flag based on the value
      if (id === 'showInvoice') {
        this.showInvoice = true;
      } else if (id === 'showSec1') {
        this.showSec1 = true;
      } else if (id === 'showSec2') {
        this.showSec2 = true;
      }
    } else {
      this.validateAccountHolderAndLanguage();
    }

    setTimeout(() => {
      $("#" + id)[0].scrollIntoView();
    }, 500);

    if(this.deviceWidth < 768)
    {
      setTimeout(function(){

        $('ng-select').find('.ng-input').find('input').on('focus', function() { $(this).blur(); });
  
      },500)
    }
    
  }

  validateAccountHolderAndLanguage() {
    const languagePreference = document.getElementById('languagePreference');
    const accountHolder = document.getElementById('accountHolder');
    if (this.accountoption === '' || this.accountoption === undefined)
      accountHolder.classList.add('validateClass');
    if (this.language === '' || this.language === undefined)
      languagePreference.classList.add('validateClass');
  }

   ngAfterContentChecked(): void {
     if (
       this.accountoption != null &&
       this.accountoption != undefined &&
       this.accountoption != ''
     ) {
       var primaryaccount = document.getElementById('primaryaccount');
       if (primaryaccount != undefined && primaryaccount != null) {
         primaryaccount.classList.remove('disevent');
         primaryaccount.classList.remove('customngselectpink');
       }
     }

     if (this.dob != undefined) {
       var dateid = document.getElementById('enrollDate');
       if (dateid != undefined && dateid != null)
        {
          //$('#enrollDate').parents('mat-form-field').removeClass('disevent')
          this.dobinvalid = false;
          $('#enrollDateField_').removeClass('mat-form-field-invalid')
          
        }else
        {
         this.dobinvalid = true;
         $('#enrollDateField_').addClass('mat-form-field-invalid')


        }
         
     }else
     {
      this.dobinvalid = true;
      // $('#enrollDateField_').addClass('mat-form-field-invalid')
     }

     if((this.clickedOnce) && this.dobinvalid && (dateid == null || dateid == null))
     {
        $('#enrollDateField_').addClass('mat-form-field-invalid')
     }

     if($('#invoiceee').hasClass('disevent'))
     {
      this.invoiceInvalid = true;
     }else
     {
      this.invoiceInvalid = false;
       }

       if ($('#referald').hasClass('disevent')) {
           this.howdidInvalid = true;
       } else {
           this.howdidInvalid = false;
       }

    //  if($('#disssn').hasClass('disevent') || this.ssnInvalid)
    //   {
    //    this.ssnInvalidmsg = true;
    //   }else
    //   {
    //    this.ssnInvalidmsg = false;
    //   }

     if (this.phone_num != undefined && this.phone_num != '') {
       var phoneeweb = document.getElementById('phoneeweb');
       if (phoneeweb != undefined && phoneeweb != null)
         phoneeweb.classList.remove('disevent');
     } else if (this.phone_num1 != undefined && this.phone_num1 != '') {
       var phoneeweb = document.getElementById('phoneeweb');
       if (phoneeweb != undefined && phoneeweb != null)
         phoneeweb.classList.remove('disevent');
     }

     if (
       this.language !== undefined &&
       this.language != null &&
       this.language !== ''
     ) {
       var langaaid = document.getElementById('langaaid');
       if (langaaid != undefined && langaaid != null) {
         langaaid.classList.remove('disevent');
         langaaid.classList.remove('customngselectpink');
       }
     }

     if (this.ssn != null && this.ssn !== undefined && this.ssn != '') {
       var disssn = document.getElementById('disssn');
       if (disssn != undefined && disssn != null)
        {
          disssn.classList.remove('disevent');
          
        }
     }

     if($('#disssn').hasClass('ssnEventClass') || $('#disssn').hasClass('ng-invalid') || $('#disssn').hasClass('disevent'))
     {
      if($('#disssn').val() == "")
      {

        this.ssnInvalidmsg = true;
      }else
      {
       this.ssnInvalidmsg = false;
      }
     }else
     {
      this.ssnInvalidmsg = false;
     }

     if (
       this.hearusOption != null &&
       this.hearusOption != undefined &&
       this.hearusOption != ''
     ) {
       var referald = document.getElementById('referald');
       if (referald != undefined && referald != null)
         referald.classList.remove('disevent');
       var referalcd = document.getElementById('referalcd');
       if (referalcd != undefined && referalcd != null)
         referalcd.classList.remove('customngselectpink');
     }

     if (
       this.invoice != null &&
       this.invoice != undefined &&
       this.invoice != ''
     ) {
       var invoiceee = document.getElementById('invoiceee');
       if (invoiceee != undefined && invoiceee != null) {
         invoiceee.classList.remove('disevent');
       }

       var fetyureInvoice = document.getElementById('fetyureInvoice');
       if (fetyureInvoice != undefined && fetyureInvoice != null)
         fetyureInvoice.classList.remove('customngselectpink');
     }
     if (
       this.email_address != null &&
       this.email_address != undefined &&
       this.email_address != ''
     ) {
       var emaileweb = document.getElementById('emaileweb');
       if (emaileweb != undefined && emaileweb != null)
         emaileweb.classList.remove('disevent');
     }

     const phone = document.getElementById('phone_mob');

     if (
       this.phone_num1 === undefined ||
       this.phone_num1 === null ||
       this.phone_num1 === '' 
       //|| this.phone_num1.length < 12
       
     ) {
       this.validContact = false;
       phone.classList.add('langColorpink');
     } else {

       if(this.phoneValidation())
       {
        phone.classList.add('langColorpink');
       }
       else
       {

          phone.classList.remove('langColorpink');
       }
     }

     const fName = document.getElementById('fName');

     if (
       this.first_name === undefined ||
       this.first_name === null ||
       this.first_name === ''
     ) {
       this.validContact = false;
       fName.classList.add('langColorpink');
     } else {
       fName.classList.remove('langColorpink');
     }

     const lName = document.getElementById('lName');

     if (
       this.last_name === undefined ||
       this.last_name === null ||
       this.last_name === ''
     ) {
       this.validContact = false;
       lName.classList.add('langColorpink');
     } else {
       lName.classList.remove('langColorpink');
     }
     if (
       this.accountoption === undefined ||
       this.accountoption === null ||
       this.accountoption === ''
     ) {
       //accountoption.classList.add('langColorpink');
     } else {
       //accountoption.classList.remove('langColor');
     }
     const email_mob = document.getElementById('email_mob');


     var isEmailValid1 = false;
     if(this.email_address != '' && this.email_address != null && this.email_address != undefined )
     {
       var validEmailRegEx =
       /^[A-Z0-9_'%=+!`#~$*?^{}&|-]+([\.][A-Z0-9_'%=+!`#~$*?^{}&|-]+)*@[A-Z0-9-]+(\.[A-Z0-9-]+)+$/i;
        isEmailValid1 = validEmailRegEx.test(this.email_address);
      
     }
  

     if (
       !isEmailValid1
     ) {
       email_mob.classList.add('langColorpink');
     } else {
       email_mob.classList.remove('langColorpink');
     }
     
     if (this.dob === undefined || this.dob === null || this.dob === '') {
       $("#enrollDate_mob_").addClass('mat-form-field-invalid')
     } else {
       $("#enrollDate_mob_").removeClass('mat-form-field-invalid')
     }

    if (window.innerWidth > 768)
    {
        if(!this.agreeBox)
          {
           $("#headerText").html("What is your contact information?");
          }
          else
          {
           $("#headerText").html("Agree to the disclosures, click 'Submit,' and you're done!<br /> This is the final step.");
          }
    }
     

     if (this.checkValidity && !this.agreeBox) {
       if (
         this.form['valid'] &&
         (!_.isEmpty(this.license) ||
           (!_.isEmpty(this.ssn) &&
             this.ssn.length > 10 &&
             this.ssnvalidation === false)) &&
         !_.isEmpty(this.state) &&
         this.language != undefined &&
         this.language != 'Language Preference' &&
          !_.isEmpty(this.invoice) && 
         (!_.isEmpty(this.hearusOption))
         //&& (((this.selectedProduct.energy_provider == 'Frontier Utilities' || this.selectedProduct.energy_provider == 'Gexa Energy') && this.goPaperlessGexa == true ) )
         && this.goPaperlessGexa == true 
        
       ) {

         if(this.displayInvoiceValueBoth())
         {
           if($("#phoneCheck").is(":checked"))
           {
             this.ngClass = true;
             this.ngClass1 = true;
             this.disableBtn = false;
            
            $('#buttondisclick').removeClass('clickable')
           }
           else
           {
             this.ngClass = false;
             this.ngClass1 = false;
             this.disableBtn = true;
           
           }
         }
         else
         {
          
           this.ngClass = true;
           this.ngClass1 = true;
           this.disableBtn = false;
          
          $('#buttondisclick').removeClass('clickable')

         }


       } else if (
         this.language == 'Language Preference' ||
         (this.phone_num1 != undefined && this.phone_num1.length < 12)
       ) {
         this.ngClass = false;
         this.disableBtn = true;
       }
      
        else if (
       
           this.invoice == '' ||
           this.invoice == undefined ||
           this.invoice == null 
         ) {

           if (window.innerWidth < 768) {
          
             this.ngClass = true;
             this.ngClass1 = true;
             this.disableBtn = false;
             this.validContact = true;
             //$('#buttondisclick').removeClass('clickable')
           }
           else
           {

           this.ngClass = false;
           this.disableBtn = true;
           }
          
         }
       else if ((this.selectedProduct.energy_provider == 'Frontier Utilities' || this.selectedProduct.energy_provider == 'Gexa Energy') 
         && this.goPaperlessGexa == false)
         {
           this.ngClass = false;
           this.disableBtn = true;
         }
      
       else if (
         this.language != undefined &&
         this.language != 'Language Preference' &&
         (this.last_name != undefined ||
           this.last_name != null ||
           this.last_name != '') &&
           (this.first_name != undefined ||
             this.first_name != null ||
             this.first_name != '')  &&
         this.dob != undefined &&
         this.accountoption != undefined &&
         (this.phone_num1 != '' || this.phone_num1.length < 12)
         && (this.email_address != '' && this.email_address != null && this.email_address != undefined && isEmailValid1
          )
          &&

         (!_.isEmpty(this.ssn) &&
         this.ssn.length > 10 &&
         this.ssnvalidation === false) &&
         (!_.isEmpty(this.hearusOption))
       ) {
         if (
           //this.accountoption != '' ||
           this.last_name != ''  &&
           this.last_name != undefined  &&
           this.last_name != null
           && 
           this.first_name != undefined &&
             this.first_name != null &&
             this.first_name != '' 
            
             
         ) {
          $('#buttondisclick').removeClass('clickable')
           this.disableBtn = false;
           this.validContact = true;
           this.ngClass = true;
           this.ngClass1 = true;
           
          
         } else {
           this.ngClass = false;
           this.ngClass1 = false;
           this.disableBtn = true;
           this.validContact = false;

           //this.validContact = false;
         }

        
        

       } 
      
       
      
       else if (this.agreeBox1 && this.agreeBox2 && this.agreeBox3) {

        if(this.deviceWidth < 786)
          {
            this.ngClass = true;
            this.ngClass1 = true;
            this.disableBtn = false;
          }
   
        // $('#buttondisclick').removeClass('clickable')
       } else {

         if(this.deviceWidth > 786)
         {
           this.ngClass = false;

         }

         if(this.deviceWidth < 786)
         {
           this.ngClass1 = false;
           this.disableBtn = true;
         }

       
       }
      } else if (
       this.agreeBox &&
       this.agreeBox1 &&
       this.agreeBox2 &&
       this.agreeBox3
     ) {

        if(this.deviceWidth < 786)
        {
          this.ngClass = true;
          this.ngClass1 = true;
          this.disableBtn = false;
        }
      
       //$('#buttondisclick').removeClass('clickable')
     } else {
       if(this.deviceWidth > 786)
         {
           this.ngClass = false;

         }
       // this.ngClass1 = false;
       this.disableBtn = true;
     }

     if (!_.isEmpty(JSON.parse(sessionStorage.getItem('userObj')))) {
       const contactInfo = JSON.parse(sessionStorage.getItem('userObj'));
       // this.first_name = contactInfo.fName ? contactInfo.fName : '';
       // this.last_name = contactInfo.lName ? contactInfo.lName : '';
       // this.email_address = this.email_address_temp
       //   ? this.email_address_temp
       //   : contactInfo.emailId
       //   ? contactInfo.emailId
       //   : '';
       // this.phone_num = contactInfo.phone ? contactInfo.phone : '';
       this.getSessionData = false;
     }
   }

  getState(event) {
    this.state = event;
  }

  onchangeState(event) {
    this.state = event;
    this.onChangeSaveAbondonedOrder(event)
  }

  // Phone number validation in entrollment:
  pNumberValidate(e) {
    const key = e.charCode || e.keyCode || 0;
    const text = e.target.value;
    if (
      (key >= 96 && key <= 105) ||
      key === 45 ||
      (key >= 48 && key <= 57) ||
      key === 189 ||
      key === 109 ||
      key === 46 ||
      key === 37 ||
      key === 39
    ) {
      if (text.length === 3) {
        this.phone_num = text + '-';
      }
      if (text.length === 7) {
        this.phone_num = text + '-';
      }
    } else if (key === 8 || key === 9) {
      return true;
    } else {
      return false;
    }
  }

  // ssn validation:
  ssnValidate(e) {
    if (e.target.value || e.target.value.length === 11) {
      if (
        e.target.value != 'XXX-XX-XXXX' &&
        e.target.value != 'XXX-XX-XXX' &&
        e.target.value != 'XXX-XX-XXXX-'
      ) {
        this.ssn123 = this.ssn12.concat(e.target.value);
      }
    }

    if (
      e.target.value.length > 10 &&
      e.target.value != 'XXX-XX-XXXX' &&
      e.target.value != 'XXX-XX-XXXX-'
    ) {
      var val = e.target.value.replace(/[^\d\*]/g, '').replace(/[0-9]/g, 'X');
    } else {
      if (e.target.value != 'XXX-XX-XXXX' && e.target.value != 'XXX-XX-XXXX-') {
        val = e.target.value.replace(/[^\d\*]/g, '');
      }
    }
    var newVal = '';
    var sizes = [3, 2, 4];
    var maxSize = 10;

    for (var i in sizes) {
      if (val != 'undefined' && val.length > sizes[i] && val.length < 10) {
        newVal += val.substr(0, sizes[i]) + '-';
        val = val.substr(sizes[i]);
      } else if (val.length > 10 || val.length === 10) {
        if (
          val === 'XXXXXXXXXXX' ||
          val === 'XXXXXXXXXX' ||
          val.includes('-') === false
        ) {
          this.ssnvalidation = true;
        } else {
          this.ssnvalidation = false;
        }
      } else {
        this.ssnvalidation = false;
        break;
      }
    }
    newVal += val;
    this.newVal = newVal;
    this.ssn = newVal;
    const key = e.charCode || e.keyCode || 0;
    const text = e.target.value;
    if (e.keyCode == 8) {
      if ('-' == text.charAt(text.length - 1)) {
        e = text.substring(0, text.length - 1);
      }
    }

    if (
      this.ssn.length > 10 &&
      this.ssn != null &&
      this.ssn != '' &&
      this.ssnvalidation === false
    ) {
      this.ngClass = true;
      this.disableBtn = false;
      //$('#buttondisclick').removeClass('clickable')
      if (
        this.language != undefined &&
        this.language != '' &&
        this.language != null &&
        this.dob != undefined &&
        this.dob != null
      ) {
        var disclick = document.getElementById('buttondisclick');
       // disclick.classList.remove('clickable');
      }
    } else {
      this.ngClass = false;
      this.disableBtn = true;
    }
  }

  validateSSNLength(event) {
    const ssnValue = event.target.value;
    this.ssnInvalid = true;
    if (ssnValue.length < 11) {
      this.ssnInvalid = false;
      this.ngClass = false;
      this.disableBtn = true;
    }else
    {
      $('#disssn').removeClass('ssnEventClass');
    }
  }

  validatemsg(event) {
    this.ssnmsg = false;
    const ssnValue = event.target.value;
    if(ssnValue == "")
    {
      this.ssnmsg = true
    }
  }

  enrollmentNext1(formValid) {
    if (
      formValid &&
      (!_.isEmpty(this.license) ||
        (!_.isEmpty(this.ssn) && this.ssn.length > 9)) &&
      !_.isEmpty(this.state) &&
      !_.isEmpty(this.language)
    ) {
      this.ngClass = true;
      this.disableBtn = false;
    } else {
      this.ngClass = false;
      this.disableBtn = true;
    }
  }

  checkboxEvnt(event, id) {
    if (id === 'acceptbtn1') {
      this.agreeBox1 = event.target.checked;
    } else if (id === 'acceptbtn2') {
      this.agreeBox2 = event.target.checked;
    } else if (id === 'acceptbtn3') {
      this.agreeBox3 = event.target.checked;
    } else if (id === 'acceptbtn4') {
      this.agreeBox4 = event.target.checked;
    }

    if (this.checkBoxValidation()) {
      this.ngClass = true;
      this.disableBtn = false;
    } else {
      this.ngClass = false;
      this.disableBtn = true;
    }
  }

  checkboxEvntenableSMS(event, id) {
    if (id === 'enablesmshonest') {
      if (event.target.checked === true) {
        this.enablesmshonest = true;
      } else if (event.target.checked === false) {
        this.enablesmshonest = false;
      }
    } else if (id === 'enablesmschariot') {
      if (event.target.checked === true) {
        this.enablesmschariot = true;
      } else {
        this.enablesmschariot = false;
      }
    }
    this.onChangeSaveAbondonedOrder(event);
  }

  checkboxGoPaperless(event, id) {
    this.goPaperlessGexa_error = false;
    
    if (id === 'goPaperlessGexa') {
      this.goPaperlessGexa = event.target.checked;

      if(!this.goPaperlessGexa)
      {
        this.goPaperlessGexa_error = true;
        
      }
      // if (event.target.checked === true) {
      //   this.goPaperlessGexa = true;
      // } else if (event.target.checked === false) {
      //   this.goPaperlessGexa = false;
      // }
    }
  }

  // to disable the button
  privateInfoChanged(event, formValid) {
    this.showMask = !this.showMask;
    if (
      !_.isEmpty(this.ssn) &&
      this.ssn.length > 9 &&
      this.ssnvalidation === false
    ) {
      this.ngClass = true;
      this.disableBtn = false;
      formValid = true;
    } else {
      this.ngClass = false;
      this.disableBtn = true;
    }

    if (
      formValid &&
      (!_.isEmpty(this.license) ||
        (!_.isEmpty(this.ssn) &&
          this.ssn.length > 9 &&
          this.ssnvalidation === false)) &&
      !_.isEmpty(this.state)
    ) {
      this.ngClass = true;
      this.disableBtn = false;
    } else {
      if (this.selectedProduct.energy_provider == 'Texans Energy') {
        this.ngClass = false;
        this.disableBtn = true;
      }
    }
    this.onChangeSaveAbondonedOrder(event);
  }

  //Mobile:EmailAddress Value Change Event
  confirmbtn1(event, formValid) {
    var validEmailRegEx =
      /^[A-Z0-9_'%=+!`#~$*?^{}&|-]+([\.][A-Z0-9_'%=+!`#~$*?^{}&|-]+)*@[A-Z0-9-]+(\.[A-Z0-9-]+)+$/i;
    var isEmailValid1 = validEmailRegEx.test(event.target.value);
    if (isEmailValid1 === false) {
      //alert('Please Enter Valid Email');
    }

    this.email_address_temp = event.target.value;

    if (this.email_address_temp === this.accountoption) {
      this.showSecPart = false;
    }
  }

  confirmbtn(event, formValid) {
    var validEmailRegEx =
      /^[A-Z0-9_'%=+!`#~$*?^{}&|-]+([\.][A-Z0-9_'%=+!`#~$*?^{}&|-]+)*@[A-Z0-9-]+(\.[A-Z0-9-]+)+$/i;
    var isEmailValid = validEmailRegEx.test(event.target.value);
    if (isEmailValid === false) {
      alert('Please Enter Valid Email');
    }

    this.email_address_temp = this.email_address_temp
      ? this.email_address_temp
      : this.email_address;
    this.accountoption = event.target.value;

    if (this.email_address_temp === this.accountoption) {
      this.showSecPart = false;
      const accountoption = document.getElementById('conf_email_mob');
      accountoption.classList.remove('langColorpink');
    } else if (this.email_address_temp != this.accountoption) {
      alert('Email address mismatch');
      const accountoption = document.getElementById('conf_email_mob');
      accountoption.classList.add('langColorpink');
    }
  }

  onBlockClick() {
    this.clickedOnce = true;
    this.firstnameChange = true;
    this.lastnameChange = true;
    this.emailChange = true;
    this.phoneChange = true;
    //if ($('#theButton:disabled').length > 0) {
    

      if (this.dob === undefined) {
        // var dateid = document.getElementById('enrollDate');
        // dateid.classList.add('disevent');
        //$('#enrollDate').parents('mat-form-field').addClass('disevent')
        $('#enrollDateField_').addClass('mat-form-field-invalid')
       
      }

      if (
        
        (this.phone_num === undefined || this.phone_num.length === 0  || this.phone_num === ""  )
      ) {
        // var phoneeweb = document.getElementById('phoneeweb');
        // phoneeweb.classList.add('disevent');

        //$('#phoneeweb').find('input').addClass('disevent')

      }
      if (
        this.language === undefined ||
        this.language === '' ||
        this.language === null
      ) {
        var langaaid = document.getElementById('langaaid');
        langaaid.classList.add('disevent');

        langaaid.classList.add('customngselectpink');
      }

      if (
        this.accountoption === null ||
        this.accountoption === undefined ||
        this.accountoption === ''
      ) {
        var primaryaccount = document.getElementById('primaryaccount');
        primaryaccount.classList.add('disevent');
        primaryaccount.classList.add('customngselectpink');
      }

      if (this.ssn === null || this.ssn.length <= 10 || this.ssn === '') {
        var disssn = document.getElementById('disssn');
        disssn.classList.add('ssnEventClass');
      }else
      {
        //var disssn = document.getElementById('disssn');
        $('#disssn').removeClass('ssnEventClass');
      }

      if (
        this.hearusOption === null ||
        this.hearusOption === undefined ||
        this.hearusOption === ''
      ) {
        var referald = document.getElementById('referald');
        referald.classList.add('disevent');
        var referalcd = document.getElementById('referalcd');
        referalcd.classList.add('customngselectpink');
      }

      if (
        this.invoice === null ||
        this.invoice === undefined ||
        this.invoice === ''
      ) {
        var invoiceee = document.getElementById('invoiceee');
        invoiceee.classList.add('disevent');

        var fetyureInvoice = document.getElementById('fetyureInvoice');
        fetyureInvoice.classList.add('customngselectpink');
      }
      if (
        this.email_address === null ||
        this.email_address === undefined ||
        this.email_address === ''
      ) {
        // var emaileweb = document.getElementById('emaileweb');
        // emaileweb.classList.add('disevent');

        //$('#emaileweb').find('input').addClass('disevent')
      }

    //} else {
     // var disclick = document.getElementById('buttondisclick');
      //disclick.classList.remove('clickable');
   // }
  }

  // SelectLanguage for mobile
  selectLangMbl(lang, langId) {
    this.language = lang;
    var ddd = parseInt(localStorage.getItem('deviceWidth'));
    if (window.innerWidth < 768) {
      this.setLanguageClassListPerDeviceWidth();
      this.validateMobileFields();
      const languagePreference = document.getElementById('languagePreference');
      if (this.language !== '' || this.language !== undefined)
        languagePreference.classList.remove('validateClass');
    }
  }

  setLanguageClassListPerDeviceWidth() {
    const invoice1 = document.getElementById('englishId');
    const invoice2 = document.getElementById('spanishId');
    if (this.language === 'English') {
      if (invoice2 !== null) {
        invoice2.classList.remove('langColorgrey');
      }
      if (invoice1 !== null) {
        invoice1.classList.add('langColorpink1');
        invoice2.classList.remove('langColorpink1');
      }
      var id = document.getElementById('ppid');
    } else if (this.language === 'Spanish') {
      if (invoice1 !== null) {
        invoice1.classList.remove('langColorgrey');
      }
      if (invoice2 !== null) {
        invoice2.classList.add('langColorpink1');
        invoice1.classList.remove('langColorpink1');
      }
    }
  }

  selectaccountMbl(option, langId) {
    this.accountoption = option;
    var ddd = parseInt(localStorage.getItem('deviceWidth'));

    if (window.innerWidth < 768) {
      const invoice11 = document.getElementById('yesId');
      const invoice21 = document.getElementById('noId');
      if (this.accountoption === 'Yes') {
        if (invoice21 !== null) {
          invoice21.classList.remove('langColorgrey');
        }
        if (invoice11 !== null) {
          invoice11.classList.add('langColorpink1');
          invoice21.classList.remove('langColorpink1');
        }
        var id = document.getElementById('ppid');
      } else if (this.accountoption === 'No') {
        if (invoice11 !== null) {
          invoice11.classList.remove('langColorgrey');
        }
        if (invoice21 !== null) {
          invoice21.classList.add('langColorpink1');
          invoice11.classList.remove('langColorpink1');
        }
      }
      this.validateMobileFields();
      const accountHolder = document.getElementById('accountHolder');
      if (this.accountoption !== '' || this.accountoption !== undefined)
        accountHolder.classList.remove('validateClass');
    }
  }

  // To Format the date
  getDate() {
    if (this.dob) {
      this.dob = new Date(
        this.dob.date.year,
        this.dob.date.month - 1,
        this.dob.date.day
      );
    }
  }

  // To calculate the age of the user
  getAge(dateString) {
    const today = new Date();
    const birthDate = new Date(dateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }
  valueChanged() {
    console.log(this.dob);
    this.onChangeSaveAbondonedOrder(event);
  }
  // Date of birth valiadate
  dateOfBirth(e) {
    this.dob = this.dob;
    const key = e.charCode || e.keyCode || 0;
    if (key === 9) {
      return true;
    } else {
      return false;
    }
  }

  openModalWithClass(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-lg' },this.ngbModalOptions)
    );
  }

  getReferrals(event) {
    this.hearusOption = event;
    this.sec2Disable = true;
    this.howdidButton = true;
    this.onChangeSaveAbondonedOrder(event);
  }

  focusInputField()
  {
    this.howdidButton = false;
  }
  close()
  {
    this.howdidButton = true;
  }


  getlanguages(event) {
    this.language = event;
    this.sec2Disable = true;
  }

  getInvoice(event) {
    this.invoice = event;
    var ddd = parseInt(localStorage.getItem('deviceWidth'));
    if (window.innerWidth < 768) {
      const invoice1 = document.getElementById('paper');
      const invoice2 = document.getElementById('paperless');
      const invoice3 = document.getElementById('both');
      if (this.invoice === 'Paper') {
        if (invoice2 !== null && invoice2.classList.contains('langColor')) {
          invoice2.classList.remove('langColor');
        }
        if (invoice3 !== null && invoice3.classList.contains('langColor')) {
          invoice3.classList.remove('langColor');
        }
        if (invoice1 !== null) {
          invoice1.classList.add('langColor');
        }
        var id = document.getElementById('ppid');
        this.triggerScrollTo(id);
      } else if (this.invoice === 'Paperless') {
        if (invoice1 !== null && invoice1.classList.contains('langColor')) {
          invoice1.classList.remove('langColor');
        }
        if (invoice3 !== null && invoice3.classList.contains('langColor')) {
          invoice3.classList.remove('langColor');
        }
        if (invoice2 !== null) {
          invoice2.classList.add('langColor');
        }
        var id = document.getElementById('ppid');
        this.triggerScrollTo(id);
      } else if (this.invoice === 'Both') {
        if (invoice1 !== null && invoice1.classList.contains('langColor')) {
          invoice1.classList.remove('langColor');
        }
        if (invoice2 !== null && invoice2.classList.contains('langColor')) {
          invoice2.classList.remove('langColor');
        }
        if (invoice3 !== null) {
          invoice3.classList.add('langColor');
        }
        var id = document.getElementById('ppid');
       this.triggerScrollTo(id);
      }
    }
    this.onChangeSaveAbondonedOrder(event);
  }

  changeAccountOption(event) {
    this.accountOptionMessage = '';
    if (event === 'Yes') {
      this.accountOptionFlag = true;
    } else {
      if (this.represnt === undefined || this.represnt === '') {
        this.formValid = false;
      }
    }
    this.onChangeSaveAbondonedOrder(event);
  }

  validateMobileFields() {
    const buttonClass = document.getElementById('theButton');
    
    var isEmailValid1 = false;
    if(this.email_address != '' && this.email_address != null && this.email_address != undefined )
    {
      var validEmailRegEx =
      /^[A-Z0-9_'%=+!`#~$*?^{}&|-]+([\.][A-Z0-9_'%=+!`#~$*?^{}&|-]+)*@[A-Z0-9-]+(\.[A-Z0-9-]+)+$/i;
       isEmailValid1 = validEmailRegEx.test(this.email_address );
      
    }

    if (
      this.accountoption !== '' &&
      this.phone_num1 !== undefined &&
      this.phone_num1.length >= 12 &&
      this.language !== '' &&
      this.dob !== undefined &&
      (this.last_name != undefined ||
        this.last_name != null ||
        this.last_name != '') &&
        (this.first_name != undefined ||
          this.first_name != null ||
          this.first_name != '')  &&
          (this.email_address != '' && this.email_address != null && this.email_address != undefined  ) && isEmailValid1
    ) {
      buttonClass.classList.add('sectbtn');
      buttonClass.classList.remove('disabledButton'); 

      try{

        const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;
        if(this.phone_num1 !== "" && this.phone_num1 !== undefined && !phoneRegex.test(this.phone_num1))
        {
          this.MobilephoneNoError = true;
          buttonClass.classList.remove('sectbtn');
          buttonClass.classList.add('disabledButton');
          return true;

        }
    
      }catch{
  
      }
     

      return false;
    } else {
      buttonClass.classList.remove('sectbtn');
      buttonClass.classList.add('disabledButton');    
      return true;
    }
  }

  phoneValidation()
  {
    this.MobilephoneNoError = false;
    try{

      const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;
      if(this.phone_num1 !== "" && this.phone_num1 !== undefined && !phoneRegex.test(this.phone_num1))
      {
          this.MobilephoneNoError = true;
      }
  
    }catch{

    }
   
      return this.MobilephoneNoError;
  }

  customerEnrollmentHotlineLink() {
    return this.selectedProduct.energy_provider === '4Change Energy'
      ? 'tel:(888) 367-6061'
      : `tel:${this.selectedProduct.providerContact}`;
  }

  customerEnrollmentHotline() {
    return this.providerContact.ProviderName === '4Change Energy'
      ? '(888) 367-6061'
      : this.selectedProduct.providerContact;
  }

  checkBoxValidation() {
    if (this.selectedProduct.energy_provider === '4Change Energy') {
      this.agreeBox1 = true;
      return this.agreeBox2 && this.agreeBox3 && this.agreeBox4;
    } else {
      return this.agreeBox1 && this.agreeBox2 && this.agreeBox3;
    }
  }

  displayInvoiceValueBoth() {
    return this.selectedProduct.energy_provider === 'Gexa Energy' ||
      this.selectedProduct.energy_provider === 'Frontier Utilities'
      ? true
      : false;
  }

  displayErrorText() {
    return this.errorText !== '' ? this.errorText : '';
  }

  postObjDetails() {
    let serviceTypeDateDetails = this.getServiceTypeValues();
    this.residentialService.completeCustomerEnrollmentPostObject =
      this.orderDetails;
    const postObjDetails = JSON.parse(
      sessionStorage.getItem('chariotPostObject')
    );

    const userId = JSON.parse(sessionStorage.getItem('userObj'));
    const orderDetails = {
      order_no: null,
      hg_accountId: userId._id,
      ConfirmationNumber: this.orderDetails.referenumber,
      status: this.orderDetails.webStatus,
      isDepositRequired: this.assignConfirmationStatus(
        this.orderDetails.webStatus
      ),
      webStatus: this.orderDetails.webStatus,
      reason: this.orderDetails.webStatus,
      creditCheckResults: this.assignConfirmationStatus(
        this.orderDetails.webStatus
      ),
      customerId: this.orderDetails.referenumber,
      enableSMSForHonest: this.enablesmshonest === false ? 'No' : 'Yes',
      enableSMSForChariot: this.enablesmschariot === true ? 'Yes' : 'No',
      ratePlanName: this.selectedProduct.product_key,
      serviceTypeDetails: serviceTypeDateDetails,
      contactInfo: {
        legalFirstName: postObjDetails.FirstName,
        legalLastName: postObjDetails.LastName,
        emailId: postObjDetails.EmailAddress,
        phoneNo: postObjDetails.PhoneNumber,
        language: postObjDetails.languagePreference,
        dob: postObjDetails.DOB,
        authorizedRep: postObjDetails.AuthorizedUserName,
      },
      esiid: postObjDetails.ESIID,
      invoiceType: postObjDetails.BillDeliverMethodID,
      promoDetails: {
        hearusOption: postObjDetails.Howdidyouhear,
        promoeCode: this.promo_code,
      },
      privateDetails: {
        state: postObjDetails.BillingState,
        license: postObjDetails.DriversLicence,
      },
      billingAddress: JSON.parse(sessionStorage.getItem('billingAddress')),
      isExpired: false,
      ReceivedPromocode: this.residentialService.promoCode,
      UsedPromocode:
        this.residentialService.promoCode === 'TAP' ? 'TAP' : 'GORILLA',
      selectedProduct: this.selectedProduct,
      expirationDate: this.serviceTypeExpireDate(
        serviceTypeDateDetails.switchDate
      ),
      Affiliate: sessionStorage.getItem('_Affiliate') == undefined || sessionStorage.getItem('_Affiliate') == '' || sessionStorage.getItem('_Affiliate') == null? "" : sessionStorage.getItem('_Affiliate'),
      AffiliatePromo: sessionStorage.getItem('_Promo') == undefined || sessionStorage.getItem('_Promo') == '' || sessionStorage.getItem('_Promo') == null? "" : sessionStorage.getItem('_Promo'),
      AffiliateID: sessionStorage.getItem('_AffiliateID') == undefined || sessionStorage.getItem('_AffiliateID') == '' || sessionStorage.getItem('_AffiliateID') == null? "" : sessionStorage.getItem('_AffiliateID'),
      QuestionId: sessionStorage.getItem('QuestionUserID') == undefined || sessionStorage.getItem('QuestionUserID') == '' || sessionStorage.getItem('QuestionUserID') == null? "" : sessionStorage.getItem('QuestionUserID')
    };
    return orderDetails;
  }

    postBKVObjDetails() {
      
        let serviceTypeDateDetails = this.getServiceTypeValues();
        this.residentialService.completeCustomerEnrollmentPostObject =
            this.orderDetails;
        const postObjDetails = JSON.parse(
            sessionStorage.getItem('BKVPostObject')
        );

        const userId = JSON.parse(sessionStorage.getItem('userObj'));
        const orderDetails = {
            order_no: null,
            hg_accountId: userId._id,
            ConfirmationNumber: this.orderDetails.referenumber,
            status: this.orderDetails.webStatus,
            isDepositRequired: this.assignConfirmationStatus(
                this.orderDetails.webStatus
            ),
            webStatus: this.orderDetails.webStatus,
            reason: this.orderDetails.webStatus,
            creditCheckResults: this.assignConfirmationStatus(
                this.orderDetails.webStatus
            ),
            customerId: this.orderDetails.referenumber,
            enableSMSForHonest: this.enablesmshonest === false ? 'No' : 'Yes',
            enableSMSForChariot: this.enablesmschariot === true ? 'Yes' : 'No',
            ratePlanName: this.selectedProduct.product_key,
            serviceTypeDetails: serviceTypeDateDetails,
            contactInfo: {
                legalFirstName: postObjDetails.FirstName,
                legalLastName: postObjDetails.LastName,
                emailId: postObjDetails.EmailAddress,
                phoneNo: postObjDetails.PhoneNumber,
                language: postObjDetails.languagePreference,
                dob: postObjDetails.DOB,
                authorizedRep: postObjDetails.AuthorizedUserName,
            },
            esiid: postObjDetails.ESIID,
            invoiceType: postObjDetails.BillDeliverMethodID,
            promoDetails: {
                hearusOption: postObjDetails.Howdidyouhear,
                promoeCode: this.promo_code,
            },
            privateDetails: {
                state: postObjDetails.BillingState,
                license: postObjDetails.DriversLicence,
            },
            billingAddress: JSON.parse(sessionStorage.getItem('billingAddress')),
            isExpired: false,
            ReceivedPromocode: this.residentialService.promoCode,
            UsedPromocode:
                this.residentialService.promoCode === 'TAP' ? 'TAP' : 'GORILLA',
            selectedProduct: this.selectedProduct,
            expirationDate: this.serviceTypeExpireDate(
                serviceTypeDateDetails.switchDate
            ),
            Affiliate: sessionStorage.getItem('_Affiliate') == undefined || sessionStorage.getItem('_Affiliate') == '' || sessionStorage.getItem('_Affiliate') == null ? "" : sessionStorage.getItem('_Affiliate'),
            AffiliatePromo: sessionStorage.getItem('_Promo') == undefined || sessionStorage.getItem('_Promo') == '' || sessionStorage.getItem('_Promo') == null ? "" : sessionStorage.getItem('_Promo'),
            AffiliateID: sessionStorage.getItem('_AffiliateID') == undefined || sessionStorage.getItem('_AffiliateID') == '' || sessionStorage.getItem('_AffiliateID') == null? "" : sessionStorage.getItem('_AffiliateID'),
            QuestionId: sessionStorage.getItem('QuestionUserID') == undefined || sessionStorage.getItem('QuestionUserID') == '' || sessionStorage.getItem('QuestionUserID') == null? "" : sessionStorage.getItem('QuestionUserID')
        };
        return orderDetails;
    }


  assignOrderDetailsForRhythm(isrequiredDeposit) {
    let mainPhone = this.getPrimaryPhoneNumber(),
      isGetOrderRes = false,
      isNotificationRes = false;
    let serviceTypeDateDetails = this.getServiceTypeValues();
    this.selectedProduct.energy_provider_image =
      this.providerContact.ProviderCloudLogo;
    const orderDetails = {
      order_no: null,
      hg_accountId: this.hgAccountId,
      ConfirmationNumber:
        this.orderDetails.referenumber,
      status:
      isrequiredDeposit == false ? 'COMPLETED' : 'Pending Deposit',
      isDepositRequired:  isrequiredDeposit == false ? '' : 'Pending Deposit',
      webStatus:
      isrequiredDeposit == false ? this.orderDetails.webStatus : 'Pending Deposit'
      ,
      reason:
      this.orderDetails.reason,
      creditCheckResults: '',
      customerId:
        '',
      enableSMSForHonest: this.enablesmshonest === false ? 'No' : 'Yes',
      enableSMSForChariot: this.enablesmschariot === true ? 'Yes' : 'No',
      ratePlanName: this.selectedProduct.product_key,
      serviceTypeDetails: serviceTypeDateDetails,
      contactInfo: {
        legalFirstName: this.first_name,
        legalLastName: this.last_name,
        emailId: this.email_address,
        phoneNo: mainPhone[0] + mainPhone[1] + mainPhone[2],
        language: this.language,
        dob: this.dob,
        authorizedRep: this.represnt,
      },
      esiid: this.residentialService.esiid,
      invoiceType: this.invoice,
      promoDetails: {
        hearusOption: this.hearusOption,
        promoeCode: this.promo_code,
      },
      privateDetails: {
        state: this.state,
        license: this.license,
      },
      billingAddress: JSON.parse(sessionStorage.getItem('billingAddress')),
      isExpired: false,
      ReceivedPromocode: this.residentialService.promoCode,
      UsedPromocode:
        this.residentialService.promoCode === 'TAP' ? 'TAP' : 'GORILLA',
      selectedProduct: this.selectedProduct,
      expirationDate: this.serviceTypeExpireDate(
        serviceTypeDateDetails.switchDate
      ),
      Affiliate: sessionStorage.getItem('_Affiliate') == undefined || sessionStorage.getItem('_Affiliate') == '' || sessionStorage.getItem('_Affiliate') == null? "" : sessionStorage.getItem('_Affiliate'),
      AffiliatePromo: sessionStorage.getItem('_Promo') == undefined || sessionStorage.getItem('_Promo') == '' || sessionStorage.getItem('_Promo') == null? "" : sessionStorage.getItem('_Promo'),
      AffiliateID: sessionStorage.getItem('_AffiliateID') == undefined || sessionStorage.getItem('_AffiliateID') == '' || sessionStorage.getItem('_AffiliateID') == null? "" : sessionStorage.getItem('_AffiliateID'),
      QuestionId: sessionStorage.getItem('QuestionUserID') == undefined || sessionStorage.getItem('QuestionUserID') == '' || sessionStorage.getItem('QuestionUserID') == null? "" : sessionStorage.getItem('QuestionUserID'),
      RejectedMessage :  this.orderDetails['RejectedMessage']
    };
    this.recommendationService.enrollmentOrderDetails = orderDetails;

    return orderDetails;
  }

DOB_Click(fieldName)
{
  const fieldName_ = document.getElementById(fieldName);
  fieldName_ .dispatchEvent(new Event("click"));

}
redirectto3rdStep(msg)
{
  console.log(msg)

  if(this.validateCustomermoveto3rdstep(msg))
  {


    if(this.invoice == "Email and Mail")
    {
      this.invoice = "Both";
    }else
    {
      this.invoice = this.ChariotReversinvoiceDetails[this.invoice];
    }
  

  this.closeModal();
  this.onCloseHandled();
  if(msg != null && msg  != undefined && msg.indexOf('Address is already') > -1 || msg.indexOf("Address is not available") > -1 )
  {
    this.shownext('showInvoice', this.hearusOption);

    const serviceTab = document.getElementById('service');
    const serviceTabHeading = document.getElementById('service_click');

    // this.recommendationService.messageService({
    //   agreeBox: this.showInvoice,
    // });

    //   serviceTab.classList.remove('active');
    //   serviceTab.classList.remove('nav-link');
    //   serviceTabHeading.classList.remove('active');
    //   const confirmTabValue = document.getElementById('confirm_click');
    //   confirmTabValue.classList.add('active');
    //   confirmTabValue.classList.add('nav-link');
    //   const confirmElementObj = document.getElementById('confirm');
    //   confirmElementObj.classList.remove('fade');
    //   confirmElementObj.classList.add('active');
    //   this.getOrderDetails('confirm_address');
    
    this.editnavigt('confirm');

  }else
  {

    this.shownext('showSec1', this.hearusOption);
  }
  this.agreeBox = false;
  this.checkValidity = true;
          this.ngClass = true;
          this.disableBtn = false;

  }
    // this.router.navigate([
    //   'recommendation/compare-product',
    //   this.recommendationService.hg_accountId,
    // ]);
}
getOrderDetails(event) {
  if (event !== 'confirm_address') {
    this.orderDetails = true;
  } else {
    this.orderDetails = false;
  }

}

validateCustomermoveto3rdstep(msg){
  var valid = false;
  var errors = ["email","emailaddress", "dob", "date of birth", "ssn" , "phone number", "address is already","address is not available", "service address",
   "social security", "electricity service","billdelivermethod","billdelivermethodid","servicestartdate","service start date","credit check was unsuccessful","servicetype" , "paperlessconsent","requestedstartdate"];
  if(msg != null)
  {
  if((errors.includes(msg.toLowerCase())) ){

    valid = true;
  }else{

    
    errors.forEach(e => {
      

      if(msg.toLowerCase().indexOf(e) > -1)
      {
        valid = true;
      }

    });


  }
  }
  return valid;
}

TrackFunction(Status)
{
  
  var product = this.selectedProduct
  var value = sessionStorage.getItem('esiidValue')
  var subString = value != null ? value.substring(value.length - 5) : "";

  CallTrack_function(
    "EnrollmentSubmit",
    product.energy_provider, 
    product.product_key, 
    product.terms, 
    (product.tier[0].avg_charge * 100).toFixed(1),
    (product.tier[1].avg_charge * 100).toFixed(1),
    (product.tier[2].avg_charge * 100).toFixed(1),
    subString,  
    product.utility_name, 
    Status,$("[name='email']").val() );

}

formatDate(inputDate: string | undefined): string | null {
  if (!inputDate) {
    return null; // Return null if inputDate is not set or is empty
  }

  const parts = inputDate.split('/');
  if (parts.length === 3) {
    const formattedDate = `${parts[2]}-${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}`;
    return formattedDate;
  } else {
    return null; // Return null for invalid date format
  }
}

SaveAbondonedOrder(isFailed?, reason = '')
{
  
  let serviceTypeDateDetails = this.getServiceTypeValues();
  const userId = JSON.parse(sessionStorage.getItem('userObj'));

  const orderDetails = {
    id :sessionStorage.getItem('_abandonedid') == undefined || sessionStorage.getItem('_abandonedid') == '' || sessionStorage.getItem('_abandonedid') == null ? 0 : sessionStorage.getItem('_abandonedid'),
    order_no: null,
    hg_accountId: userId._id,
    ConfirmationNumber: '',
    status: isFailed ? 'Failed Enrollment' : 'Abondoned Enrollment',
    isDepositRequired: '',
    webStatus: '',
    reason: reason,
    creditCheckResults: '',
    customerId: '',
    enableSMSForHonest: this.enablesmshonest === false ? 'No' : 'Yes',
    enableSMSForChariot: this.enablesmschariot === true ? 'Yes' : 'No',
    ratePlanName: this.selectedProduct.product_key,
    serviceTypeDetails: serviceTypeDateDetails,
    contactInfo: {
      legalFirstName: this.first_name,
      legalLastName: this.last_name,
      emailId: this.email_address,
      phoneNo: this.phone_num1,
      language: this.language,
      dob: this.dob,
      authorizedRep: this.represnt,
    },
    esiid: this.residentialService.esiid,
    invoiceType: this.invoice,
    promoDetails: {
      hearusOption: this.hearusOption,
      promoeCode: this.promo_code,
    },
    privateDetails: {
      state: this.state,
      license: this.license,
    },
    billingAddress: JSON.parse(sessionStorage.getItem('billingAddress')),
    isExpired: false,
    ReceivedPromocode: this.residentialService.promoCode,
    UsedPromocode:
      this.residentialService.promoCode === 'TAP' ? 'TAP' : 'GORILLA',
    selectedProduct: this.selectedProduct,
    expirationDate: this.serviceTypeExpireDate(
      serviceTypeDateDetails.switchDate
    ),
    Affiliate: sessionStorage.getItem('_Affiliate') == undefined || sessionStorage.getItem('_Affiliate') == '' || sessionStorage.getItem('_Affiliate') == null? "" : sessionStorage.getItem('_Affiliate'),
    AffiliatePromo: sessionStorage.getItem('_Promo') == undefined || sessionStorage.getItem('_Promo') == '' || sessionStorage.getItem('_Promo') == null? "" : sessionStorage.getItem('_Promo'),
    AffiliateID: sessionStorage.getItem('_AffiliateID') == undefined || sessionStorage.getItem('_AffiliateID') == '' || sessionStorage.getItem('_AffiliateID') == null? "" : sessionStorage.getItem('_AffiliateID'),
    QuestionId: sessionStorage.getItem('QuestionUserID') == undefined || sessionStorage.getItem('QuestionUserID') == '' || sessionStorage.getItem('QuestionUserID') == null? "" : sessionStorage.getItem('QuestionUserID')
  };

  const postObjDetails = orderDetails;
  this.orderDetails = {
    ...this.orderDetails,
    ...postObjDetails,
  };

  const body = new HttpParams().append(
    'orderDetails',
    JSON.stringify(this.orderDetails)
  );
  this.http
    .post(this.url + '/saveabandonedorders', body)
    .subscribe((res: any) => {
      sessionStorage.setItem('_abandonedid', res)
  });

}

ClearAbandonedId()
{
  sessionStorage.removeItem('_abandonedid');
}

}
